/* eslint-disable */
// @ts-nocheck
// 이 파일은 자동 생성되었습니다. 직접 수정하지 마세요.
import { useQueryClient } from "@tanstack/react-query";import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  AdminAccessControllerEnd200,
  AdminAccessControllerIssueToken201,
  AdminAccessControllerListSessions200,
  AdminAccessControllerListSessionsParams,
  AdminAccessControllerSearchTargets200,
  AdminAccessControllerSearchTargetsParams,
  AdminAccessControllerStart201,
  AdoptCoachingDocumentAiReviewDtoModel,
  AuthControllerGetCurrentUser200,
  AuthControllerLogin200,
  AuthControllerRefreshToken200,
  AuthControllerRequestAccountUnlockCode200,
  AuthControllerResetPassword200,
  AuthControllerSetInitialPasswordForHr200,
  AuthControllerUnlockAccount200,
  AuthControllerVerifyAccountUnlockCode200,
  AuthControllerVerifyPasswordSetupCode200,
  AuthControllerVerifyPasswordSetupCodeParams,
  BulkRequestLeaderContextDocumentDtoModel,
  CaseControllerCreateBulkCase201,
  CaseControllerCreateCase201,
  CaseControllerGetCase200,
  CaseControllerSearchCases200,
  CaseControllerSearchCasesParams,
  CaseControllerUpdateCase200,
  CaseCycleControllerCancelSlot200,
  CaseCycleControllerContactCoach200,
  CaseCycleControllerGetCoachingNotesFromCycle200,
  CaseCycleControllerGetCycle200,
  CaseCycleControllerGetCycleCoach200,
  CaseCycleControllerGetCycleCoachSlots200,
  CaseCycleControllerGetCycleCoachSlotsParams,
  CaseCycleControllerGetCycles200,
  CaseCycleControllerReserveSlot200,
  CaseFeedbackControllerCheckByCoachingNoteId200,
  CaseFeedbackControllerCheckByCoachingReportId200,
  CaseFeedbackControllerCheckSessionFeedbackExists200,
  CaseFeedbackControllerGetCaseFeedbacks200,
  CaseFeedbackControllerGetCaseFeedbacksParams,
  CaseFeedbackControllerSavePartialCaseFeedback200,
  CaseFeedbackControllerSubmitCaseFeedback200,
  CaseFeedbackRequestDtoModel,
  CaseProfileControllerGetTerms200,
  CaseProfileControllerUpdateTerms200,
  CaseReportControllerGetCycleReports200,
  CaseSurveyControllerGetCycleSurveys200,
  CaseSurveyControllerGetPeerFeedbackSurveys200,
  CaseSurveyControllerSubmitOnboardingSurvey200,
  CaseSurveyControllerSubmitWaymarkSurvey200,
  CatchUpReportDataRequestDtoModel,
  CmAlignmentCallAssessmentControllerCompleteCall200,
  CmAlignmentCallAssessmentControllerGetPendingTargets200,
  CmAlignmentCallControllerGetAlignmentCall200,
  CmAlignmentCallControllerSaveAlignmentCall200,
  CmCaseControllerUpdateCaseDetailNotionUrl200,
  CmCaseInfoRequestControllerCreateHrAccount201,
  CmCaseInfoRequestControllerGetHrAccounts200,
  CmCaseInfoRequestControllerSendCaseInfoRequest201,
  CmCoachControllerCreateCoach200,
  CmCoachControllerGetActiveCoaches200,
  CmCoachControllerGetCoachCategories200,
  CmCoachControllerGetCoachOpenSlots200,
  CmCoachControllerGetCoachOpenSlotsParams,
  CmCoachControllerGetCoaches200,
  CmCoachControllerUpdateCoach200,
  CmCoachControllerUploadCoachPhoto201,
  CmCoachControllerUploadCoachPhotoBody,
  CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams,
  CmCoachingDocumentControllerCompleteCoachingPlan200,
  CmCoachingDocumentControllerCompleteCoachingReport200,
  CmCoachingDocumentControllerGetCoachingReport200,
  CmCoachingDocumentControllerSaveSlideData200,
  CmCoachingDocumentControllerUndoCoachingPlanCompletion200,
  CmCoachingDocumentControllerUndoCoachingReportCompletion200,
  CmCoachingDocumentControllerUndoPeerFeedbackReportCompletion200,
  CmCompanyControllerCreateFavoriteCompany201,
  CmCompanyControllerDeleteFavoriteCompany200,
  CmCompanyControllerFindAllWithFavorite200,
  CmCompanyControllerGetCompanyStatusDashboard200,
  CmControllerGetCoachingManagers200,
  CmCycleControllerAdoptCoachingPlanAiReview201,
  CmCycleControllerAdoptCoachingReportAiReview201,
  CmCycleControllerApproveCoachingPlan200,
  CmCycleControllerApproveCoachingReport200,
  CmCycleControllerCompleteCycle200,
  CmCycleControllerCreateCoachingPlanFeedback201,
  CmCycleControllerCreateCoachingReportFeedback201,
  CmCycleControllerDeleteCoachingPlanFeedback200,
  CmCycleControllerDeleteCoachingReportFeedback200,
  CmCycleControllerDeliverCoachingPlanFeedback200,
  CmCycleControllerDeliverCoachingReportFeedback200,
  CmCycleControllerFindAllCyclesByCaseId200,
  CmCycleControllerFindAllSessionsByCycleId200,
  CmCycleControllerFindAllSessionsByCycleIdParams,
  CmCycleControllerFindCoachingPlanByCycleId200,
  CmCycleControllerFindCoachingReportByCycleId200,
  CmCycleControllerFindOne200,
  CmCycleControllerGetCoachAssignmentMemo200,
  CmCycleControllerGetCoachingManagerDashboard200,
  CmCycleControllerGetCoachingManagerDashboardParams,
  CmCycleControllerGetCoachingPlanAiReview200,
  CmCycleControllerGetCoachingReportAiReview200,
  CmCycleControllerGetCycles200,
  CmCycleControllerGetCyclesParams,
  CmCycleControllerGetDownloadCallRequest200,
  CmCycleControllerHoldCycle200,
  CmCycleControllerListCoachingPlanFeedbacks200,
  CmCycleControllerListCoachingReportFeedbacks200,
  CmCycleControllerReleaseCycleHold200,
  CmCycleControllerRequestCoachingPlanAiReview201,
  CmCycleControllerRequestCoachingReportAiReview201,
  CmCycleControllerUpdateCoachingPlanFeedback200,
  CmCycleControllerUpdateCoachingReportFeedback200,
  CmCycleControllerUpdateCycleMemo200,
  CmCycleControllerUpdateDownloadCallRequest200,
  CmDataExportControllerIsAuthorized200,
  CmDocsControllerSendToHr200,
  CmEmailControllerGetEmailPreview200,
  CmEmailControllerGetEmailPreviewParams,
  CmEmailControllerSendOnboardingEmail200,
  CmEmailControllerSendOnboardingReminderEmail200,
  CmEmailControllerSendPeerFeedbackEmail200,
  CmEmailControllerSendPeerFeedbackReminderEmail200,
  CmEmailControllerSendSessionReminder200,
  CmInsightsControllerGetCoachDashboard200,
  CmInsightsControllerGetCoachDashboardParams,
  CmInsightsControllerGetCompanyDashboard200,
  CmInsightsControllerGetCompanyDashboardParams,
  CmInsightsControllerGetDashboard200,
  CmInsightsControllerGetDashboardParams,
  CmLeaderContextDocumentBulkControllerBulkRequest200,
  CmLeaderContextDocumentControllerGetDocument200,
  CmLeaderContextDocumentControllerRequestDocument201,
  CmMatchingControllerCreateMatchings201,
  CmMatchingControllerDeleteCoachAssignment200,
  CmMatchingControllerSendMatchingNotification200,
  CmSurveyControllerCreatePeerFeedbackReport200,
  CmSurveyControllerCreatePeerFeedbackSurvey200,
  CmSurveyControllerCreatePeerFeedbackSurveys200,
  CmSurveyControllerDeletePeerFeedbackSurvey200,
  CmSurveyControllerFindAllPeerFeedbackSurveysByCycleId200,
  CmSurveyControllerFindOneLeadershipSelfSurvey200,
  CmSurveyControllerFindOneOnboardingSurvey200,
  CmSurveyControllerFindOnePostLeadershipSelfSurvey200,
  CmSurveyControllerFindOnePostWaymarkSurvey200,
  CmSurveyControllerFindOneWaymarkSurvey200,
  CmSurveyControllerGetPeerFeedbackReport200,
  CmSurveyControllerMarkAsCompletedPeerFeedbackReport200,
  CmSurveyControllerRequestPeerFeedbackReportAiAnalysis200,
  CmSurveyControllerSendToCasePeerFeedbackReport200,
  CmSurveyControllerUpdatePeerFeedbackReport200,
  CmSurveyControllerUpdatePeerFeedbackSurvey200,
  CoachCapacityControllerGetCoachCapacity200,
  CoachCapacityControllerUpdateCoachCapacity200,
  CoachCompanyControllerCreateFavoriteCompany201,
  CoachCompanyControllerDeleteFavoriteCompany200,
  CoachCompanyControllerFindAllWithFavorite200,
  CoachCycleControllerFindOne200,
  CoachCycleControllerGetCaseNotificationAvailability200,
  CoachCycleControllerGetCoachAssignmentMemo200,
  CoachCycleControllerGetCycles200,
  CoachCycleControllerGetCyclesByCaseId200,
  CoachCycleControllerGetCyclesDashboard200,
  CoachCycleControllerGetCyclesDashboardParams,
  CoachCycleControllerGetDownloadCallRequest200,
  CoachCycleControllerNotifyCase200,
  CoachCycleControllerRequestDownloadCall201,
  CoachCycleControllerUpdateCycleMemo200,
  CoachInsightsControllerGetMyDashboard200,
  CoachInsightsControllerGetMyDashboardParams,
  CoachSessionControllerCompleteSession200,
  CoachSessionControllerMarkAsNoShow200,
  CoachSessionControllerSendLateEntryReminder200,
  CoachSlotControllerCancelSlot200,
  CoachSlotControllerCloseSlot200,
  CoachSlotControllerGetSlots200,
  CoachSlotControllerGetSlotsParams,
  CoachSlotControllerOpenSlot200,
  CoachSlotControllerReserveSlot200,
  CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleId200,
  CoachSurveyControllerFindOneLeadershipSelfSurvey200,
  CoachSurveyControllerFindOneOnboardingSurvey200,
  CoachSurveyControllerFindOnePostLeadershipSelfSurvey200,
  CoachSurveyControllerFindOnePostWaymarkSurvey200,
  CoachSurveyControllerFindOneWaymarkSurvey200,
  CoachSurveyControllerGetPeerFeedbackReport200,
  CoachingDocumentControllerGetCoachingNote200,
  CoachingDocumentControllerGetCoachingPlan200,
  CoachingDocumentControllerGetCoachingReport200,
  CoachingDocumentControllerGetLeadershipSummaryReport200,
  CoachingDocumentControllerGetMissionSummaryReport200,
  CoachingDocumentControllerGetOccupationalHealthReport200,
  CoachingDocumentControllerGetOnboardingSurvey200,
  CoachingDocumentControllerGetPeerFeedbackReport200,
  CoachingNoteControllerCreateCoachingNote200,
  CoachingNoteControllerFindAllCoachingNotesFromCycle200,
  CoachingNoteControllerGetTranscriptState200,
  CoachingNoteControllerLoadCoachingNoteAiDraft200,
  CoachingNoteControllerSendToCase200,
  CoachingNoteControllerUpdateCoachingNote200,
  CoachingPlanControllerGetCoachingPlanAiDraft200,
  CoachingPlanControllerListFeedbacks200,
  CoachingPlanControllerResolveFeedback200,
  CoachingPlanControllerUpdateCoachingPlan200,
  CoachingPlanUpdateDtoModel,
  CoachingReportControllerGenerateSlideDataWithAi200,
  CoachingReportControllerGetCoachingReport200,
  CoachingReportControllerListFeedbacks200,
  CoachingReportControllerResolveFeedback200,
  CoachingReportControllerUpdateCoachingReport200,
  CoachingReportUpdateDtoModel,
  CompanyControllerCreateCompany201,
  CompanyControllerGetCasesByCompanyId200,
  CompanyControllerGetCasesByCompanyIdParams,
  CompanyControllerGetCompanies200,
  CompanyControllerGetCompanyById200,
  CompanyControllerUpdateCompany200,
  CompleteCycleDtoModel,
  ConsentRecordingRequestDtoModel,
  ConsoleDataDashboardControllerDeleteCompanyFile200,
  ConsoleDataDashboardControllerDeleteCompanyFileParams,
  ConsoleDataDashboardControllerDeleteCycleFile200,
  ConsoleDataDashboardControllerDeleteCycleFileParams,
  ConsoleDataDashboardControllerDownloadAllCasesZipParams,
  ConsoleDataDashboardControllerDownloadCompanyFileParams,
  ConsoleDataDashboardControllerDownloadCycleFileParams,
  ConsoleDataDashboardControllerGenerateOrgReport200,
  ConsoleDataDashboardControllerGenerateOrgReportBody,
  ConsoleDataDashboardControllerGenerateOrganizationalDiagnosis200,
  ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody,
  ConsoleDataDashboardControllerGetCompanyCycles200,
  ConsoleDataDashboardControllerGetCompanyCyclesParams,
  ConsoleDataDashboardControllerGetDashboard200,
  ConsoleDataDashboardControllerGetDashboardLegacy200,
  ConsoleDataDashboardControllerGetDashboardParams,
  ConsoleDataDashboardControllerGetOrgReports200,
  ConsoleDataDashboardControllerGetOrgReportsParams,
  ConsoleDataDashboardControllerUploadCompanyFile200,
  ConsoleDataDashboardControllerUploadCompanyFileBody,
  ConsoleDataDashboardControllerUploadCycleFile200,
  ConsoleDataDashboardControllerUploadCycleFileBody,
  ContactCoachRequestDtoModel,
  CreateBulkSimpleCaseDtoModel,
  CreateCaseDtoModel,
  CreateCoachDtoModel,
  CreateCoachingNoteDtoModel,
  CreateCoachingPlanFeedbackDtoModel,
  CreateCoachingReportFeedbackDtoModel,
  CreateCompanyDtoModel,
  CreateCycleDtoModel,
  CreateDownloadCallRequestDtoModel,
  CreateHrAccountRequestDtoModel,
  CreateMatchingsDtoModel,
  CreateMySupportInquiryRequestDtoModel,
  CreatePeerFeedbackReportDtoModel,
  CreatePeerFeedbackSurveyBulkDtoModel,
  CreatePeerFeedbackSurveyDtoModel,
  CreateSupportInquiryRequestDtoModel,
  CreateWorkshopDtoModel,
  CycleCoachMatchingDetailResponseDtoModel,
  CycleCoachMatchingPublicViewResponseDtoModel,
  CycleControllerCreateCycle201,
  CycleControllerSearchWaymarkSurveys200,
  CycleControllerUpdateCycle200,
  CycleFormulationForCoachResponseDtoModel,
  GenerateCatchUpReportRequestDtoModel,
  HoldCycleDtoModel,
  HrCaseRegistrationControllerGetMyRequest200,
  HrCaseRegistrationControllerRegisterDraftCase201,
  HrCaseRegistrationControllerSearchReviewers200,
  HrCaseRegistrationControllerSearchReviewersParams,
  HrCaseRegistrationControllerUpdateDraftCase200,
  HrCoachCandidateShareDataRequestDtoModel,
  HrCoachMatchingSharePreviewResponseDtoModel,
  HrControllerGetHrs200,
  HrControllerGetHrsParams,
  HrCycleControllerGetActiveCycles200,
  HrCycleControllerGetActiveCyclesParams,
  HrCycleControllerGetCompleteCycles200,
  HrCycleControllerGetCompleteCyclesParams,
  LcdContentResponseDtoModel,
  LeaderContextDocumentControllerGetForm200,
  LeaderContextDocumentControllerSubmit201,
  LoginRequestDtoModel,
  NotificationScheduleControllerDeleteCompanyOverride200,
  NotificationScheduleControllerListByCompany200,
  NotificationScheduleControllerListGlobal200,
  NotificationScheduleControllerUpsertCompanyOverride200,
  NotificationScheduleControllerUpsertGlobal200,
  NotificationTemplateControllerDeleteCompanyOverride200,
  NotificationTemplateControllerListByCompany200,
  NotificationTemplateControllerListGlobal200,
  NotificationTemplateControllerListTypes200,
  NotificationTemplateControllerPreview200,
  NotificationTemplateControllerSendTestEmail200,
  NotificationTemplateControllerUpsertCompanyOverride200,
  NotificationTemplateControllerUpsertGlobal200,
  NotificationTemplatePreviewDtoModel,
  PartialCaseFeedbackRequestDtoModel,
  PatchHrCoachMatchingShareContentRequestDtoModel,
  RefreshTokenDtoModel,
  RegisterDraftCaseRequestDtoModel,
  RequestAccountUnlockCodeDtoModel,
  RequestLeaderContextDocumentDtoModel,
  ReserveSlotDtoModel,
  ResetPasswordDtoModel,
  ResetPasswordFromLinkRequestDtoModel,
  SaveAlignmentCallDtoModel,
  SaveLcdContentRequestDtoModel,
  SearchWaymarkSurveysDtoModel,
  SendCaseInfoRequestRequestDtoModel,
  SendEmailRequestDtoModel,
  SendMatchingNotificationDtoModel,
  SendPasswordResetEmailDtoModel,
  SendTestEmailDtoModel,
  SendToHrDtoModel,
  SetCandidateSelectionRequestDtoModel,
  SetCaseReviewersRequestDtoModel,
  SettlementControllerGetCoaches200,
  SettlementControllerGetCoachingSessions200,
  SettlementControllerGetCoachingSessionsParams,
  SetupInitialPasswordDtoModel,
  StartAdminAccessRequestDtoModel,
  SubmitLeaderContextDocumentDtoModel,
  SubmitSurveyRequestDtoModel,
  UnlockAccountDtoModel,
  UpdateCaseDetailNotionUrlDtoModel,
  UpdateCaseDtoModel,
  UpdateCaseTermsDtoModel,
  UpdateCoachCapacityDtoModel,
  UpdateCoachDtoModel,
  UpdateCoachingDocumentFeedbackDtoModel,
  UpdateCoachingNoteDtoModel,
  UpdateCompanyDtoModel,
  UpdateCycleDtoModel,
  UpdateCycleMemoDtoModel,
  UpdateDownloadCallRequestDtoModel,
  UpdateDraftCaseRequestDtoModel,
  UpdatePeerFeedbackReportDtoModel,
  UpdatePeerFeedbackSurveyDtoModel,
  UpdateWorkshopDtoModel,
  UpsertNotificationScheduleDtoModel,
  UpsertNotificationTemplateDtoModel,
  VerifyAccountUnlockCodeDtoModel,
  VerifyPasswordResetCodeDtoModel,
  WorkshopControllerCreateWorkshop201,
  WorkshopControllerDeleteWorkshop200,
  WorkshopControllerGetWorkshopsByCompanyId200,
  WorkshopControllerUpdateWorkshop200
} from './models'
import { apiClient } from '../client/axios-client';



/**
 * 비밀번호를 5회 연속으로 틀리면 계정이 잠긴다. 잠긴 동안에는 errorCode ACCOUNT_LOCKED 를 돌려준다.
 * @summary Login with email and password
 */
export const authControllerLogin = (
    loginRequestDtoModel: LoginRequestDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerLogin200>(
      {url: `/v2/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequestDtoModel
    },
      );
    }
  


export const getAuthControllerLoginMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogin>>, {data: LoginRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogin>>>
    export type AuthControllerLoginMutationBody = LoginRequestDtoModel
    export type AuthControllerLoginMutationError = void

    /**
 * @summary Login with email and password
 */
export const useAuthControllerLogin = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerLogin>>,
        TError,
        {data: LoginRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerLoginMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Get current user information
 */
export const authControllerGetCurrentUser = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<AuthControllerGetCurrentUser200>(
      {url: `/v2/auth/me`, method: 'GET', signal
    },
      );
    }
  

export const getAuthControllerGetCurrentUserQueryKey = () => {
    return [`/v2/auth/me`] as const;
    }

    
export const getAuthControllerGetCurrentUserInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof authControllerGetCurrentUser>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetCurrentUser>>> = ({ signal }) => authControllerGetCurrentUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetCurrentUserInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetCurrentUser>>>
export type AuthControllerGetCurrentUserInfiniteQueryError = unknown

/**
 * @summary Get current user information
 */
export const useAuthControllerGetCurrentUserInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof authControllerGetCurrentUser>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAuthControllerGetCurrentUserInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAuthControllerGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerGetCurrentUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerGetCurrentUser>>> = ({ signal }) => authControllerGetCurrentUser(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerGetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerGetCurrentUser>>>
export type AuthControllerGetCurrentUserQueryError = unknown

/**
 * @summary Get current user information
 */
export const useAuthControllerGetCurrentUser = <TData = Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerGetCurrentUser>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAuthControllerGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Refresh Firebase ID token
 */
export const authControllerRefreshToken = (
    refreshTokenDtoModel: RefreshTokenDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerRefreshToken200>(
      {url: `/v2/auth/refresh-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshTokenDtoModel
    },
      );
    }
  


export const getAuthControllerRefreshTokenMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,{data: RefreshTokenDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,{data: RefreshTokenDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefreshToken>>, {data: RefreshTokenDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRefreshToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRefreshTokenMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefreshToken>>>
    export type AuthControllerRefreshTokenMutationBody = RefreshTokenDtoModel
    export type AuthControllerRefreshTokenMutationError = void

    /**
 * @summary Refresh Firebase ID token
 */
export const useAuthControllerRefreshToken = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError,{data: RefreshTokenDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRefreshToken>>,
        TError,
        {data: RefreshTokenDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerRefreshTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 변경 주기가 지나 차단된 상태에서도 호출할 수 있다. 기존 토큰에는 변경 전 기준 시각이 박혀 있어 새 토큰을 함께 내려준다.
 * @summary Reset password
 */
export const authControllerResetPassword = (
    resetPasswordDtoModel: ResetPasswordDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerResetPassword200>(
      {url: `/v2/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordDtoModel
    },
      );
    }
  


export const getAuthControllerResetPasswordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPassword>>, TError,{data: ResetPasswordDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPassword>>, TError,{data: ResetPasswordDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerResetPassword>>, {data: ResetPasswordDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerResetPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerResetPassword>>>
    export type AuthControllerResetPasswordMutationBody = ResetPasswordDtoModel
    export type AuthControllerResetPasswordMutationError = void

    /**
 * @summary Reset password
 */
export const useAuthControllerResetPassword = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPassword>>, TError,{data: ResetPasswordDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerResetPassword>>,
        TError,
        {data: ResetPasswordDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Set initial password for a new user
 */
export const authControllerSetInitialPassword = (
    setupInitialPasswordDtoModel: SetupInitialPasswordDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/auth/setup-initial-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setupInitialPasswordDtoModel
    },
      );
    }
  


export const getAuthControllerSetInitialPasswordMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPassword>>, TError,{data: SetupInitialPasswordDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPassword>>, TError,{data: SetupInitialPasswordDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSetInitialPassword>>, {data: SetupInitialPasswordDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerSetInitialPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSetInitialPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSetInitialPassword>>>
    export type AuthControllerSetInitialPasswordMutationBody = SetupInitialPasswordDtoModel
    export type AuthControllerSetInitialPasswordMutationError = void

    /**
 * @summary Set initial password for a new user
 */
export const useAuthControllerSetInitialPassword = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPassword>>, TError,{data: SetupInitialPasswordDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSetInitialPassword>>,
        TError,
        {data: SetupInitialPasswordDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerSetInitialPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Verify if a password setup code is valid and return user info
 */
export const authControllerVerifyPasswordSetupCode = (
    params: AuthControllerVerifyPasswordSetupCodeParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AuthControllerVerifyPasswordSetupCode200>(
      {url: `/v2/auth/verify-initial-password-setup-code`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAuthControllerVerifyPasswordSetupCodeQueryKey = (params: AuthControllerVerifyPasswordSetupCodeParams,) => {
    return [`/v2/auth/verify-initial-password-setup-code`, ...(params ? [params]: [])] as const;
    }

    
export const getAuthControllerVerifyPasswordSetupCodeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, AuthControllerVerifyPasswordSetupCodeParams['page']>, TError = void>(params: AuthControllerVerifyPasswordSetupCodeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData, Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, QueryKey, AuthControllerVerifyPasswordSetupCodeParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerVerifyPasswordSetupCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, QueryKey, AuthControllerVerifyPasswordSetupCodeParams['page']> = ({ signal, pageParam }) => authControllerVerifyPasswordSetupCode({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData, Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, QueryKey, AuthControllerVerifyPasswordSetupCodeParams['page']> & { queryKey: QueryKey }
}

export type AuthControllerVerifyPasswordSetupCodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>>
export type AuthControllerVerifyPasswordSetupCodeInfiniteQueryError = void

/**
 * @summary Verify if a password setup code is valid and return user info
 */
export const useAuthControllerVerifyPasswordSetupCodeInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, AuthControllerVerifyPasswordSetupCodeParams['page']>, TError = void>(
 params: AuthControllerVerifyPasswordSetupCodeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData, Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, QueryKey, AuthControllerVerifyPasswordSetupCodeParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAuthControllerVerifyPasswordSetupCodeInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAuthControllerVerifyPasswordSetupCodeQueryOptions = <TData = Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError = void>(params: AuthControllerVerifyPasswordSetupCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerVerifyPasswordSetupCodeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>> = ({ signal }) => authControllerVerifyPasswordSetupCode(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthControllerVerifyPasswordSetupCodeQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>>
export type AuthControllerVerifyPasswordSetupCodeQueryError = void

/**
 * @summary Verify if a password setup code is valid and return user info
 */
export const useAuthControllerVerifyPasswordSetupCode = <TData = Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError = void>(
 params: AuthControllerVerifyPasswordSetupCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordSetupCode>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAuthControllerVerifyPasswordSetupCodeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send password reset email
 */
export const authControllerSendPasswordResetEmail = (
    sendPasswordResetEmailDtoModel: SendPasswordResetEmailDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/auth/send-password-reset-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendPasswordResetEmailDtoModel
    },
      );
    }
  


export const getAuthControllerSendPasswordResetEmailMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>, TError,{data: SendPasswordResetEmailDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>, TError,{data: SendPasswordResetEmailDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>, {data: SendPasswordResetEmailDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerSendPasswordResetEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSendPasswordResetEmailMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>>
    export type AuthControllerSendPasswordResetEmailMutationBody = SendPasswordResetEmailDtoModel
    export type AuthControllerSendPasswordResetEmailMutationError = void

    /**
 * @summary Send password reset email
 */
export const useAuthControllerSendPasswordResetEmail = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>, TError,{data: SendPasswordResetEmailDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSendPasswordResetEmail>>,
        TError,
        {data: SendPasswordResetEmailDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerSendPasswordResetEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reset password from link
 */
export const authControllerVerifyPasswordResetCode = (
    verifyPasswordResetCodeDtoModel: VerifyPasswordResetCodeDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/auth/verify-password-reset-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyPasswordResetCodeDtoModel
    },
      );
    }
  


export const getAuthControllerVerifyPasswordResetCodeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>, TError,{data: VerifyPasswordResetCodeDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>, TError,{data: VerifyPasswordResetCodeDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>, {data: VerifyPasswordResetCodeDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerVerifyPasswordResetCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerVerifyPasswordResetCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>>
    export type AuthControllerVerifyPasswordResetCodeMutationBody = VerifyPasswordResetCodeDtoModel
    export type AuthControllerVerifyPasswordResetCodeMutationError = void

    /**
 * @summary Reset password from link
 */
export const useAuthControllerVerifyPasswordResetCode = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>, TError,{data: VerifyPasswordResetCodeDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerVerifyPasswordResetCode>>,
        TError,
        {data: VerifyPasswordResetCodeDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerVerifyPasswordResetCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary Reset password from link
 */
export const authControllerResetPasswordFromLink = (
    resetPasswordFromLinkRequestDtoModel: ResetPasswordFromLinkRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/auth/reset-password-from-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordFromLinkRequestDtoModel
    },
      );
    }
  


export const getAuthControllerResetPasswordFromLinkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>, TError,{data: ResetPasswordFromLinkRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>, TError,{data: ResetPasswordFromLinkRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>, {data: ResetPasswordFromLinkRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerResetPasswordFromLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerResetPasswordFromLinkMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>>
    export type AuthControllerResetPasswordFromLinkMutationBody = ResetPasswordFromLinkRequestDtoModel
    export type AuthControllerResetPasswordFromLinkMutationError = void

    /**
 * @summary Reset password from link
 */
export const useAuthControllerResetPasswordFromLink = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>, TError,{data: ResetPasswordFromLinkRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerResetPasswordFromLink>>,
        TError,
        {data: ResetPasswordFromLinkRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerResetPasswordFromLinkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전사 및 AI 요약 동의 처리
 */
export const authControllerConsentRecording = (
    consentRecordingRequestDtoModel: ConsentRecordingRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/auth/consent/recording`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: consentRecordingRequestDtoModel
    },
      );
    }
  


export const getAuthControllerConsentRecordingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConsentRecording>>, TError,{data: ConsentRecordingRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerConsentRecording>>, TError,{data: ConsentRecordingRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerConsentRecording>>, {data: ConsentRecordingRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerConsentRecording(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerConsentRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerConsentRecording>>>
    export type AuthControllerConsentRecordingMutationBody = ConsentRecordingRequestDtoModel
    export type AuthControllerConsentRecordingMutationError = unknown

    /**
 * @summary 전사 및 AI 요약 동의 처리
 */
export const useAuthControllerConsentRecording = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerConsentRecording>>, TError,{data: ConsentRecordingRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerConsentRecording>>,
        TError,
        {data: ConsentRecordingRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerConsentRecordingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * HR은 비밀번호 설정 후 재로그인 없이 대시보드로 진입해야 하므로 토큰을 함께 반환한다.
 * @summary HR 비밀번호 설정 + 자동 로그인
 */
export const authControllerSetInitialPasswordForHr = (
    setupInitialPasswordDtoModel: SetupInitialPasswordDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerSetInitialPasswordForHr200>(
      {url: `/v2/auth/hr/initial-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setupInitialPasswordDtoModel
    },
      );
    }
  


export const getAuthControllerSetInitialPasswordForHrMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>, TError,{data: SetupInitialPasswordDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>, TError,{data: SetupInitialPasswordDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>, {data: SetupInitialPasswordDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerSetInitialPasswordForHr(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSetInitialPasswordForHrMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>>
    export type AuthControllerSetInitialPasswordForHrMutationBody = SetupInitialPasswordDtoModel
    export type AuthControllerSetInitialPasswordForHrMutationError = unknown

    /**
 * @summary HR 비밀번호 설정 + 자동 로그인
 */
export const useAuthControllerSetInitialPasswordForHr = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>, TError,{data: SetupInitialPasswordDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSetInitialPasswordForHr>>,
        TError,
        {data: SetupInitialPasswordDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerSetInitialPasswordForHrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 계정이 없거나 잠기지 않았어도 성공으로 응답한다. 결과를 구분하면 이메일 가입 여부를 알려주는 꼴이 된다.
 * @summary 계정 잠금 해제 인증번호 재발송
 */
export const authControllerRequestAccountUnlockCode = (
    requestAccountUnlockCodeDtoModel: RequestAccountUnlockCodeDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerRequestAccountUnlockCode200>(
      {url: `/v2/auth/unlock/code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestAccountUnlockCodeDtoModel
    },
      );
    }
  


export const getAuthControllerRequestAccountUnlockCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>, TError,{data: RequestAccountUnlockCodeDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>, TError,{data: RequestAccountUnlockCodeDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>, {data: RequestAccountUnlockCodeDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRequestAccountUnlockCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRequestAccountUnlockCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>>
    export type AuthControllerRequestAccountUnlockCodeMutationBody = RequestAccountUnlockCodeDtoModel
    export type AuthControllerRequestAccountUnlockCodeMutationError = unknown

    /**
 * @summary 계정 잠금 해제 인증번호 재발송
 */
export const useAuthControllerRequestAccountUnlockCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>, TError,{data: RequestAccountUnlockCodeDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRequestAccountUnlockCode>>,
        TError,
        {data: RequestAccountUnlockCodeDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerRequestAccountUnlockCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 계정 잠금 해제 인증번호 확인
 */
export const authControllerVerifyAccountUnlockCode = (
    verifyAccountUnlockCodeDtoModel: VerifyAccountUnlockCodeDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerVerifyAccountUnlockCode200>(
      {url: `/v2/auth/unlock/verify-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyAccountUnlockCodeDtoModel
    },
      );
    }
  


export const getAuthControllerVerifyAccountUnlockCodeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>, TError,{data: VerifyAccountUnlockCodeDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>, TError,{data: VerifyAccountUnlockCodeDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>, {data: VerifyAccountUnlockCodeDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerVerifyAccountUnlockCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerVerifyAccountUnlockCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>>
    export type AuthControllerVerifyAccountUnlockCodeMutationBody = VerifyAccountUnlockCodeDtoModel
    export type AuthControllerVerifyAccountUnlockCodeMutationError = void

    /**
 * @summary 계정 잠금 해제 인증번호 확인
 */
export const useAuthControllerVerifyAccountUnlockCode = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>, TError,{data: VerifyAccountUnlockCodeDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerVerifyAccountUnlockCode>>,
        TError,
        {data: VerifyAccountUnlockCodeDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerVerifyAccountUnlockCodeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 비밀번호를 새로 설정해야 잠금이 풀린다. 새 비밀번호는 생성규칙 검증을 그대로 거친다.
 * @summary 인증번호로 잠금 해제 + 비밀번호 재설정
 */
export const authControllerUnlockAccount = (
    unlockAccountDtoModel: UnlockAccountDtoModel,
 ) => {
      
      
      return apiClient<AuthControllerUnlockAccount200>(
      {url: `/v2/auth/unlock/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: unlockAccountDtoModel
    },
      );
    }
  


export const getAuthControllerUnlockAccountMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerUnlockAccount>>, TError,{data: UnlockAccountDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerUnlockAccount>>, TError,{data: UnlockAccountDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerUnlockAccount>>, {data: UnlockAccountDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  authControllerUnlockAccount(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerUnlockAccountMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerUnlockAccount>>>
    export type AuthControllerUnlockAccountMutationBody = UnlockAccountDtoModel
    export type AuthControllerUnlockAccountMutationError = void

    /**
 * @summary 인증번호로 잠금 해제 + 비밀번호 재설정
 */
export const useAuthControllerUnlockAccount = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerUnlockAccount>>, TError,{data: UnlockAccountDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof authControllerUnlockAccount>>,
        TError,
        {data: UnlockAccountDtoModel},
        TContext
      > => {

      const mutationOptions = getAuthControllerUnlockAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 대리 접속 대상 계정 검색 (내부 CPM)
 */
export const adminAccessControllerSearchTargets = (
    params: AdminAccessControllerSearchTargetsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AdminAccessControllerSearchTargets200>(
      {url: `/v2/admin-access/users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminAccessControllerSearchTargetsQueryKey = (params: AdminAccessControllerSearchTargetsParams,) => {
    return [`/v2/admin-access/users`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminAccessControllerSearchTargetsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, AdminAccessControllerSearchTargetsParams['page']>, TError = unknown>(params: AdminAccessControllerSearchTargetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, QueryKey, AdminAccessControllerSearchTargetsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccessControllerSearchTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, QueryKey, AdminAccessControllerSearchTargetsParams['page']> = ({ signal, pageParam }) => adminAccessControllerSearchTargets({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, QueryKey, AdminAccessControllerSearchTargetsParams['page']> & { queryKey: QueryKey }
}

export type AdminAccessControllerSearchTargetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>>
export type AdminAccessControllerSearchTargetsInfiniteQueryError = unknown

/**
 * @summary 대리 접속 대상 계정 검색 (내부 CPM)
 */
export const useAdminAccessControllerSearchTargetsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, AdminAccessControllerSearchTargetsParams['page']>, TError = unknown>(
 params: AdminAccessControllerSearchTargetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, QueryKey, AdminAccessControllerSearchTargetsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminAccessControllerSearchTargetsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminAccessControllerSearchTargetsQueryOptions = <TData = Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError = unknown>(params: AdminAccessControllerSearchTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccessControllerSearchTargetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>> = ({ signal }) => adminAccessControllerSearchTargets(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminAccessControllerSearchTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>>
export type AdminAccessControllerSearchTargetsQueryError = unknown

/**
 * @summary 대리 접속 대상 계정 검색 (내부 CPM)
 */
export const useAdminAccessControllerSearchTargets = <TData = Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError = unknown>(
 params: AdminAccessControllerSearchTargetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerSearchTargets>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminAccessControllerSearchTargetsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 세션만 만들고 토큰은 내주지 않는다. 새 탭이 세션 ID 로 POST admin-access-sessions/:id/token 을 불러 받는다. 진행 중인 자기 세션은 먼저 닫는다.
 * @summary 대리 접속 시작 (내부 CPM)
 */
export const adminAccessControllerStart = (
    startAdminAccessRequestDtoModel: StartAdminAccessRequestDtoModel,
 ) => {
      
      
      return apiClient<AdminAccessControllerStart201>(
      {url: `/v2/admin-access-sessions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startAdminAccessRequestDtoModel
    },
      );
    }
  


export const getAdminAccessControllerStartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerStart>>, TError,{data: StartAdminAccessRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerStart>>, TError,{data: StartAdminAccessRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccessControllerStart>>, {data: StartAdminAccessRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  adminAccessControllerStart(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAccessControllerStartMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerStart>>>
    export type AdminAccessControllerStartMutationBody = StartAdminAccessRequestDtoModel
    export type AdminAccessControllerStartMutationError = unknown

    /**
 * @summary 대리 접속 시작 (내부 CPM)
 */
export const useAdminAccessControllerStart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerStart>>, TError,{data: StartAdminAccessRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAccessControllerStart>>,
        TError,
        {data: StartAdminAccessRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getAdminAccessControllerStartMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 대리 접속 기록 (월간 점검, 내부 CPM)
 */
export const adminAccessControllerListSessions = (
    params: AdminAccessControllerListSessionsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AdminAccessControllerListSessions200>(
      {url: `/v2/admin-access-sessions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminAccessControllerListSessionsQueryKey = (params: AdminAccessControllerListSessionsParams,) => {
    return [`/v2/admin-access-sessions`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminAccessControllerListSessionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, AdminAccessControllerListSessionsParams['page']>, TError = unknown>(params: AdminAccessControllerListSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerListSessions>>, QueryKey, AdminAccessControllerListSessionsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccessControllerListSessionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, QueryKey, AdminAccessControllerListSessionsParams['page']> = ({ signal, pageParam }) => adminAccessControllerListSessions({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerListSessions>>, QueryKey, AdminAccessControllerListSessionsParams['page']> & { queryKey: QueryKey }
}

export type AdminAccessControllerListSessionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerListSessions>>>
export type AdminAccessControllerListSessionsInfiniteQueryError = unknown

/**
 * @summary 대리 접속 기록 (월간 점검, 내부 CPM)
 */
export const useAdminAccessControllerListSessionsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, AdminAccessControllerListSessionsParams['page']>, TError = unknown>(
 params: AdminAccessControllerListSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData, Awaited<ReturnType<typeof adminAccessControllerListSessions>>, QueryKey, AdminAccessControllerListSessionsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminAccessControllerListSessionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminAccessControllerListSessionsQueryOptions = <TData = Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError = unknown>(params: AdminAccessControllerListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAccessControllerListSessionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAccessControllerListSessions>>> = ({ signal }) => adminAccessControllerListSessions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type AdminAccessControllerListSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerListSessions>>>
export type AdminAccessControllerListSessionsQueryError = unknown

/**
 * @summary 대리 접속 기록 (월간 점검, 내부 CPM)
 */
export const useAdminAccessControllerListSessions = <TData = Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError = unknown>(
 params: AdminAccessControllerListSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAccessControllerListSessions>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAdminAccessControllerListSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 세션을 만든 뒤 60초 안에 한 번만 받을 수 있다.
 * @summary 대리 접속 토큰 받기 (세션을 만든 본인)
 */
export const adminAccessControllerIssueToken = (
    sessionId: string,
 ) => {
      
      
      return apiClient<AdminAccessControllerIssueToken201>(
      {url: `/v2/admin-access-sessions/${sessionId}/token`, method: 'POST'
    },
      );
    }
  


export const getAdminAccessControllerIssueTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerIssueToken>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerIssueToken>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccessControllerIssueToken>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  adminAccessControllerIssueToken(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAccessControllerIssueTokenMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerIssueToken>>>
    
    export type AdminAccessControllerIssueTokenMutationError = unknown

    /**
 * @summary 대리 접속 토큰 받기 (세션을 만든 본인)
 */
export const useAdminAccessControllerIssueToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerIssueToken>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAccessControllerIssueToken>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getAdminAccessControllerIssueTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 대리 접속 탭(그 세션 토큰) 또는 세션을 만든 CPM 이 부른다. 기록은 지우지 않고 종료 시각만 남긴다.
 * @summary 대리 접속 종료
 */
export const adminAccessControllerEnd = (
    sessionId: string,
 ) => {
      
      
      return apiClient<AdminAccessControllerEnd200>(
      {url: `/v2/admin-access-sessions/${sessionId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminAccessControllerEndMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerEnd>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerEnd>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAccessControllerEnd>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  adminAccessControllerEnd(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminAccessControllerEndMutationResult = NonNullable<Awaited<ReturnType<typeof adminAccessControllerEnd>>>
    
    export type AdminAccessControllerEndMutationError = unknown

    /**
 * @summary 대리 접속 종료
 */
export const useAdminAccessControllerEnd = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAccessControllerEnd>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof adminAccessControllerEnd>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getAdminAccessControllerEndMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 역할: COACHING_MANAGER
 * @summary 고객사 등록
 */
export const companyControllerCreateCompany = (
    createCompanyDtoModel: CreateCompanyDtoModel,
 ) => {
      
      
      return apiClient<CompanyControllerCreateCompany201>(
      {url: `/v2/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyDtoModel
    },
      );
    }
  


export const getCompanyControllerCreateCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyControllerCreateCompany>>, TError,{data: CreateCompanyDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companyControllerCreateCompany>>, TError,{data: CreateCompanyDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyControllerCreateCompany>>, {data: CreateCompanyDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  companyControllerCreateCompany(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyControllerCreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companyControllerCreateCompany>>>
    export type CompanyControllerCreateCompanyMutationBody = CreateCompanyDtoModel
    export type CompanyControllerCreateCompanyMutationError = unknown

    /**
 * @summary 고객사 등록
 */
export const useCompanyControllerCreateCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyControllerCreateCompany>>, TError,{data: CreateCompanyDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companyControllerCreateCompany>>,
        TError,
        {data: CreateCompanyDtoModel},
        TContext
      > => {

      const mutationOptions = getCompanyControllerCreateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 역할: COACHING_MANAGER
 * @summary 모든 고객사 조회
 */
export const companyControllerGetCompanies = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyControllerGetCompanies200>(
      {url: `/v2/companies`, method: 'GET', signal
    },
      );
    }
  

export const getCompanyControllerGetCompaniesQueryKey = () => {
    return [`/v2/companies`] as const;
    }

    
export const getCompanyControllerGetCompaniesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCompanies>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCompanies>>> = ({ signal }) => companyControllerGetCompanies(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyControllerGetCompaniesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCompanies>>>
export type CompanyControllerGetCompaniesInfiniteQueryError = unknown

/**
 * @summary 모든 고객사 조회
 */
export const useCompanyControllerGetCompaniesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCompanies>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCompaniesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyControllerGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCompanies>>> = ({ signal }) => companyControllerGetCompanies(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyControllerGetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCompanies>>>
export type CompanyControllerGetCompaniesQueryError = unknown

/**
 * @summary 모든 고객사 조회
 */
export const useCompanyControllerGetCompanies = <TData = Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanies>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 고객사 조회
 */
export const companyControllerGetCompanyById = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyControllerGetCompanyById200>(
      {url: `/v2/companies/${companyId}`, method: 'GET', signal
    },
      );
    }
  

export const getCompanyControllerGetCompanyByIdQueryKey = (companyId: string,) => {
    return [`/v2/companies/${companyId}`] as const;
    }

    
export const getCompanyControllerGetCompanyByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCompanyById>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCompanyByIdQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCompanyById>>> = ({ signal }) => companyControllerGetCompanyById(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyControllerGetCompanyByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCompanyById>>>
export type CompanyControllerGetCompanyByIdInfiniteQueryError = unknown

/**
 * @summary 고객사 조회
 */
export const useCompanyControllerGetCompanyByIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCompanyById>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCompanyByIdInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyControllerGetCompanyByIdQueryOptions = <TData = Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCompanyByIdQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCompanyById>>> = ({ signal }) => companyControllerGetCompanyById(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyControllerGetCompanyByIdQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCompanyById>>>
export type CompanyControllerGetCompanyByIdQueryError = unknown

/**
 * @summary 고객사 조회
 */
export const useCompanyControllerGetCompanyById = <TData = Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCompanyById>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCompanyByIdQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 고객사 수정
 */
export const companyControllerUpdateCompany = (
    companyId: string,
    updateCompanyDtoModel: UpdateCompanyDtoModel,
 ) => {
      
      
      return apiClient<CompanyControllerUpdateCompany200>(
      {url: `/v2/companies/${companyId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDtoModel
    },
      );
    }
  


export const getCompanyControllerUpdateCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyControllerUpdateCompany>>, TError,{companyId: string;data: UpdateCompanyDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof companyControllerUpdateCompany>>, TError,{companyId: string;data: UpdateCompanyDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyControllerUpdateCompany>>, {companyId: string;data: UpdateCompanyDtoModel}> = (props) => {
          const {companyId,data} = props ?? {};

          return  companyControllerUpdateCompany(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyControllerUpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof companyControllerUpdateCompany>>>
    export type CompanyControllerUpdateCompanyMutationBody = UpdateCompanyDtoModel
    export type CompanyControllerUpdateCompanyMutationError = unknown

    /**
 * @summary 고객사 수정
 */
export const useCompanyControllerUpdateCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyControllerUpdateCompany>>, TError,{companyId: string;data: UpdateCompanyDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof companyControllerUpdateCompany>>,
        TError,
        {companyId: string;data: UpdateCompanyDtoModel},
        TContext
      > => {

      const mutationOptions = getCompanyControllerUpdateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 고객사 케이스 조회
 */
export const companyControllerGetCasesByCompanyId = (
    companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyControllerGetCasesByCompanyId200>(
      {url: `/v2/companies/${companyId}/cases`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCompanyControllerGetCasesByCompanyIdQueryKey = (companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams,) => {
    return [`/v2/companies/${companyId}/cases`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyControllerGetCasesByCompanyIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, CompanyControllerGetCasesByCompanyIdParams['page']>, TError = unknown>(companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData, Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, QueryKey, CompanyControllerGetCasesByCompanyIdParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCasesByCompanyIdQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, QueryKey, CompanyControllerGetCasesByCompanyIdParams['page']> = ({ signal, pageParam }) => companyControllerGetCasesByCompanyId(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData, Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, QueryKey, CompanyControllerGetCasesByCompanyIdParams['page']> & { queryKey: QueryKey }
}

export type CompanyControllerGetCasesByCompanyIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>>
export type CompanyControllerGetCasesByCompanyIdInfiniteQueryError = unknown

/**
 * @summary 고객사 케이스 조회
 */
export const useCompanyControllerGetCasesByCompanyIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, CompanyControllerGetCasesByCompanyIdParams['page']>, TError = unknown>(
 companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData, Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, QueryKey, CompanyControllerGetCasesByCompanyIdParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCasesByCompanyIdInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyControllerGetCasesByCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError = unknown>(companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyControllerGetCasesByCompanyIdQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>> = ({ signal }) => companyControllerGetCasesByCompanyId(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyControllerGetCasesByCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>>
export type CompanyControllerGetCasesByCompanyIdQueryError = unknown

/**
 * @summary 고객사 케이스 조회
 */
export const useCompanyControllerGetCasesByCompanyId = <TData = Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError = unknown>(
 companyId: string,
    params?: CompanyControllerGetCasesByCompanyIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof companyControllerGetCasesByCompanyId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyControllerGetCasesByCompanyIdQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스 콘솔 이용약관을 조회합니다.
 * @summary 이용약관 조회
 */
export const caseProfileControllerGetTerms = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseProfileControllerGetTerms200>(
      {url: `/v2/cases/me/terms`, method: 'GET', signal
    },
      );
    }
  

export const getCaseProfileControllerGetTermsQueryKey = () => {
    return [`/v2/cases/me/terms`] as const;
    }

    
export const getCaseProfileControllerGetTermsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseProfileControllerGetTermsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>> = ({ signal }) => caseProfileControllerGetTerms(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseProfileControllerGetTermsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>>
export type CaseProfileControllerGetTermsInfiniteQueryError = unknown

/**
 * @summary 이용약관 조회
 */
export const useCaseProfileControllerGetTermsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseProfileControllerGetTermsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseProfileControllerGetTermsQueryOptions = <TData = Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseProfileControllerGetTermsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>> = ({ signal }) => caseProfileControllerGetTerms(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseProfileControllerGetTermsQueryResult = NonNullable<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>>
export type CaseProfileControllerGetTermsQueryError = unknown

/**
 * @summary 이용약관 조회
 */
export const useCaseProfileControllerGetTerms = <TData = Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseProfileControllerGetTerms>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseProfileControllerGetTermsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스 콘솔 이용약관에 동의합니다.
 * @summary 이용약관 동의
 */
export const caseProfileControllerUpdateTerms = (
    updateCaseTermsDtoModel: UpdateCaseTermsDtoModel,
 ) => {
      
      
      return apiClient<CaseProfileControllerUpdateTerms200>(
      {url: `/v2/cases/me/terms`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCaseTermsDtoModel
    },
      );
    }
  


export const getCaseProfileControllerUpdateTermsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>, TError,{data: UpdateCaseTermsDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>, TError,{data: UpdateCaseTermsDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>, {data: UpdateCaseTermsDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  caseProfileControllerUpdateTerms(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseProfileControllerUpdateTermsMutationResult = NonNullable<Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>>
    export type CaseProfileControllerUpdateTermsMutationBody = UpdateCaseTermsDtoModel
    export type CaseProfileControllerUpdateTermsMutationError = unknown

    /**
 * @summary 이용약관 동의
 */
export const useCaseProfileControllerUpdateTerms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>, TError,{data: UpdateCaseTermsDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseProfileControllerUpdateTerms>>,
        TError,
        {data: UpdateCaseTermsDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseProfileControllerUpdateTermsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 케이스에 할당된 사이클 목록을 조회합니다.
 * @summary 사이클 목록 조회
 */
export const caseCycleControllerGetCycles = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseCycleControllerGetCycles200>(
      {url: `/v2/cases/me/cycles`, method: 'GET', signal
    },
      );
    }
  

export const getCaseCycleControllerGetCyclesQueryKey = () => {
    return [`/v2/cases/me/cycles`] as const;
    }

    
export const getCaseCycleControllerGetCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCyclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>> = ({ signal }) => caseCycleControllerGetCycles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>>
export type CaseCycleControllerGetCyclesInfiniteQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCaseCycleControllerGetCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCyclesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseCycleControllerGetCyclesQueryOptions = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCyclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>> = ({ signal }) => caseCycleControllerGetCycles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>>
export type CaseCycleControllerGetCyclesQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCaseCycleControllerGetCycles = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCyclesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 상세 조회
 */
export const caseCycleControllerGetCycle = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseCycleControllerGetCycle200>(
      {url: `/v2/cases/me/cycles/${cycleId}`, method: 'GET', signal
    },
      );
    }
  

export const getCaseCycleControllerGetCycleQueryKey = (cycleId: string,) => {
    return [`/v2/cases/me/cycles/${cycleId}`] as const;
    }

    
export const getCaseCycleControllerGetCycleInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>> = ({ signal }) => caseCycleControllerGetCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>>
export type CaseCycleControllerGetCycleInfiniteQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCaseCycleControllerGetCycleInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseCycleControllerGetCycleQueryOptions = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>> = ({ signal }) => caseCycleControllerGetCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>>
export type CaseCycleControllerGetCycleQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCaseCycleControllerGetCycle = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycle>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 코치 조회
 */
export const caseCycleControllerGetCycleCoach = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseCycleControllerGetCycleCoach200>(
      {url: `/v2/cases/me/cycles/${cycleId}/coach`, method: 'GET', signal
    },
      );
    }
  

export const getCaseCycleControllerGetCycleCoachQueryKey = (cycleId: string,) => {
    return [`/v2/cases/me/cycles/${cycleId}/coach`] as const;
    }

    
export const getCaseCycleControllerGetCycleCoachInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleCoachQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>> = ({ signal }) => caseCycleControllerGetCycleCoach(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleCoachInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>>
export type CaseCycleControllerGetCycleCoachInfiniteQueryError = unknown

/**
 * @summary 사이클 코치 조회
 */
export const useCaseCycleControllerGetCycleCoachInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleCoachInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseCycleControllerGetCycleCoachQueryOptions = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleCoachQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>> = ({ signal }) => caseCycleControllerGetCycleCoach(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleCoachQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>>
export type CaseCycleControllerGetCycleCoachQueryError = unknown

/**
 * @summary 사이클 코치 조회
 */
export const useCaseCycleControllerGetCycleCoach = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoach>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleCoachQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 코치 슬롯 조회
 */
export const caseCycleControllerGetCycleCoachSlots = (
    cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseCycleControllerGetCycleCoachSlots200>(
      {url: `/v2/cases/me/cycles/${cycleId}/coach/slots`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCaseCycleControllerGetCycleCoachSlotsQueryKey = (cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams,) => {
    return [`/v2/cases/me/cycles/${cycleId}/coach/slots`, ...(params ? [params]: [])] as const;
    }

    
export const getCaseCycleControllerGetCycleCoachSlotsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, CaseCycleControllerGetCycleCoachSlotsParams['page']>, TError = unknown>(cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData, Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, QueryKey, CaseCycleControllerGetCycleCoachSlotsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleCoachSlotsQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, QueryKey, CaseCycleControllerGetCycleCoachSlotsParams['page']> = ({ signal, pageParam }) => caseCycleControllerGetCycleCoachSlots(cycleId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData, Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, QueryKey, CaseCycleControllerGetCycleCoachSlotsParams['page']> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleCoachSlotsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>>
export type CaseCycleControllerGetCycleCoachSlotsInfiniteQueryError = unknown

/**
 * @summary 사이클 코치 슬롯 조회
 */
export const useCaseCycleControllerGetCycleCoachSlotsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, CaseCycleControllerGetCycleCoachSlotsParams['page']>, TError = unknown>(
 cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData, Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, QueryKey, CaseCycleControllerGetCycleCoachSlotsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleCoachSlotsInfiniteQueryOptions(cycleId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseCycleControllerGetCycleCoachSlotsQueryOptions = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError = unknown>(cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCycleCoachSlotsQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>> = ({ signal }) => caseCycleControllerGetCycleCoachSlots(cycleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCycleCoachSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>>
export type CaseCycleControllerGetCycleCoachSlotsQueryError = unknown

/**
 * @summary 사이클 코치 슬롯 조회
 */
export const useCaseCycleControllerGetCycleCoachSlots = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError = unknown>(
 cycleId: string,
    params: CaseCycleControllerGetCycleCoachSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCycleCoachSlots>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCycleCoachSlotsQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 세션 슬롯 예약
 */
export const caseCycleControllerReserveSlot = (
    cycleId: string,
    sessionId: string,
    reserveSlotDtoModel: ReserveSlotDtoModel,
 ) => {
      
      
      return apiClient<CaseCycleControllerReserveSlot200>(
      {url: `/v2/cases/me/cycles/${cycleId}/sessions/${sessionId}/reserve-slot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reserveSlotDtoModel
    },
      );
    }
  


export const getCaseCycleControllerReserveSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>, TError,{cycleId: string;sessionId: string;data: ReserveSlotDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>, TError,{cycleId: string;sessionId: string;data: ReserveSlotDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>, {cycleId: string;sessionId: string;data: ReserveSlotDtoModel}> = (props) => {
          const {cycleId,sessionId,data} = props ?? {};

          return  caseCycleControllerReserveSlot(cycleId,sessionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseCycleControllerReserveSlotMutationResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>>
    export type CaseCycleControllerReserveSlotMutationBody = ReserveSlotDtoModel
    export type CaseCycleControllerReserveSlotMutationError = unknown

    /**
 * @summary 세션 슬롯 예약
 */
export const useCaseCycleControllerReserveSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>, TError,{cycleId: string;sessionId: string;data: ReserveSlotDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseCycleControllerReserveSlot>>,
        TError,
        {cycleId: string;sessionId: string;data: ReserveSlotDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseCycleControllerReserveSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 세션 슬롯 예약 취소
 */
export const caseCycleControllerCancelSlot = (
    cycleId: string,
    sessionId: string,
 ) => {
      
      
      return apiClient<CaseCycleControllerCancelSlot200>(
      {url: `/v2/cases/me/cycles/${cycleId}/sessions/${sessionId}/cancel-slot`, method: 'POST'
    },
      );
    }
  


export const getCaseCycleControllerCancelSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>, TError,{cycleId: string;sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>, TError,{cycleId: string;sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>, {cycleId: string;sessionId: string}> = (props) => {
          const {cycleId,sessionId} = props ?? {};

          return  caseCycleControllerCancelSlot(cycleId,sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseCycleControllerCancelSlotMutationResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>>
    
    export type CaseCycleControllerCancelSlotMutationError = unknown

    /**
 * @summary 세션 슬롯 예약 취소
 */
export const useCaseCycleControllerCancelSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>, TError,{cycleId: string;sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseCycleControllerCancelSlot>>,
        TError,
        {cycleId: string;sessionId: string},
        TContext
      > => {

      const mutationOptions = getCaseCycleControllerCancelSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const caseCycleControllerGetCoachingNotesFromCycle = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseCycleControllerGetCoachingNotesFromCycle200>(
      {url: `/v2/cases/me/cycles/${cycleId}/coaching-notes`, method: 'GET', signal
    },
      );
    }
  

export const getCaseCycleControllerGetCoachingNotesFromCycleQueryKey = (cycleId: string,) => {
    return [`/v2/cases/me/cycles/${cycleId}/coaching-notes`] as const;
    }

    
export const getCaseCycleControllerGetCoachingNotesFromCycleInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCoachingNotesFromCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>> = ({ signal }) => caseCycleControllerGetCoachingNotesFromCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCoachingNotesFromCycleInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>>
export type CaseCycleControllerGetCoachingNotesFromCycleInfiniteQueryError = unknown

/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const useCaseCycleControllerGetCoachingNotesFromCycleInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCoachingNotesFromCycleInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseCycleControllerGetCoachingNotesFromCycleQueryOptions = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseCycleControllerGetCoachingNotesFromCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>> = ({ signal }) => caseCycleControllerGetCoachingNotesFromCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseCycleControllerGetCoachingNotesFromCycleQueryResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>>
export type CaseCycleControllerGetCoachingNotesFromCycleQueryError = unknown

/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const useCaseCycleControllerGetCoachingNotesFromCycle = <TData = Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseCycleControllerGetCoachingNotesFromCycle>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseCycleControllerGetCoachingNotesFromCycleQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치에게 문의 메일 발송
 */
export const caseCycleControllerContactCoach = (
    cycleId: string,
    contactCoachRequestDtoModel: ContactCoachRequestDtoModel,
 ) => {
      
      
      return apiClient<CaseCycleControllerContactCoach200>(
      {url: `/v2/cases/me/cycles/${cycleId}/contact-coach`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactCoachRequestDtoModel
    },
      );
    }
  


export const getCaseCycleControllerContactCoachMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerContactCoach>>, TError,{cycleId: string;data: ContactCoachRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerContactCoach>>, TError,{cycleId: string;data: ContactCoachRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseCycleControllerContactCoach>>, {cycleId: string;data: ContactCoachRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  caseCycleControllerContactCoach(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseCycleControllerContactCoachMutationResult = NonNullable<Awaited<ReturnType<typeof caseCycleControllerContactCoach>>>
    export type CaseCycleControllerContactCoachMutationBody = ContactCoachRequestDtoModel
    export type CaseCycleControllerContactCoachMutationError = unknown

    /**
 * @summary 코치에게 문의 메일 발송
 */
export const useCaseCycleControllerContactCoach = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseCycleControllerContactCoach>>, TError,{cycleId: string;data: ContactCoachRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseCycleControllerContactCoach>>,
        TError,
        {cycleId: string;data: ContactCoachRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseCycleControllerContactCoachMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 사이클 설문 목록을 조회합니다.
 * @summary 사이클 설문 목록
 */
export const caseSurveyControllerGetCycleSurveys = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseSurveyControllerGetCycleSurveys200>(
      {url: `/v2/cases/me/cycles/${cycleId}/surveys`, method: 'GET', signal
    },
      );
    }
  

export const getCaseSurveyControllerGetCycleSurveysQueryKey = (cycleId: string,) => {
    return [`/v2/cases/me/cycles/${cycleId}/surveys`] as const;
    }

    
export const getCaseSurveyControllerGetCycleSurveysInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseSurveyControllerGetCycleSurveysQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>> = ({ signal }) => caseSurveyControllerGetCycleSurveys(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseSurveyControllerGetCycleSurveysInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>>
export type CaseSurveyControllerGetCycleSurveysInfiniteQueryError = unknown

/**
 * @summary 사이클 설문 목록
 */
export const useCaseSurveyControllerGetCycleSurveysInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseSurveyControllerGetCycleSurveysInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseSurveyControllerGetCycleSurveysQueryOptions = <TData = Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseSurveyControllerGetCycleSurveysQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>> = ({ signal }) => caseSurveyControllerGetCycleSurveys(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseSurveyControllerGetCycleSurveysQueryResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>>
export type CaseSurveyControllerGetCycleSurveysQueryError = unknown

/**
 * @summary 사이클 설문 목록
 */
export const useCaseSurveyControllerGetCycleSurveys = <TData = Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetCycleSurveys>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseSurveyControllerGetCycleSurveysQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 내가 해야할 동료 피드백 설문 목록을 조회합니다.
 * @summary 동료 피드백 설문 목록
 */
export const caseSurveyControllerGetPeerFeedbackSurveys = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseSurveyControllerGetPeerFeedbackSurveys200>(
      {url: `/v2/cases/me/peer-feedback-surveys`, method: 'GET', signal
    },
      );
    }
  

export const getCaseSurveyControllerGetPeerFeedbackSurveysQueryKey = () => {
    return [`/v2/cases/me/peer-feedback-surveys`] as const;
    }

    
export const getCaseSurveyControllerGetPeerFeedbackSurveysInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseSurveyControllerGetPeerFeedbackSurveysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>> = ({ signal }) => caseSurveyControllerGetPeerFeedbackSurveys(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseSurveyControllerGetPeerFeedbackSurveysInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>>
export type CaseSurveyControllerGetPeerFeedbackSurveysInfiniteQueryError = unknown

/**
 * @summary 동료 피드백 설문 목록
 */
export const useCaseSurveyControllerGetPeerFeedbackSurveysInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseSurveyControllerGetPeerFeedbackSurveysInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseSurveyControllerGetPeerFeedbackSurveysQueryOptions = <TData = Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseSurveyControllerGetPeerFeedbackSurveysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>> = ({ signal }) => caseSurveyControllerGetPeerFeedbackSurveys(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseSurveyControllerGetPeerFeedbackSurveysQueryResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>>
export type CaseSurveyControllerGetPeerFeedbackSurveysQueryError = unknown

/**
 * @summary 동료 피드백 설문 목록
 */
export const useCaseSurveyControllerGetPeerFeedbackSurveys = <TData = Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseSurveyControllerGetPeerFeedbackSurveys>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseSurveyControllerGetPeerFeedbackSurveysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 온보딩 설문 답변을 제출합니다.
 * @summary 온보딩 설문 제출
 */
export const caseSurveyControllerSubmitOnboardingSurvey = (
    cycleId: string,
    surveyId: string,
    submitSurveyRequestDtoModel: SubmitSurveyRequestDtoModel,
 ) => {
      
      
      return apiClient<CaseSurveyControllerSubmitOnboardingSurvey200>(
      {url: `/v2/cases/me/cycles/${cycleId}/surveys/onboarding/${surveyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitSurveyRequestDtoModel
    },
      );
    }
  


export const getCaseSurveyControllerSubmitOnboardingSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>, {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}> = (props) => {
          const {cycleId,surveyId,data} = props ?? {};

          return  caseSurveyControllerSubmitOnboardingSurvey(cycleId,surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseSurveyControllerSubmitOnboardingSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>>
    export type CaseSurveyControllerSubmitOnboardingSurveyMutationBody = SubmitSurveyRequestDtoModel
    export type CaseSurveyControllerSubmitOnboardingSurveyMutationError = unknown

    /**
 * @summary 온보딩 설문 제출
 */
export const useCaseSurveyControllerSubmitOnboardingSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseSurveyControllerSubmitOnboardingSurvey>>,
        TError,
        {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseSurveyControllerSubmitOnboardingSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 웨이마크 설문 답변을 제출합니다.
 * @summary 웨이마크 설문 제출
 */
export const caseSurveyControllerSubmitWaymarkSurvey = (
    cycleId: string,
    surveyId: string,
    submitSurveyRequestDtoModel: SubmitSurveyRequestDtoModel,
 ) => {
      
      
      return apiClient<CaseSurveyControllerSubmitWaymarkSurvey200>(
      {url: `/v2/cases/me/cycles/${cycleId}/surveys/waymark/${surveyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitSurveyRequestDtoModel
    },
      );
    }
  


export const getCaseSurveyControllerSubmitWaymarkSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>, {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}> = (props) => {
          const {cycleId,surveyId,data} = props ?? {};

          return  caseSurveyControllerSubmitWaymarkSurvey(cycleId,surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseSurveyControllerSubmitWaymarkSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>>
    export type CaseSurveyControllerSubmitWaymarkSurveyMutationBody = SubmitSurveyRequestDtoModel
    export type CaseSurveyControllerSubmitWaymarkSurveyMutationError = unknown

    /**
 * @summary 웨이마크 설문 제출
 */
export const useCaseSurveyControllerSubmitWaymarkSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseSurveyControllerSubmitWaymarkSurvey>>,
        TError,
        {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseSurveyControllerSubmitWaymarkSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 리더십 설문 답변을 제출합니다.
 * @summary 리더십 설문 제출
 */
export const caseSurveyControllerSubmitLeadershipSelfSurvey = (
    cycleId: string,
    surveyId: string,
    submitSurveyRequestDtoModel: SubmitSurveyRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/cases/me/cycles/${cycleId}/surveys/leadership-self/${surveyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitSurveyRequestDtoModel
    },
      );
    }
  


export const getCaseSurveyControllerSubmitLeadershipSelfSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>, {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}> = (props) => {
          const {cycleId,surveyId,data} = props ?? {};

          return  caseSurveyControllerSubmitLeadershipSelfSurvey(cycleId,surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseSurveyControllerSubmitLeadershipSelfSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>>
    export type CaseSurveyControllerSubmitLeadershipSelfSurveyMutationBody = SubmitSurveyRequestDtoModel
    export type CaseSurveyControllerSubmitLeadershipSelfSurveyMutationError = unknown

    /**
 * @summary 리더십 설문 제출
 */
export const useCaseSurveyControllerSubmitLeadershipSelfSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>, TError,{cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseSurveyControllerSubmitLeadershipSelfSurvey>>,
        TError,
        {cycleId: string;surveyId: string;data: SubmitSurveyRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseSurveyControllerSubmitLeadershipSelfSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 동료 피드백 설문 답변을 제출합니다.
 * @summary 동료 피드백 설문 제출
 */
export const caseSurveyControllerSubmitPeerFeedbackSurvey = (
    surveyId: string,
    submitSurveyRequestDtoModel: SubmitSurveyRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/cases/me/surveys/peer-feedback/${surveyId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitSurveyRequestDtoModel
    },
      );
    }
  


export const getCaseSurveyControllerSubmitPeerFeedbackSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>, TError,{surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>, TError,{surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>, {surveyId: string;data: SubmitSurveyRequestDtoModel}> = (props) => {
          const {surveyId,data} = props ?? {};

          return  caseSurveyControllerSubmitPeerFeedbackSurvey(surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseSurveyControllerSubmitPeerFeedbackSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>>
    export type CaseSurveyControllerSubmitPeerFeedbackSurveyMutationBody = SubmitSurveyRequestDtoModel
    export type CaseSurveyControllerSubmitPeerFeedbackSurveyMutationError = unknown

    /**
 * @summary 동료 피드백 설문 제출
 */
export const useCaseSurveyControllerSubmitPeerFeedbackSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>, TError,{surveyId: string;data: SubmitSurveyRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseSurveyControllerSubmitPeerFeedbackSurvey>>,
        TError,
        {surveyId: string;data: SubmitSurveyRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseSurveyControllerSubmitPeerFeedbackSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 사이클 리포트 목록을 조회합니다.
 * @summary 사이클 리포트 목록
 */
export const caseReportControllerGetCycleReports = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseReportControllerGetCycleReports200>(
      {url: `/v2/cases/me/cycles/${cycleId}/reports`, method: 'GET', signal
    },
      );
    }
  

export const getCaseReportControllerGetCycleReportsQueryKey = (cycleId: string,) => {
    return [`/v2/cases/me/cycles/${cycleId}/reports`] as const;
    }

    
export const getCaseReportControllerGetCycleReportsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseReportControllerGetCycleReportsQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>> = ({ signal }) => caseReportControllerGetCycleReports(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseReportControllerGetCycleReportsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>>
export type CaseReportControllerGetCycleReportsInfiniteQueryError = unknown

/**
 * @summary 사이클 리포트 목록
 */
export const useCaseReportControllerGetCycleReportsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseReportControllerGetCycleReportsInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseReportControllerGetCycleReportsQueryOptions = <TData = Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseReportControllerGetCycleReportsQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>> = ({ signal }) => caseReportControllerGetCycleReports(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseReportControllerGetCycleReportsQueryResult = NonNullable<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>>
export type CaseReportControllerGetCycleReportsQueryError = unknown

/**
 * @summary 사이클 리포트 목록
 */
export const useCaseReportControllerGetCycleReports = <TData = Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseReportControllerGetCycleReports>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseReportControllerGetCycleReportsQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스를 생성합니다.
 * @summary 케이스 생성
 */
export const caseControllerCreateCase = (
    createCaseDtoModel: CreateCaseDtoModel,
 ) => {
      
      
      return apiClient<CaseControllerCreateCase201>(
      {url: `/v2/cases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCaseDtoModel
    },
      );
    }
  


export const getCaseControllerCreateCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateCase>>, TError,{data: CreateCaseDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateCase>>, TError,{data: CreateCaseDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseControllerCreateCase>>, {data: CreateCaseDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  caseControllerCreateCase(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseControllerCreateCaseMutationResult = NonNullable<Awaited<ReturnType<typeof caseControllerCreateCase>>>
    export type CaseControllerCreateCaseMutationBody = CreateCaseDtoModel
    export type CaseControllerCreateCaseMutationError = unknown

    /**
 * @summary 케이스 생성
 */
export const useCaseControllerCreateCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateCase>>, TError,{data: CreateCaseDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseControllerCreateCase>>,
        TError,
        {data: CreateCaseDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseControllerCreateCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 목록 안에서 이메일이 겹치면 하나로 합치고, 이미 등록된 사람은 건너뛴다. 건너뛰기만 해서 등록된 건이 0이어도 201 이므로, 결과는 cases 와 skippedCount 로 판단한다.
 * @summary 동료피드백 등록을 위한 케이스 bulk 생성
 */
export const caseControllerCreateBulkCase = (
    createBulkSimpleCaseDtoModel: CreateBulkSimpleCaseDtoModel,
 ) => {
      
      
      return apiClient<CaseControllerCreateBulkCase201>(
      {url: `/v2/cases/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBulkSimpleCaseDtoModel
    },
      );
    }
  


export const getCaseControllerCreateBulkCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateBulkCase>>, TError,{data: CreateBulkSimpleCaseDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateBulkCase>>, TError,{data: CreateBulkSimpleCaseDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseControllerCreateBulkCase>>, {data: CreateBulkSimpleCaseDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  caseControllerCreateBulkCase(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseControllerCreateBulkCaseMutationResult = NonNullable<Awaited<ReturnType<typeof caseControllerCreateBulkCase>>>
    export type CaseControllerCreateBulkCaseMutationBody = CreateBulkSimpleCaseDtoModel
    export type CaseControllerCreateBulkCaseMutationError = unknown

    /**
 * @summary 동료피드백 등록을 위한 케이스 bulk 생성
 */
export const useCaseControllerCreateBulkCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerCreateBulkCase>>, TError,{data: CreateBulkSimpleCaseDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseControllerCreateBulkCase>>,
        TError,
        {data: CreateBulkSimpleCaseDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseControllerCreateBulkCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 이름 또는 이메일로 케이스를 검색하여 자동완성 목록을 제공합니다. 검색어는 최소 2글자 이상 입력해야 하며, 케이스 ID, 이름, 이메일, 회사명을 포함한 간단한 정보만 반환됩니다.
 * @summary 케이스 자동완성 검색
 */
export const caseControllerSearchCases = (
    companyId: string,
    params: CaseControllerSearchCasesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseControllerSearchCases200>(
      {url: `/v2/cases/search/${companyId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCaseControllerSearchCasesQueryKey = (companyId: string,
    params: CaseControllerSearchCasesParams,) => {
    return [`/v2/cases/search/${companyId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCaseControllerSearchCasesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseControllerSearchCases>>, CaseControllerSearchCasesParams['page']>, TError = unknown>(companyId: string,
    params: CaseControllerSearchCasesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData, Awaited<ReturnType<typeof caseControllerSearchCases>>, QueryKey, CaseControllerSearchCasesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseControllerSearchCasesQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseControllerSearchCases>>, QueryKey, CaseControllerSearchCasesParams['page']> = ({ signal, pageParam }) => caseControllerSearchCases(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData, Awaited<ReturnType<typeof caseControllerSearchCases>>, QueryKey, CaseControllerSearchCasesParams['page']> & { queryKey: QueryKey }
}

export type CaseControllerSearchCasesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseControllerSearchCases>>>
export type CaseControllerSearchCasesInfiniteQueryError = unknown

/**
 * @summary 케이스 자동완성 검색
 */
export const useCaseControllerSearchCasesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseControllerSearchCases>>, CaseControllerSearchCasesParams['page']>, TError = unknown>(
 companyId: string,
    params: CaseControllerSearchCasesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData, Awaited<ReturnType<typeof caseControllerSearchCases>>, QueryKey, CaseControllerSearchCasesParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseControllerSearchCasesInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseControllerSearchCasesQueryOptions = <TData = Awaited<ReturnType<typeof caseControllerSearchCases>>, TError = unknown>(companyId: string,
    params: CaseControllerSearchCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseControllerSearchCasesQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseControllerSearchCases>>> = ({ signal }) => caseControllerSearchCases(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseControllerSearchCasesQueryResult = NonNullable<Awaited<ReturnType<typeof caseControllerSearchCases>>>
export type CaseControllerSearchCasesQueryError = unknown

/**
 * @summary 케이스 자동완성 검색
 */
export const useCaseControllerSearchCases = <TData = Awaited<ReturnType<typeof caseControllerSearchCases>>, TError = unknown>(
 companyId: string,
    params: CaseControllerSearchCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseControllerSearchCases>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseControllerSearchCasesQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스를 조회합니다.
 * @summary 케이스 조회
 */
export const caseControllerGetCase = (
    caseId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseControllerGetCase200>(
      {url: `/v2/cases/${caseId}`, method: 'GET', signal
    },
      );
    }
  

export const getCaseControllerGetCaseQueryKey = (caseId: string,) => {
    return [`/v2/cases/${caseId}`] as const;
    }

    
export const getCaseControllerGetCaseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseControllerGetCase>>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseControllerGetCaseQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseControllerGetCase>>> = ({ signal }) => caseControllerGetCase(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseControllerGetCaseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseControllerGetCase>>>
export type CaseControllerGetCaseInfiniteQueryError = unknown

/**
 * @summary 케이스 조회
 */
export const useCaseControllerGetCaseInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseControllerGetCase>>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseControllerGetCaseInfiniteQueryOptions(caseId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseControllerGetCaseQueryOptions = <TData = Awaited<ReturnType<typeof caseControllerGetCase>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseControllerGetCaseQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseControllerGetCase>>> = ({ signal }) => caseControllerGetCase(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseControllerGetCaseQueryResult = NonNullable<Awaited<ReturnType<typeof caseControllerGetCase>>>
export type CaseControllerGetCaseQueryError = unknown

/**
 * @summary 케이스 조회
 */
export const useCaseControllerGetCase = <TData = Awaited<ReturnType<typeof caseControllerGetCase>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseControllerGetCase>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseControllerGetCaseQueryOptions(caseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스를 수정합니다.
 * @summary 케이스 수정
 */
export const caseControllerUpdateCase = (
    caseId: string,
    updateCaseDtoModel: UpdateCaseDtoModel,
 ) => {
      
      
      return apiClient<CaseControllerUpdateCase200>(
      {url: `/v2/cases/${caseId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCaseDtoModel
    },
      );
    }
  


export const getCaseControllerUpdateCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerUpdateCase>>, TError,{caseId: string;data: UpdateCaseDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseControllerUpdateCase>>, TError,{caseId: string;data: UpdateCaseDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseControllerUpdateCase>>, {caseId: string;data: UpdateCaseDtoModel}> = (props) => {
          const {caseId,data} = props ?? {};

          return  caseControllerUpdateCase(caseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseControllerUpdateCaseMutationResult = NonNullable<Awaited<ReturnType<typeof caseControllerUpdateCase>>>
    export type CaseControllerUpdateCaseMutationBody = UpdateCaseDtoModel
    export type CaseControllerUpdateCaseMutationError = unknown

    /**
 * @summary 케이스 수정
 */
export const useCaseControllerUpdateCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseControllerUpdateCase>>, TError,{caseId: string;data: UpdateCaseDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseControllerUpdateCase>>,
        TError,
        {caseId: string;data: UpdateCaseDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseControllerUpdateCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 사이클을 생성합니다.
 * @summary 사이클 생성
 */
export const cycleControllerCreateCycle = (
    createCycleDtoModel: CreateCycleDtoModel,
 ) => {
      
      
      return apiClient<CycleControllerCreateCycle201>(
      {url: `/v2/cycles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCycleDtoModel
    },
      );
    }
  


export const getCycleControllerCreateCycleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerCreateCycle>>, TError,{data: CreateCycleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cycleControllerCreateCycle>>, TError,{data: CreateCycleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cycleControllerCreateCycle>>, {data: CreateCycleDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cycleControllerCreateCycle(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CycleControllerCreateCycleMutationResult = NonNullable<Awaited<ReturnType<typeof cycleControllerCreateCycle>>>
    export type CycleControllerCreateCycleMutationBody = CreateCycleDtoModel
    export type CycleControllerCreateCycleMutationError = unknown

    /**
 * @summary 사이클 생성
 */
export const useCycleControllerCreateCycle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerCreateCycle>>, TError,{data: CreateCycleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cycleControllerCreateCycle>>,
        TError,
        {data: CreateCycleDtoModel},
        TContext
      > => {

      const mutationOptions = getCycleControllerCreateCycleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 수정
 */
export const cycleControllerUpdateCycle = (
    cycleId: string,
    updateCycleDtoModel: UpdateCycleDtoModel,
 ) => {
      
      
      return apiClient<CycleControllerUpdateCycle200>(
      {url: `/v2/cycles/${cycleId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCycleDtoModel
    },
      );
    }
  


export const getCycleControllerUpdateCycleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerUpdateCycle>>, TError,{cycleId: string;data: UpdateCycleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cycleControllerUpdateCycle>>, TError,{cycleId: string;data: UpdateCycleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cycleControllerUpdateCycle>>, {cycleId: string;data: UpdateCycleDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cycleControllerUpdateCycle(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CycleControllerUpdateCycleMutationResult = NonNullable<Awaited<ReturnType<typeof cycleControllerUpdateCycle>>>
    export type CycleControllerUpdateCycleMutationBody = UpdateCycleDtoModel
    export type CycleControllerUpdateCycleMutationError = unknown

    /**
 * @summary 사이클 수정
 */
export const useCycleControllerUpdateCycle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerUpdateCycle>>, TError,{cycleId: string;data: UpdateCycleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cycleControllerUpdateCycle>>,
        TError,
        {cycleId: string;data: UpdateCycleDtoModel},
        TContext
      > => {

      const mutationOptions = getCycleControllerUpdateCycleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 이메일로 웨이마크 설문 목록을 조회합니다.
 * @summary 웨이마크 설문 목록 조회
 */
export const cycleControllerSearchWaymarkSurveys = (
    searchWaymarkSurveysDtoModel: SearchWaymarkSurveysDtoModel,
 ) => {
      
      
      return apiClient<CycleControllerSearchWaymarkSurveys200>(
      {url: `/v2/cycles/waymark-surveys/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchWaymarkSurveysDtoModel
    },
      );
    }
  


export const getCycleControllerSearchWaymarkSurveysMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>, TError,{data: SearchWaymarkSurveysDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>, TError,{data: SearchWaymarkSurveysDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>, {data: SearchWaymarkSurveysDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cycleControllerSearchWaymarkSurveys(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CycleControllerSearchWaymarkSurveysMutationResult = NonNullable<Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>>
    export type CycleControllerSearchWaymarkSurveysMutationBody = SearchWaymarkSurveysDtoModel
    export type CycleControllerSearchWaymarkSurveysMutationError = unknown

    /**
 * @summary 웨이마크 설문 목록 조회
 */
export const useCycleControllerSearchWaymarkSurveys = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>, TError,{data: SearchWaymarkSurveysDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cycleControllerSearchWaymarkSurveys>>,
        TError,
        {data: SearchWaymarkSurveysDtoModel},
        TContext
      > => {

      const mutationOptions = getCycleControllerSearchWaymarkSurveysMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 즐겨찾기가 포함된 고객사 목록을 조회합니다.
 * @summary 즐겨찾기가 포함된 고객사 목록
 */
export const cmCompanyControllerFindAllWithFavorite = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCompanyControllerFindAllWithFavorite200>(
      {url: `/v2/coaching-managers/me/companies`, method: 'GET', signal
    },
      );
    }
  

export const getCmCompanyControllerFindAllWithFavoriteQueryKey = () => {
    return [`/v2/coaching-managers/me/companies`] as const;
    }

    
export const getCmCompanyControllerFindAllWithFavoriteInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCompanyControllerFindAllWithFavoriteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>> = ({ signal }) => cmCompanyControllerFindAllWithFavorite(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCompanyControllerFindAllWithFavoriteInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>>
export type CmCompanyControllerFindAllWithFavoriteInfiniteQueryError = unknown

/**
 * @summary 즐겨찾기가 포함된 고객사 목록
 */
export const useCmCompanyControllerFindAllWithFavoriteInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCompanyControllerFindAllWithFavoriteInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCompanyControllerFindAllWithFavoriteQueryOptions = <TData = Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCompanyControllerFindAllWithFavoriteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>> = ({ signal }) => cmCompanyControllerFindAllWithFavorite(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCompanyControllerFindAllWithFavoriteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>>
export type CmCompanyControllerFindAllWithFavoriteQueryError = unknown

/**
 * @summary 즐겨찾기가 포함된 고객사 목록
 */
export const useCmCompanyControllerFindAllWithFavorite = <TData = Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerFindAllWithFavorite>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCompanyControllerFindAllWithFavoriteQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * CM이 즐겨찾기 고객사를 등록합니다.
 * @summary 즐겨찾기 고객사 등록
 */
export const cmCompanyControllerCreateFavoriteCompany = (
    companyId: string,
 ) => {
      
      
      return apiClient<CmCompanyControllerCreateFavoriteCompany201>(
      {url: `/v2/coaching-managers/me/companies/${companyId}/favorite`, method: 'POST'
    },
      );
    }
  


export const getCmCompanyControllerCreateFavoriteCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>, {companyId: string}> = (props) => {
          const {companyId} = props ?? {};

          return  cmCompanyControllerCreateFavoriteCompany(companyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCompanyControllerCreateFavoriteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>>
    
    export type CmCompanyControllerCreateFavoriteCompanyMutationError = unknown

    /**
 * @summary 즐겨찾기 고객사 등록
 */
export const useCmCompanyControllerCreateFavoriteCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCompanyControllerCreateFavoriteCompany>>,
        TError,
        {companyId: string},
        TContext
      > => {

      const mutationOptions = getCmCompanyControllerCreateFavoriteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 즐겨찾기 고객사를 삭제합니다.
 * @summary 즐겨찾기 고객사 삭제
 */
export const cmCompanyControllerDeleteFavoriteCompany = (
    companyId: string,
 ) => {
      
      
      return apiClient<CmCompanyControllerDeleteFavoriteCompany200>(
      {url: `/v2/coaching-managers/me/companies/${companyId}/favorite`, method: 'DELETE'
    },
      );
    }
  


export const getCmCompanyControllerDeleteFavoriteCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>, {companyId: string}> = (props) => {
          const {companyId} = props ?? {};

          return  cmCompanyControllerDeleteFavoriteCompany(companyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCompanyControllerDeleteFavoriteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>>
    
    export type CmCompanyControllerDeleteFavoriteCompanyMutationError = unknown

    /**
 * @summary 즐겨찾기 고객사 삭제
 */
export const useCmCompanyControllerDeleteFavoriteCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCompanyControllerDeleteFavoriteCompany>>,
        TError,
        {companyId: string},
        TContext
      > => {

      const mutationOptions = getCmCompanyControllerDeleteFavoriteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 고객사별 계약 구분·사전진단 일정·온보딩 미팅·LCD 저장 현황을 한 행으로 조회합니다. 내부 CPM 전용입니다.
 * @summary 고객사 현황 대시보드
 */
export const cmCompanyControllerGetCompanyStatusDashboard = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCompanyControllerGetCompanyStatusDashboard200>(
      {url: `/v2/coaching-managers/me/companies/status-dashboard`, method: 'GET', signal
    },
      );
    }
  

export const getCmCompanyControllerGetCompanyStatusDashboardQueryKey = () => {
    return [`/v2/coaching-managers/me/companies/status-dashboard`] as const;
    }

    
export const getCmCompanyControllerGetCompanyStatusDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCompanyControllerGetCompanyStatusDashboardQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>> = ({ signal }) => cmCompanyControllerGetCompanyStatusDashboard(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCompanyControllerGetCompanyStatusDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>>
export type CmCompanyControllerGetCompanyStatusDashboardInfiniteQueryError = unknown

/**
 * @summary 고객사 현황 대시보드
 */
export const useCmCompanyControllerGetCompanyStatusDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCompanyControllerGetCompanyStatusDashboardInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCompanyControllerGetCompanyStatusDashboardQueryOptions = <TData = Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCompanyControllerGetCompanyStatusDashboardQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>> = ({ signal }) => cmCompanyControllerGetCompanyStatusDashboard(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCompanyControllerGetCompanyStatusDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>>
export type CmCompanyControllerGetCompanyStatusDashboardQueryError = unknown

/**
 * @summary 고객사 현황 대시보드
 */
export const useCmCompanyControllerGetCompanyStatusDashboard = <TData = Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCompanyControllerGetCompanyStatusDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCompanyControllerGetCompanyStatusDashboardQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클 목록을 조회합니다.
 * @summary 사이클 목록 조회
 */
export const cmCycleControllerGetCycles = (
    params?: CmCycleControllerGetCyclesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetCycles200>(
      {url: `/v2/coaching-managers/me/cycles`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmCycleControllerGetCyclesQueryKey = (params?: CmCycleControllerGetCyclesParams,) => {
    return [`/v2/coaching-managers/me/cycles`, ...(params ? [params]: [])] as const;
    }

    
export const getCmCycleControllerGetCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, CmCycleControllerGetCyclesParams['page']>, TError = unknown>(params?: CmCycleControllerGetCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, QueryKey, CmCycleControllerGetCyclesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, QueryKey, CmCycleControllerGetCyclesParams['page']> = ({ signal, pageParam }) => cmCycleControllerGetCycles({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, QueryKey, CmCycleControllerGetCyclesParams['page']> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>>
export type CmCycleControllerGetCyclesInfiniteQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCmCycleControllerGetCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, CmCycleControllerGetCyclesParams['page']>, TError = unknown>(
 params?: CmCycleControllerGetCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, QueryKey, CmCycleControllerGetCyclesParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCyclesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetCyclesQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError = unknown>(params?: CmCycleControllerGetCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>> = ({ signal }) => cmCycleControllerGetCycles(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>>
export type CmCycleControllerGetCyclesQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCmCycleControllerGetCycles = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError = unknown>(
 params?: CmCycleControllerGetCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCyclesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 회사별 전체 사이클 대시보드 조회
 */
export const cmCycleControllerGetCoachingManagerDashboard = (
    params?: CmCycleControllerGetCoachingManagerDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetCoachingManagerDashboard200>(
      {url: `/v2/coaching-managers/me/cycles/dashboard`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmCycleControllerGetCoachingManagerDashboardQueryKey = (params?: CmCycleControllerGetCoachingManagerDashboardParams,) => {
    return [`/v2/coaching-managers/me/cycles/dashboard`, ...(params ? [params]: [])] as const;
    }

    
export const getCmCycleControllerGetCoachingManagerDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, CmCycleControllerGetCoachingManagerDashboardParams['page']>, TError = unknown>(params?: CmCycleControllerGetCoachingManagerDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, QueryKey, CmCycleControllerGetCoachingManagerDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingManagerDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, QueryKey, CmCycleControllerGetCoachingManagerDashboardParams['page']> = ({ signal, pageParam }) => cmCycleControllerGetCoachingManagerDashboard({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, QueryKey, CmCycleControllerGetCoachingManagerDashboardParams['page']> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingManagerDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>>
export type CmCycleControllerGetCoachingManagerDashboardInfiniteQueryError = unknown

/**
 * @summary 회사별 전체 사이클 대시보드 조회
 */
export const useCmCycleControllerGetCoachingManagerDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, CmCycleControllerGetCoachingManagerDashboardParams['page']>, TError = unknown>(
 params?: CmCycleControllerGetCoachingManagerDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, QueryKey, CmCycleControllerGetCoachingManagerDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingManagerDashboardInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetCoachingManagerDashboardQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError = unknown>(params?: CmCycleControllerGetCoachingManagerDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingManagerDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>> = ({ signal }) => cmCycleControllerGetCoachingManagerDashboard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingManagerDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>>
export type CmCycleControllerGetCoachingManagerDashboardQueryError = unknown

/**
 * @summary 회사별 전체 사이클 대시보드 조회
 */
export const useCmCycleControllerGetCoachingManagerDashboard = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError = unknown>(
 params?: CmCycleControllerGetCoachingManagerDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingManagerDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingManagerDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스에 할당된 사이클 목록을 조회합니다.
 * @summary 사이클 목록 조회
 */
export const cmCycleControllerFindAllCyclesByCaseId = (
    caseId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerFindAllCyclesByCaseId200>(
      {url: `/v2/coaching-managers/me/cases/${caseId}/cycles`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerFindAllCyclesByCaseIdQueryKey = (caseId: string,) => {
    return [`/v2/coaching-managers/me/cases/${caseId}/cycles`] as const;
    }

    
export const getCmCycleControllerFindAllCyclesByCaseIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindAllCyclesByCaseIdQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>> = ({ signal }) => cmCycleControllerFindAllCyclesByCaseId(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindAllCyclesByCaseIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>>
export type CmCycleControllerFindAllCyclesByCaseIdInfiniteQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCmCycleControllerFindAllCyclesByCaseIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindAllCyclesByCaseIdInfiniteQueryOptions(caseId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerFindAllCyclesByCaseIdQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindAllCyclesByCaseIdQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>> = ({ signal }) => cmCycleControllerFindAllCyclesByCaseId(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindAllCyclesByCaseIdQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>>
export type CmCycleControllerFindAllCyclesByCaseIdQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCmCycleControllerFindAllCyclesByCaseId = <TData = Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllCyclesByCaseId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindAllCyclesByCaseIdQueryOptions(caseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 상세 조회
 */
export const cmCycleControllerFindOne = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerFindOne200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerFindOneQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}`] as const;
    }

    
export const getCmCycleControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindOne>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindOneQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindOne>>> = ({ signal }) => cmCycleControllerFindOne(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindOne>>>
export type CmCycleControllerFindOneInfiniteQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCmCycleControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindOne>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindOneInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindOneQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindOne>>> = ({ signal }) => cmCycleControllerFindOne(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindOne>>>
export type CmCycleControllerFindOneQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCmCycleControllerFindOne = <TData = Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindOne>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindOneQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 메모 수정
 */
export const cmCycleControllerUpdateCycleMemo = (
    cycleId: string,
    updateCycleMemoDtoModel: UpdateCycleMemoDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerUpdateCycleMemo200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/memo`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCycleMemoDtoModel
    },
      );
    }
  


export const getCmCycleControllerUpdateCycleMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>, {cycleId: string;data: UpdateCycleMemoDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerUpdateCycleMemo(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerUpdateCycleMemoMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>>
    export type CmCycleControllerUpdateCycleMemoMutationBody = UpdateCycleMemoDtoModel
    export type CmCycleControllerUpdateCycleMemoMutationError = unknown

    /**
 * @summary 사이클 메모 수정
 */
export const useCmCycleControllerUpdateCycleMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerUpdateCycleMemo>>,
        TError,
        {cycleId: string;data: UpdateCycleMemoDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerUpdateCycleMemoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 세션 목록 조회
 */
export const cmCycleControllerFindAllSessionsByCycleId = (
    cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerFindAllSessionsByCycleId200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/sessions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmCycleControllerFindAllSessionsByCycleIdQueryKey = (cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/sessions`, ...(params ? [params]: [])] as const;
    }

    
export const getCmCycleControllerFindAllSessionsByCycleIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, CmCycleControllerFindAllSessionsByCycleIdParams['page']>, TError = unknown>(cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, QueryKey, CmCycleControllerFindAllSessionsByCycleIdParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindAllSessionsByCycleIdQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, QueryKey, CmCycleControllerFindAllSessionsByCycleIdParams['page']> = ({ signal, pageParam }) => cmCycleControllerFindAllSessionsByCycleId(cycleId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, QueryKey, CmCycleControllerFindAllSessionsByCycleIdParams['page']> & { queryKey: QueryKey }
}

export type CmCycleControllerFindAllSessionsByCycleIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>>
export type CmCycleControllerFindAllSessionsByCycleIdInfiniteQueryError = unknown

/**
 * @summary 사이클 세션 목록 조회
 */
export const useCmCycleControllerFindAllSessionsByCycleIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, CmCycleControllerFindAllSessionsByCycleIdParams['page']>, TError = unknown>(
 cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData, Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, QueryKey, CmCycleControllerFindAllSessionsByCycleIdParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindAllSessionsByCycleIdInfiniteQueryOptions(cycleId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerFindAllSessionsByCycleIdQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError = unknown>(cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindAllSessionsByCycleIdQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>> = ({ signal }) => cmCycleControllerFindAllSessionsByCycleId(cycleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindAllSessionsByCycleIdQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>>
export type CmCycleControllerFindAllSessionsByCycleIdQueryError = unknown

/**
 * @summary 사이클 세션 목록 조회
 */
export const useCmCycleControllerFindAllSessionsByCycleId = <TData = Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError = unknown>(
 cycleId: string,
    params?: CmCycleControllerFindAllSessionsByCycleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindAllSessionsByCycleId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindAllSessionsByCycleIdQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 코칭 플랜 조회
 */
export const cmCycleControllerFindCoachingPlanByCycleId = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerFindCoachingPlanByCycleId200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerFindCoachingPlanByCycleIdQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan`] as const;
    }

    
export const getCmCycleControllerFindCoachingPlanByCycleIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindCoachingPlanByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>> = ({ signal }) => cmCycleControllerFindCoachingPlanByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindCoachingPlanByCycleIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>>
export type CmCycleControllerFindCoachingPlanByCycleIdInfiniteQueryError = unknown

/**
 * @summary 사이클 코칭 플랜 조회
 */
export const useCmCycleControllerFindCoachingPlanByCycleIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindCoachingPlanByCycleIdInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerFindCoachingPlanByCycleIdQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindCoachingPlanByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>> = ({ signal }) => cmCycleControllerFindCoachingPlanByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindCoachingPlanByCycleIdQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>>
export type CmCycleControllerFindCoachingPlanByCycleIdQueryError = unknown

/**
 * @summary 사이클 코칭 플랜 조회
 */
export const useCmCycleControllerFindCoachingPlanByCycleId = <TData = Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingPlanByCycleId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindCoachingPlanByCycleIdQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 코칭 리포트 조회
 */
export const cmCycleControllerFindCoachingReportByCycleId = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerFindCoachingReportByCycleId200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerFindCoachingReportByCycleIdQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-report`] as const;
    }

    
export const getCmCycleControllerFindCoachingReportByCycleIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindCoachingReportByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>> = ({ signal }) => cmCycleControllerFindCoachingReportByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindCoachingReportByCycleIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>>
export type CmCycleControllerFindCoachingReportByCycleIdInfiniteQueryError = unknown

/**
 * @summary 사이클 코칭 리포트 조회
 */
export const useCmCycleControllerFindCoachingReportByCycleIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindCoachingReportByCycleIdInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerFindCoachingReportByCycleIdQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerFindCoachingReportByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>> = ({ signal }) => cmCycleControllerFindCoachingReportByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerFindCoachingReportByCycleIdQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>>
export type CmCycleControllerFindCoachingReportByCycleIdQueryError = unknown

/**
 * @summary 사이클 코칭 리포트 조회
 */
export const useCmCycleControllerFindCoachingReportByCycleId = <TData = Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerFindCoachingReportByCycleId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerFindCoachingReportByCycleIdQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 코칭 보류 전환 (CPM)
 */
export const cmCycleControllerHoldCycle = (
    cycleId: string,
    holdCycleDtoModel: HoldCycleDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerHoldCycle200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/hold`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: holdCycleDtoModel
    },
      );
    }
  


export const getCmCycleControllerHoldCycleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>, TError,{cycleId: string;data: HoldCycleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>, TError,{cycleId: string;data: HoldCycleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>, {cycleId: string;data: HoldCycleDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerHoldCycle(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerHoldCycleMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>>
    export type CmCycleControllerHoldCycleMutationBody = HoldCycleDtoModel
    export type CmCycleControllerHoldCycleMutationError = unknown

    /**
 * @summary 사이클 코칭 보류 전환 (CPM)
 */
export const useCmCycleControllerHoldCycle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>, TError,{cycleId: string;data: HoldCycleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerHoldCycle>>,
        TError,
        {cycleId: string;data: HoldCycleDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerHoldCycleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 코칭 보류 해제 (CPM)
 */
export const cmCycleControllerReleaseCycleHold = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerReleaseCycleHold200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/hold`, method: 'DELETE'
    },
      );
    }
  


export const getCmCycleControllerReleaseCycleHoldMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerReleaseCycleHold(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerReleaseCycleHoldMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>>
    
    export type CmCycleControllerReleaseCycleHoldMutationError = unknown

    /**
 * @summary 사이클 코칭 보류 해제 (CPM)
 */
export const useCmCycleControllerReleaseCycleHold = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerReleaseCycleHold>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerReleaseCycleHoldMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 코칭 플랜 승인 (CPM)
 */
export const cmCycleControllerApproveCoachingPlan = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerApproveCoachingPlan200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/approvals`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerApproveCoachingPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerApproveCoachingPlan(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerApproveCoachingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>>
    
    export type CmCycleControllerApproveCoachingPlanMutationError = unknown

    /**
 * @summary 사이클 코칭 플랜 승인 (CPM)
 */
export const useCmCycleControllerApproveCoachingPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerApproveCoachingPlan>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerApproveCoachingPlanMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 코칭 리포트 승인 (CPM)
 */
export const cmCycleControllerApproveCoachingReport = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerApproveCoachingReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/approvals`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerApproveCoachingReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerApproveCoachingReport(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerApproveCoachingReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>>
    
    export type CmCycleControllerApproveCoachingReportMutationError = unknown

    /**
 * @summary 사이클 코칭 리포트 승인 (CPM)
 */
export const useCmCycleControllerApproveCoachingReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerApproveCoachingReport>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerApproveCoachingReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 플랜 항목에 피드백 작성 (CPM)
 */
export const cmCycleControllerCreateCoachingPlanFeedback = (
    cycleId: string,
    createCoachingPlanFeedbackDtoModel: CreateCoachingPlanFeedbackDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerCreateCoachingPlanFeedback201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCoachingPlanFeedbackDtoModel
    },
      );
    }
  


export const getCmCycleControllerCreateCoachingPlanFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>, TError,{cycleId: string;data: CreateCoachingPlanFeedbackDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>, TError,{cycleId: string;data: CreateCoachingPlanFeedbackDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>, {cycleId: string;data: CreateCoachingPlanFeedbackDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerCreateCoachingPlanFeedback(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerCreateCoachingPlanFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>>
    export type CmCycleControllerCreateCoachingPlanFeedbackMutationBody = CreateCoachingPlanFeedbackDtoModel
    export type CmCycleControllerCreateCoachingPlanFeedbackMutationError = unknown

    /**
 * @summary 코칭 플랜 항목에 피드백 작성 (CPM)
 */
export const useCmCycleControllerCreateCoachingPlanFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>, TError,{cycleId: string;data: CreateCoachingPlanFeedbackDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerCreateCoachingPlanFeedback>>,
        TError,
        {cycleId: string;data: CreateCoachingPlanFeedbackDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerCreateCoachingPlanFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 플랜 피드백 목록 (CPM)
 */
export const cmCycleControllerListCoachingPlanFeedbacks = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerListCoachingPlanFeedbacks200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedbacks`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerListCoachingPlanFeedbacksQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedbacks`] as const;
    }

    
export const getCmCycleControllerListCoachingPlanFeedbacksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerListCoachingPlanFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>> = ({ signal }) => cmCycleControllerListCoachingPlanFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerListCoachingPlanFeedbacksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>>
export type CmCycleControllerListCoachingPlanFeedbacksInfiniteQueryError = unknown

/**
 * @summary 코칭 플랜 피드백 목록 (CPM)
 */
export const useCmCycleControllerListCoachingPlanFeedbacksInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerListCoachingPlanFeedbacksInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerListCoachingPlanFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerListCoachingPlanFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>> = ({ signal }) => cmCycleControllerListCoachingPlanFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerListCoachingPlanFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>>
export type CmCycleControllerListCoachingPlanFeedbacksQueryError = unknown

/**
 * @summary 코칭 플랜 피드백 목록 (CPM)
 */
export const useCmCycleControllerListCoachingPlanFeedbacks = <TData = Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingPlanFeedbacks>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerListCoachingPlanFeedbacksQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 플랜 피드백을 코치에게 전달 (CPM)
 */
export const cmCycleControllerDeliverCoachingPlanFeedback = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerDeliverCoachingPlanFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedback-deliveries`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerDeliverCoachingPlanFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerDeliverCoachingPlanFeedback(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerDeliverCoachingPlanFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>>
    
    export type CmCycleControllerDeliverCoachingPlanFeedbackMutationError = unknown

    /**
 * @summary 코칭 플랜 피드백을 코치에게 전달 (CPM)
 */
export const useCmCycleControllerDeliverCoachingPlanFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingPlanFeedback>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerDeliverCoachingPlanFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 리포트에 피드백 작성 (CPM)
 */
export const cmCycleControllerCreateCoachingReportFeedback = (
    cycleId: string,
    createCoachingReportFeedbackDtoModel: CreateCoachingReportFeedbackDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerCreateCoachingReportFeedback201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedbacks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCoachingReportFeedbackDtoModel
    },
      );
    }
  


export const getCmCycleControllerCreateCoachingReportFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>, TError,{cycleId: string;data: CreateCoachingReportFeedbackDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>, TError,{cycleId: string;data: CreateCoachingReportFeedbackDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>, {cycleId: string;data: CreateCoachingReportFeedbackDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerCreateCoachingReportFeedback(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerCreateCoachingReportFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>>
    export type CmCycleControllerCreateCoachingReportFeedbackMutationBody = CreateCoachingReportFeedbackDtoModel
    export type CmCycleControllerCreateCoachingReportFeedbackMutationError = unknown

    /**
 * @summary 코칭 리포트에 피드백 작성 (CPM)
 */
export const useCmCycleControllerCreateCoachingReportFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>, TError,{cycleId: string;data: CreateCoachingReportFeedbackDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerCreateCoachingReportFeedback>>,
        TError,
        {cycleId: string;data: CreateCoachingReportFeedbackDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerCreateCoachingReportFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 리포트 피드백 목록 (CPM)
 */
export const cmCycleControllerListCoachingReportFeedbacks = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerListCoachingReportFeedbacks200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedbacks`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerListCoachingReportFeedbacksQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedbacks`] as const;
    }

    
export const getCmCycleControllerListCoachingReportFeedbacksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerListCoachingReportFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>> = ({ signal }) => cmCycleControllerListCoachingReportFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerListCoachingReportFeedbacksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>>
export type CmCycleControllerListCoachingReportFeedbacksInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 피드백 목록 (CPM)
 */
export const useCmCycleControllerListCoachingReportFeedbacksInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerListCoachingReportFeedbacksInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerListCoachingReportFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerListCoachingReportFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>> = ({ signal }) => cmCycleControllerListCoachingReportFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerListCoachingReportFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>>
export type CmCycleControllerListCoachingReportFeedbacksQueryError = unknown

/**
 * @summary 코칭 리포트 피드백 목록 (CPM)
 */
export const useCmCycleControllerListCoachingReportFeedbacks = <TData = Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerListCoachingReportFeedbacks>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerListCoachingReportFeedbacksQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 리포트 피드백을 코치에게 전달 (CPM)
 */
export const cmCycleControllerDeliverCoachingReportFeedback = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerDeliverCoachingReportFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedback-deliveries`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerDeliverCoachingReportFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerDeliverCoachingReportFeedback(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerDeliverCoachingReportFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>>
    
    export type CmCycleControllerDeliverCoachingReportFeedbackMutationError = unknown

    /**
 * @summary 코칭 리포트 피드백을 코치에게 전달 (CPM)
 */
export const useCmCycleControllerDeliverCoachingReportFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerDeliverCoachingReportFeedback>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerDeliverCoachingReportFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전달 전 코칭 플랜 피드백 수정 (CPM)
 */
export const cmCycleControllerUpdateCoachingPlanFeedback = (
    cycleId: string,
    feedbackId: string,
    updateCoachingDocumentFeedbackDtoModel: UpdateCoachingDocumentFeedbackDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerUpdateCoachingPlanFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedbacks/${feedbackId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachingDocumentFeedbackDtoModel
    },
      );
    }
  


export const getCmCycleControllerUpdateCoachingPlanFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>, {cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}> = (props) => {
          const {cycleId,feedbackId,data} = props ?? {};

          return  cmCycleControllerUpdateCoachingPlanFeedback(cycleId,feedbackId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerUpdateCoachingPlanFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>>
    export type CmCycleControllerUpdateCoachingPlanFeedbackMutationBody = UpdateCoachingDocumentFeedbackDtoModel
    export type CmCycleControllerUpdateCoachingPlanFeedbackMutationError = unknown

    /**
 * @summary 전달 전 코칭 플랜 피드백 수정 (CPM)
 */
export const useCmCycleControllerUpdateCoachingPlanFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingPlanFeedback>>,
        TError,
        {cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerUpdateCoachingPlanFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전달 전 코칭 플랜 피드백 삭제 (CPM)
 */
export const cmCycleControllerDeleteCoachingPlanFeedback = (
    cycleId: string,
    feedbackId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerDeleteCoachingPlanFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/feedbacks/${feedbackId}`, method: 'DELETE'
    },
      );
    }
  


export const getCmCycleControllerDeleteCoachingPlanFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>, {cycleId: string;feedbackId: string}> = (props) => {
          const {cycleId,feedbackId} = props ?? {};

          return  cmCycleControllerDeleteCoachingPlanFeedback(cycleId,feedbackId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerDeleteCoachingPlanFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>>
    
    export type CmCycleControllerDeleteCoachingPlanFeedbackMutationError = unknown

    /**
 * @summary 전달 전 코칭 플랜 피드백 삭제 (CPM)
 */
export const useCmCycleControllerDeleteCoachingPlanFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingPlanFeedback>>,
        TError,
        {cycleId: string;feedbackId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerDeleteCoachingPlanFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전달 전 코칭 리포트 피드백 수정 (CPM)
 */
export const cmCycleControllerUpdateCoachingReportFeedback = (
    cycleId: string,
    feedbackId: string,
    updateCoachingDocumentFeedbackDtoModel: UpdateCoachingDocumentFeedbackDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerUpdateCoachingReportFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedbacks/${feedbackId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachingDocumentFeedbackDtoModel
    },
      );
    }
  


export const getCmCycleControllerUpdateCoachingReportFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>, {cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}> = (props) => {
          const {cycleId,feedbackId,data} = props ?? {};

          return  cmCycleControllerUpdateCoachingReportFeedback(cycleId,feedbackId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerUpdateCoachingReportFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>>
    export type CmCycleControllerUpdateCoachingReportFeedbackMutationBody = UpdateCoachingDocumentFeedbackDtoModel
    export type CmCycleControllerUpdateCoachingReportFeedbackMutationError = unknown

    /**
 * @summary 전달 전 코칭 리포트 피드백 수정 (CPM)
 */
export const useCmCycleControllerUpdateCoachingReportFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerUpdateCoachingReportFeedback>>,
        TError,
        {cycleId: string;feedbackId: string;data: UpdateCoachingDocumentFeedbackDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerUpdateCoachingReportFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전달 전 코칭 리포트 피드백 삭제 (CPM)
 */
export const cmCycleControllerDeleteCoachingReportFeedback = (
    cycleId: string,
    feedbackId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerDeleteCoachingReportFeedback200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/feedbacks/${feedbackId}`, method: 'DELETE'
    },
      );
    }
  


export const getCmCycleControllerDeleteCoachingReportFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>, {cycleId: string;feedbackId: string}> = (props) => {
          const {cycleId,feedbackId} = props ?? {};

          return  cmCycleControllerDeleteCoachingReportFeedback(cycleId,feedbackId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerDeleteCoachingReportFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>>
    
    export type CmCycleControllerDeleteCoachingReportFeedbackMutationError = unknown

    /**
 * @summary 전달 전 코칭 리포트 피드백 삭제 (CPM)
 */
export const useCmCycleControllerDeleteCoachingReportFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerDeleteCoachingReportFeedback>>,
        TError,
        {cycleId: string;feedbackId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerDeleteCoachingReportFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 즉시 PENDING 으로 응답하고, 결과는 AI 서버 콜백으로 채워진다.
 * @summary 코칭 플랜 AI 1차 검수 초안 생성 요청 (CPM)
 */
export const cmCycleControllerRequestCoachingPlanAiReview = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerRequestCoachingPlanAiReview201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/ai-review`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerRequestCoachingPlanAiReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerRequestCoachingPlanAiReview(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerRequestCoachingPlanAiReviewMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>>
    
    export type CmCycleControllerRequestCoachingPlanAiReviewMutationError = unknown

    /**
 * @summary 코칭 플랜 AI 1차 검수 초안 생성 요청 (CPM)
 */
export const useCmCycleControllerRequestCoachingPlanAiReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerRequestCoachingPlanAiReview>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerRequestCoachingPlanAiReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 아직 생성한 적이 없으면 null.
 * @summary 코칭 플랜 AI 1차 검수 초안 조회 (CPM)
 */
export const cmCycleControllerGetCoachingPlanAiReview = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetCoachingPlanAiReview200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/ai-review`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerGetCoachingPlanAiReviewQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/ai-review`] as const;
    }

    
export const getCmCycleControllerGetCoachingPlanAiReviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingPlanAiReviewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>> = ({ signal }) => cmCycleControllerGetCoachingPlanAiReview(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingPlanAiReviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>>
export type CmCycleControllerGetCoachingPlanAiReviewInfiniteQueryError = unknown

/**
 * @summary 코칭 플랜 AI 1차 검수 초안 조회 (CPM)
 */
export const useCmCycleControllerGetCoachingPlanAiReviewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingPlanAiReviewInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetCoachingPlanAiReviewQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingPlanAiReviewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>> = ({ signal }) => cmCycleControllerGetCoachingPlanAiReview(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingPlanAiReviewQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>>
export type CmCycleControllerGetCoachingPlanAiReviewQueryError = unknown

/**
 * @summary 코칭 플랜 AI 1차 검수 초안 조회 (CPM)
 */
export const useCmCycleControllerGetCoachingPlanAiReview = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingPlanAiReview>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingPlanAiReviewQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 채택한 지적이 정식 피드백이 된다. 같은 항목의 여러 지적은 하나로 합쳐진다.
 * @summary 코칭 플랜 AI 검수 초안 채택 (CPM)
 */
export const cmCycleControllerAdoptCoachingPlanAiReview = (
    cycleId: string,
    adoptCoachingDocumentAiReviewDtoModel: AdoptCoachingDocumentAiReviewDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerAdoptCoachingPlanAiReview201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plan/ai-review/adoptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adoptCoachingDocumentAiReviewDtoModel
    },
      );
    }
  


export const getCmCycleControllerAdoptCoachingPlanAiReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>, {cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerAdoptCoachingPlanAiReview(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerAdoptCoachingPlanAiReviewMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>>
    export type CmCycleControllerAdoptCoachingPlanAiReviewMutationBody = AdoptCoachingDocumentAiReviewDtoModel
    export type CmCycleControllerAdoptCoachingPlanAiReviewMutationError = unknown

    /**
 * @summary 코칭 플랜 AI 검수 초안 채택 (CPM)
 */
export const useCmCycleControllerAdoptCoachingPlanAiReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingPlanAiReview>>,
        TError,
        {cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerAdoptCoachingPlanAiReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 즉시 PENDING 으로 응답하고, 결과는 AI 서버 콜백으로 채워진다.
 * @summary 코칭 리포트 AI 1차 검수 초안 생성 요청 (CPM)
 */
export const cmCycleControllerRequestCoachingReportAiReview = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCycleControllerRequestCoachingReportAiReview201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/ai-review`, method: 'POST'
    },
      );
    }
  


export const getCmCycleControllerRequestCoachingReportAiReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCycleControllerRequestCoachingReportAiReview(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerRequestCoachingReportAiReviewMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>>
    
    export type CmCycleControllerRequestCoachingReportAiReviewMutationError = unknown

    /**
 * @summary 코칭 리포트 AI 1차 검수 초안 생성 요청 (CPM)
 */
export const useCmCycleControllerRequestCoachingReportAiReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerRequestCoachingReportAiReview>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerRequestCoachingReportAiReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 아직 생성한 적이 없으면 null.
 * @summary 코칭 리포트 AI 1차 검수 초안 조회 (CPM)
 */
export const cmCycleControllerGetCoachingReportAiReview = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetCoachingReportAiReview200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/ai-review`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerGetCoachingReportAiReviewQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/ai-review`] as const;
    }

    
export const getCmCycleControllerGetCoachingReportAiReviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingReportAiReviewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>> = ({ signal }) => cmCycleControllerGetCoachingReportAiReview(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingReportAiReviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>>
export type CmCycleControllerGetCoachingReportAiReviewInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 AI 1차 검수 초안 조회 (CPM)
 */
export const useCmCycleControllerGetCoachingReportAiReviewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingReportAiReviewInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetCoachingReportAiReviewQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachingReportAiReviewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>> = ({ signal }) => cmCycleControllerGetCoachingReportAiReview(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachingReportAiReviewQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>>
export type CmCycleControllerGetCoachingReportAiReviewQueryError = unknown

/**
 * @summary 코칭 리포트 AI 1차 검수 초안 조회 (CPM)
 */
export const useCmCycleControllerGetCoachingReportAiReview = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachingReportAiReview>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachingReportAiReviewQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 리포트 피드백은 문서당 한 건이라 채택한 지적들이 하나로 합쳐진다.
 * @summary 코칭 리포트 AI 검수 초안 채택 (CPM)
 */
export const cmCycleControllerAdoptCoachingReportAiReview = (
    cycleId: string,
    adoptCoachingDocumentAiReviewDtoModel: AdoptCoachingDocumentAiReviewDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerAdoptCoachingReportAiReview201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-report/ai-review/adoptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adoptCoachingDocumentAiReviewDtoModel
    },
      );
    }
  


export const getCmCycleControllerAdoptCoachingReportAiReviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>, {cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerAdoptCoachingReportAiReview(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerAdoptCoachingReportAiReviewMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>>
    export type CmCycleControllerAdoptCoachingReportAiReviewMutationBody = AdoptCoachingDocumentAiReviewDtoModel
    export type CmCycleControllerAdoptCoachingReportAiReviewMutationError = unknown

    /**
 * @summary 코칭 리포트 AI 검수 초안 채택 (CPM)
 */
export const useCmCycleControllerAdoptCoachingReportAiReview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>, TError,{cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerAdoptCoachingReportAiReview>>,
        TError,
        {cycleId: string;data: AdoptCoachingDocumentAiReviewDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerAdoptCoachingReportAiReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 보낸 다운로드 콜 요청을 확인합니다. 요청이 없으면 request 가 null.
 * @summary 다운로드 콜 요청 조회 (CPM)
 */
export const cmCycleControllerGetDownloadCallRequest = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetDownloadCallRequest200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/download-call-request`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerGetDownloadCallRequestQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/download-call-request`] as const;
    }

    
export const getCmCycleControllerGetDownloadCallRequestInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetDownloadCallRequestQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>> = ({ signal }) => cmCycleControllerGetDownloadCallRequest(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetDownloadCallRequestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>>
export type CmCycleControllerGetDownloadCallRequestInfiniteQueryError = unknown

/**
 * @summary 다운로드 콜 요청 조회 (CPM)
 */
export const useCmCycleControllerGetDownloadCallRequestInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetDownloadCallRequestInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetDownloadCallRequestQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetDownloadCallRequestQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>> = ({ signal }) => cmCycleControllerGetDownloadCallRequest(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetDownloadCallRequestQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>>
export type CmCycleControllerGetDownloadCallRequestQueryError = unknown

/**
 * @summary 다운로드 콜 요청 조회 (CPM)
 */
export const useCmCycleControllerGetDownloadCallRequest = <TData = Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetDownloadCallRequest>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetDownloadCallRequestQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 콜을 마친 뒤 요청을 완료로 바꿉니다. 요청이 없으면 404, 이미 완료했으면 409를 반환합니다.
 * @summary 다운로드 콜 요청 완료 처리 (CPM)
 */
export const cmCycleControllerUpdateDownloadCallRequest = (
    cycleId: string,
    updateDownloadCallRequestDtoModel: UpdateDownloadCallRequestDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerUpdateDownloadCallRequest200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/download-call-request`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDownloadCallRequestDtoModel
    },
      );
    }
  


export const getCmCycleControllerUpdateDownloadCallRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>, TError,{cycleId: string;data: UpdateDownloadCallRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>, TError,{cycleId: string;data: UpdateDownloadCallRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>, {cycleId: string;data: UpdateDownloadCallRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerUpdateDownloadCallRequest(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerUpdateDownloadCallRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>>
    export type CmCycleControllerUpdateDownloadCallRequestMutationBody = UpdateDownloadCallRequestDtoModel
    export type CmCycleControllerUpdateDownloadCallRequestMutationError = unknown

    /**
 * @summary 다운로드 콜 요청 완료 처리 (CPM)
 */
export const useCmCycleControllerUpdateDownloadCallRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>, TError,{cycleId: string;data: UpdateDownloadCallRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerUpdateDownloadCallRequest>>,
        TError,
        {cycleId: string;data: UpdateDownloadCallRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerUpdateDownloadCallRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 보는 메모를 CPM 도 같은 내용으로 확인합니다. 메모가 없으면 memo 가 null.
 * @summary 코치 배정 메모 조회 (CPM)
 */
export const cmCycleControllerGetCoachAssignmentMemo = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCycleControllerGetCoachAssignmentMemo200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coach-assignment-memo`, method: 'GET', signal
    },
      );
    }
  

export const getCmCycleControllerGetCoachAssignmentMemoQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coach-assignment-memo`] as const;
    }

    
export const getCmCycleControllerGetCoachAssignmentMemoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachAssignmentMemoQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>> = ({ signal }) => cmCycleControllerGetCoachAssignmentMemo(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachAssignmentMemoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>>
export type CmCycleControllerGetCoachAssignmentMemoInfiniteQueryError = unknown

/**
 * @summary 코치 배정 메모 조회 (CPM)
 */
export const useCmCycleControllerGetCoachAssignmentMemoInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachAssignmentMemoInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCycleControllerGetCoachAssignmentMemoQueryOptions = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCycleControllerGetCoachAssignmentMemoQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>> = ({ signal }) => cmCycleControllerGetCoachAssignmentMemo(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCycleControllerGetCoachAssignmentMemoQueryResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>>
export type CmCycleControllerGetCoachAssignmentMemoQueryError = unknown

/**
 * @summary 코치 배정 메모 조회 (CPM)
 */
export const useCmCycleControllerGetCoachAssignmentMemo = <TData = Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCycleControllerGetCoachAssignmentMemoQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 고객사 피드백을 함께 받아 사이클을 종료합니다. 완료되지 않은 세션이 남은 사이클은 조기종결 사유가 필요합니다.
 * @summary 사이클 종료 (CPM)
 */
export const cmCycleControllerCompleteCycle = (
    cycleId: string,
    completeCycleDtoModel: CompleteCycleDtoModel,
 ) => {
      
      
      return apiClient<CmCycleControllerCompleteCycle200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/completion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeCycleDtoModel
    },
      );
    }
  


export const getCmCycleControllerCompleteCycleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>, TError,{cycleId: string;data: CompleteCycleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>, TError,{cycleId: string;data: CompleteCycleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>, {cycleId: string;data: CompleteCycleDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCycleControllerCompleteCycle(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCycleControllerCompleteCycleMutationResult = NonNullable<Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>>
    export type CmCycleControllerCompleteCycleMutationBody = CompleteCycleDtoModel
    export type CmCycleControllerCompleteCycleMutationError = unknown

    /**
 * @summary 사이클 종료 (CPM)
 */
export const useCmCycleControllerCompleteCycle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>, TError,{cycleId: string;data: CompleteCycleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCycleControllerCompleteCycle>>,
        TError,
        {cycleId: string;data: CompleteCycleDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCycleControllerCompleteCycleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 코칭 매니저 매칭을 등록합니다.
 * @summary 코칭 매니저 매칭 등록
 */
export const cmMatchingControllerCreateMatchings = (
    createMatchingsDtoModel: CreateMatchingsDtoModel,
 ) => {
      
      
      return apiClient<CmMatchingControllerCreateMatchings201>(
      {url: `/v2/coaching-managers/me/matchings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMatchingsDtoModel
    },
      );
    }
  


export const getCmMatchingControllerCreateMatchingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>, TError,{data: CreateMatchingsDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>, TError,{data: CreateMatchingsDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>, {data: CreateMatchingsDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmMatchingControllerCreateMatchings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmMatchingControllerCreateMatchingsMutationResult = NonNullable<Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>>
    export type CmMatchingControllerCreateMatchingsMutationBody = CreateMatchingsDtoModel
    export type CmMatchingControllerCreateMatchingsMutationError = unknown

    /**
 * @summary 코칭 매니저 매칭 등록
 */
export const useCmMatchingControllerCreateMatchings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>, TError,{data: CreateMatchingsDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmMatchingControllerCreateMatchings>>,
        TError,
        {data: CreateMatchingsDtoModel},
        TContext
      > => {

      const mutationOptions = getCmMatchingControllerCreateMatchingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 케이스에게 매칭 이메일 알림을 전송합니다.
 * @summary 매칭 이메일 알림 전송
 */
export const cmMatchingControllerSendMatchingNotification = (
    sendMatchingNotificationDtoModel: SendMatchingNotificationDtoModel,
 ) => {
      
      
      return apiClient<CmMatchingControllerSendMatchingNotification200>(
      {url: `/v2/coaching-managers/me/matchings/notify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendMatchingNotificationDtoModel
    },
      );
    }
  


export const getCmMatchingControllerSendMatchingNotificationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>, TError,{data: SendMatchingNotificationDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>, TError,{data: SendMatchingNotificationDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>, {data: SendMatchingNotificationDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmMatchingControllerSendMatchingNotification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmMatchingControllerSendMatchingNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>>
    export type CmMatchingControllerSendMatchingNotificationMutationBody = SendMatchingNotificationDtoModel
    export type CmMatchingControllerSendMatchingNotificationMutationError = unknown

    /**
 * @summary 매칭 이메일 알림 전송
 */
export const useCmMatchingControllerSendMatchingNotification = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>, TError,{data: SendMatchingNotificationDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmMatchingControllerSendMatchingNotification>>,
        TError,
        {data: SendMatchingNotificationDtoModel},
        TContext
      > => {

      const mutationOptions = getCmMatchingControllerSendMatchingNotificationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 해당 사이클의 코치 배정을 해제합니다 (coachId를 null로 설정).
 * @summary 코치 매칭 배정 해제
 */
export const cmMatchingControllerDeleteCoachAssignment = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmMatchingControllerDeleteCoachAssignment200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coach-assignment`, method: 'DELETE'
    },
      );
    }
  


export const getCmMatchingControllerDeleteCoachAssignmentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmMatchingControllerDeleteCoachAssignment(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmMatchingControllerDeleteCoachAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>>
    
    export type CmMatchingControllerDeleteCoachAssignmentMutationError = unknown

    /**
 * @summary 코치 매칭 배정 해제
 */
export const useCmMatchingControllerDeleteCoachAssignment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmMatchingControllerDeleteCoachAssignment>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmMatchingControllerDeleteCoachAssignmentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 코칭 매니저 문서를 발송합니다.
 * @summary 코칭 매니저 문서 발송
 */
export const cmDocsControllerSendToHr = (
    sendToHrDtoModel: SendToHrDtoModel,
 ) => {
      
      
      return apiClient<CmDocsControllerSendToHr200>(
      {url: `/v2/coaching-managers/me/send-docs-to-hr`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendToHrDtoModel
    },
      );
    }
  


export const getCmDocsControllerSendToHrMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDocsControllerSendToHr>>, TError,{data: SendToHrDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmDocsControllerSendToHr>>, TError,{data: SendToHrDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmDocsControllerSendToHr>>, {data: SendToHrDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmDocsControllerSendToHr(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmDocsControllerSendToHrMutationResult = NonNullable<Awaited<ReturnType<typeof cmDocsControllerSendToHr>>>
    export type CmDocsControllerSendToHrMutationBody = SendToHrDtoModel
    export type CmDocsControllerSendToHrMutationError = unknown

    /**
 * @summary 코칭 매니저 문서 발송
 */
export const useCmDocsControllerSendToHr = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDocsControllerSendToHr>>, TError,{data: SendToHrDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmDocsControllerSendToHr>>,
        TError,
        {data: SendToHrDtoModel},
        TContext
      > => {

      const mutationOptions = getCmDocsControllerSendToHrMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코칭 매니저 목록을 조회합니다.
 * @summary 코칭 매니저 목록 조회
 */
export const cmControllerGetCoachingManagers = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmControllerGetCoachingManagers200>(
      {url: `/v2/coaching-managers`, method: 'GET', signal
    },
      );
    }
  

export const getCmControllerGetCoachingManagersQueryKey = () => {
    return [`/v2/coaching-managers`] as const;
    }

    
export const getCmControllerGetCoachingManagersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmControllerGetCoachingManagersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>> = ({ signal }) => cmControllerGetCoachingManagers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData> & { queryKey: QueryKey }
}

export type CmControllerGetCoachingManagersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>>
export type CmControllerGetCoachingManagersInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저 목록 조회
 */
export const useCmControllerGetCoachingManagersInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmControllerGetCoachingManagersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmControllerGetCoachingManagersQueryOptions = <TData = Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmControllerGetCoachingManagersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>> = ({ signal }) => cmControllerGetCoachingManagers(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData> & { queryKey: QueryKey }
}

export type CmControllerGetCoachingManagersQueryResult = NonNullable<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>>
export type CmControllerGetCoachingManagersQueryError = unknown

/**
 * @summary 코칭 매니저 목록 조회
 */
export const useCmControllerGetCoachingManagers = <TData = Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmControllerGetCoachingManagers>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmControllerGetCoachingManagersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치 목록을 조회합니다.
 * @summary 코치 목록 조회
 */
export const cmCoachControllerGetCoaches = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCoachControllerGetCoaches200>(
      {url: `/v2/coaching-managers/me/coaches`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachControllerGetCoachesQueryKey = () => {
    return [`/v2/coaching-managers/me/coaches`] as const;
    }

    
export const getCmCoachControllerGetCoachesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>> = ({ signal }) => cmCoachControllerGetCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>>
export type CmCoachControllerGetCoachesInfiniteQueryError = unknown

/**
 * @summary 코치 목록 조회
 */
export const useCmCoachControllerGetCoachesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachControllerGetCoachesQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>> = ({ signal }) => cmCoachControllerGetCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachesQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>>
export type CmCoachControllerGetCoachesQueryError = unknown

/**
 * @summary 코치 목록 조회
 */
export const useCmCoachControllerGetCoaches = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoaches>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 신규 코치를 생성합니다.
 * @summary 신규 코치 생성
 */
export const cmCoachControllerCreateCoach = (
    createCoachDtoModel: CreateCoachDtoModel,
 ) => {
      
      
      return apiClient<CmCoachControllerCreateCoach200>(
      {url: `/v2/coaching-managers/me/coaches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCoachDtoModel
    },
      );
    }
  


export const getCmCoachControllerCreateCoachMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>, TError,{data: CreateCoachDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>, TError,{data: CreateCoachDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>, {data: CreateCoachDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmCoachControllerCreateCoach(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachControllerCreateCoachMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>>
    export type CmCoachControllerCreateCoachMutationBody = CreateCoachDtoModel
    export type CmCoachControllerCreateCoachMutationError = unknown

    /**
 * @summary 신규 코치 생성
 */
export const useCmCoachControllerCreateCoach = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>, TError,{data: CreateCoachDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachControllerCreateCoach>>,
        TError,
        {data: CreateCoachDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachControllerCreateCoachMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 활동 중인 코치 목록을 조회합니다.
 * @summary 활동 중인 코치 목록 조회
 */
export const cmCoachControllerGetActiveCoaches = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCoachControllerGetActiveCoaches200>(
      {url: `/v2/coaching-managers/me/coaches/active`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachControllerGetActiveCoachesQueryKey = () => {
    return [`/v2/coaching-managers/me/coaches/active`] as const;
    }

    
export const getCmCoachControllerGetActiveCoachesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetActiveCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>> = ({ signal }) => cmCoachControllerGetActiveCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetActiveCoachesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>>
export type CmCoachControllerGetActiveCoachesInfiniteQueryError = unknown

/**
 * @summary 활동 중인 코치 목록 조회
 */
export const useCmCoachControllerGetActiveCoachesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetActiveCoachesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachControllerGetActiveCoachesQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetActiveCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>> = ({ signal }) => cmCoachControllerGetActiveCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetActiveCoachesQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>>
export type CmCoachControllerGetActiveCoachesQueryError = unknown

/**
 * @summary 활동 중인 코치 목록 조회
 */
export const useCmCoachControllerGetActiveCoaches = <TData = Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetActiveCoaches>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetActiveCoachesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치 정보를 업데이트합니다.
 * @summary 코치 정보 업데이트
 */
export const cmCoachControllerUpdateCoach = (
    coachId: string,
    updateCoachDtoModel: UpdateCoachDtoModel,
 ) => {
      
      
      return apiClient<CmCoachControllerUpdateCoach200>(
      {url: `/v2/coaching-managers/me/coaches/${coachId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachDtoModel
    },
      );
    }
  


export const getCmCoachControllerUpdateCoachMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>, TError,{coachId: string;data: UpdateCoachDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>, TError,{coachId: string;data: UpdateCoachDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>, {coachId: string;data: UpdateCoachDtoModel}> = (props) => {
          const {coachId,data} = props ?? {};

          return  cmCoachControllerUpdateCoach(coachId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachControllerUpdateCoachMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>>
    export type CmCoachControllerUpdateCoachMutationBody = UpdateCoachDtoModel
    export type CmCoachControllerUpdateCoachMutationError = unknown

    /**
 * @summary 코치 정보 업데이트
 */
export const useCmCoachControllerUpdateCoach = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>, TError,{coachId: string;data: UpdateCoachDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachControllerUpdateCoach>>,
        TError,
        {coachId: string;data: UpdateCoachDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachControllerUpdateCoachMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치 이메일/전화번호를 조회합니다.
 * @summary 코치 단건 조회
 */
export const cmCoachControllerGetCoach = (
    coachId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/coaches/${coachId}`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachControllerGetCoachQueryKey = (coachId: string,) => {
    return [`/v2/coaching-managers/me/coaches/${coachId}`] as const;
    }

    
export const getCmCoachControllerGetCoachInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>>, TError = unknown>(coachId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachQueryKey(coachId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>> = ({ signal }) => cmCoachControllerGetCoach(coachId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>>
export type CmCoachControllerGetCoachInfiniteQueryError = unknown

/**
 * @summary 코치 단건 조회
 */
export const useCmCoachControllerGetCoachInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>>, TError = unknown>(
 coachId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachInfiniteQueryOptions(coachId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachControllerGetCoachQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError = unknown>(coachId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachQueryKey(coachId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>> = ({ signal }) => cmCoachControllerGetCoach(coachId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>>
export type CmCoachControllerGetCoachQueryError = unknown

/**
 * @summary 코치 단건 조회
 */
export const useCmCoachControllerGetCoach = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError = unknown>(
 coachId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoach>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachQueryOptions(coachId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 사진을 스토리지에 올리고 공개 URL 을 돌려준다. 코치 저장은 별도로 호출한다.
 * @summary 코치 프로필 사진 업로드
 */
export const cmCoachControllerUploadCoachPhoto = (
    coachId: string,
    cmCoachControllerUploadCoachPhotoBody: CmCoachControllerUploadCoachPhotoBody,
 ) => {
      
      const formData = new FormData();
if(cmCoachControllerUploadCoachPhotoBody.file !== undefined) {
 formData.append('file', cmCoachControllerUploadCoachPhotoBody.file)
 }

      return apiClient<CmCoachControllerUploadCoachPhoto201>(
      {url: `/v2/coaching-managers/me/coaches/${coachId}/photo`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getCmCoachControllerUploadCoachPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>, TError,{coachId: string;data: CmCoachControllerUploadCoachPhotoBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>, TError,{coachId: string;data: CmCoachControllerUploadCoachPhotoBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>, {coachId: string;data: CmCoachControllerUploadCoachPhotoBody}> = (props) => {
          const {coachId,data} = props ?? {};

          return  cmCoachControllerUploadCoachPhoto(coachId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachControllerUploadCoachPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>>
    export type CmCoachControllerUploadCoachPhotoMutationBody = CmCoachControllerUploadCoachPhotoBody
    export type CmCoachControllerUploadCoachPhotoMutationError = unknown

    /**
 * @summary 코치 프로필 사진 업로드
 */
export const useCmCoachControllerUploadCoachPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>, TError,{coachId: string;data: CmCoachControllerUploadCoachPhotoBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachControllerUploadCoachPhoto>>,
        TError,
        {coachId: string;data: CmCoachControllerUploadCoachPhotoBody},
        TContext
      > => {

      const mutationOptions = getCmCoachControllerUploadCoachPhotoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치의 오픈 예약 슬랏 목록을 조회합니다.
 * @summary 코치 오픈 슬랏 조회
 */
export const cmCoachControllerGetCoachOpenSlots = (
    coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCoachControllerGetCoachOpenSlots200>(
      {url: `/v2/coaching-managers/me/coaches/${coachId}/slots`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmCoachControllerGetCoachOpenSlotsQueryKey = (coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams,) => {
    return [`/v2/coaching-managers/me/coaches/${coachId}/slots`, ...(params ? [params]: [])] as const;
    }

    
export const getCmCoachControllerGetCoachOpenSlotsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, CmCoachControllerGetCoachOpenSlotsParams['page']>, TError = unknown>(coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData, Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, QueryKey, CmCoachControllerGetCoachOpenSlotsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachOpenSlotsQueryKey(coachId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, QueryKey, CmCoachControllerGetCoachOpenSlotsParams['page']> = ({ signal, pageParam }) => cmCoachControllerGetCoachOpenSlots(coachId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData, Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, QueryKey, CmCoachControllerGetCoachOpenSlotsParams['page']> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachOpenSlotsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>>
export type CmCoachControllerGetCoachOpenSlotsInfiniteQueryError = unknown

/**
 * @summary 코치 오픈 슬랏 조회
 */
export const useCmCoachControllerGetCoachOpenSlotsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, CmCoachControllerGetCoachOpenSlotsParams['page']>, TError = unknown>(
 coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData, Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, QueryKey, CmCoachControllerGetCoachOpenSlotsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachOpenSlotsInfiniteQueryOptions(coachId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachControllerGetCoachOpenSlotsQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError = unknown>(coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachOpenSlotsQueryKey(coachId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>> = ({ signal }) => cmCoachControllerGetCoachOpenSlots(coachId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachOpenSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>>
export type CmCoachControllerGetCoachOpenSlotsQueryError = unknown

/**
 * @summary 코치 오픈 슬랏 조회
 */
export const useCmCoachControllerGetCoachOpenSlots = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError = unknown>(
 coachId: string,
    params: CmCoachControllerGetCoachOpenSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachOpenSlots>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachOpenSlotsQueryOptions(coachId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치 목록 필터와 코치 등록/수정 모달에서 쓰는 카테고리·그룹·태그 구조를 조회합니다.
 * @summary 코치 카테고리 태그 체계 조회
 */
export const cmCoachControllerGetCoachCategories = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCoachControllerGetCoachCategories200>(
      {url: `/v2/coaching-managers/me/coach-categories`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachControllerGetCoachCategoriesQueryKey = () => {
    return [`/v2/coaching-managers/me/coach-categories`] as const;
    }

    
export const getCmCoachControllerGetCoachCategoriesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>> = ({ signal }) => cmCoachControllerGetCoachCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachCategoriesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>>
export type CmCoachControllerGetCoachCategoriesInfiniteQueryError = unknown

/**
 * @summary 코치 카테고리 태그 체계 조회
 */
export const useCmCoachControllerGetCoachCategoriesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachCategoriesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachControllerGetCoachCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachControllerGetCoachCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>> = ({ signal }) => cmCoachControllerGetCoachCategories(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachControllerGetCoachCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>>
export type CmCoachControllerGetCoachCategoriesQueryError = unknown

/**
 * @summary 코치 카테고리 태그 체계 조회
 */
export const useCmCoachControllerGetCoachCategories = <TData = Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachControllerGetCoachCategories>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachControllerGetCoachCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클의 온보딩 설문지를 조회합니다.
 * @summary 코칭 매니저가 담당하는 사이클의 온보딩 설문지 조회
 */
export const cmSurveyControllerFindOneOnboardingSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindOneOnboardingSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/onboarding`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindOneOnboardingSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/onboarding`] as const;
    }

    
export const getCmSurveyControllerFindOneOnboardingSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneOnboardingSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>> = ({ signal }) => cmSurveyControllerFindOneOnboardingSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneOnboardingSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>>
export type CmSurveyControllerFindOneOnboardingSurveyInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 온보딩 설문지 조회
 */
export const useCmSurveyControllerFindOneOnboardingSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneOnboardingSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindOneOnboardingSurveyQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneOnboardingSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>> = ({ signal }) => cmSurveyControllerFindOneOnboardingSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneOnboardingSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>>
export type CmSurveyControllerFindOneOnboardingSurveyQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 온보딩 설문지 조회
 */
export const useCmSurveyControllerFindOneOnboardingSurvey = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneOnboardingSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클의 웨이마크 설문지를 조회합니다.
 * @summary 코칭 매니저가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const cmSurveyControllerFindOneWaymarkSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindOneWaymarkSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/waymark`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindOneWaymarkSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/waymark`] as const;
    }

    
export const getCmSurveyControllerFindOneWaymarkSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>> = ({ signal }) => cmSurveyControllerFindOneWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneWaymarkSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>>
export type CmSurveyControllerFindOneWaymarkSurveyInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const useCmSurveyControllerFindOneWaymarkSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneWaymarkSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindOneWaymarkSurveyQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>> = ({ signal }) => cmSurveyControllerFindOneWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneWaymarkSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>>
export type CmSurveyControllerFindOneWaymarkSurveyQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const useCmSurveyControllerFindOneWaymarkSurvey = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneWaymarkSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클의 코칭 후 웨이마크 설문지를 조회합니다.
 * @summary 코칭 매니저가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const cmSurveyControllerFindOnePostWaymarkSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindOnePostWaymarkSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/post-waymark`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindOnePostWaymarkSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/post-waymark`] as const;
    }

    
export const getCmSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOnePostWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>> = ({ signal }) => cmSurveyControllerFindOnePostWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>>
export type CmSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const useCmSurveyControllerFindOnePostWaymarkSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindOnePostWaymarkSurveyQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOnePostWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>> = ({ signal }) => cmSurveyControllerFindOnePostWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOnePostWaymarkSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>>
export type CmSurveyControllerFindOnePostWaymarkSurveyQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const useCmSurveyControllerFindOnePostWaymarkSurvey = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOnePostWaymarkSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클의 사전 리더십 설문지를 조회합니다.
 * @summary 코칭 매니저가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const cmSurveyControllerFindOneLeadershipSelfSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindOneLeadershipSelfSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/pre-leadership-self`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindOneLeadershipSelfSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/pre-leadership-self`] as const;
    }

    
export const getCmSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>> = ({ signal }) => cmSurveyControllerFindOneLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>>
export type CmSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const useCmSurveyControllerFindOneLeadershipSelfSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindOneLeadershipSelfSurveyQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOneLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>> = ({ signal }) => cmSurveyControllerFindOneLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOneLeadershipSelfSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>>
export type CmSurveyControllerFindOneLeadershipSelfSurveyQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const useCmSurveyControllerFindOneLeadershipSelfSurvey = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOneLeadershipSelfSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 매니저가 담당하는 사이클의 사후 리더십 설문지를 조회합니다.
 * @summary 코칭 매니저가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const cmSurveyControllerFindOnePostLeadershipSelfSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindOnePostLeadershipSelfSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/post-leadership-self`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/post-leadership-self`] as const;
    }

    
export const getCmSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>> = ({ signal }) => cmSurveyControllerFindOnePostLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>>
export type CmSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const useCmSurveyControllerFindOnePostLeadershipSelfSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindOnePostLeadershipSelfSurveyQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>> = ({ signal }) => cmSurveyControllerFindOnePostLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindOnePostLeadershipSelfSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>>
export type CmSurveyControllerFindOnePostLeadershipSelfSurveyQueryError = unknown

/**
 * @summary 코칭 매니저가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const useCmSurveyControllerFindOnePostLeadershipSelfSurvey = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindOnePostLeadershipSelfSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 동료피드백 설문 목록 조회
 */
export const cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerFindAllPeerFeedbackSurveysByCycleId200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback`] as const;
    }

    
export const getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>> = ({ signal }) => cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>
export type CmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryError = unknown

/**
 * @summary 사이클 동료피드백 설문 목록 조회
 */
export const useCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>> = ({ signal }) => cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>
export type CmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryError = unknown

/**
 * @summary 사이클 동료피드백 설문 목록 조회
 */
export const useCmSurveyControllerFindAllPeerFeedbackSurveysByCycleId = <TData = Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 동료피드백 설문 생성
 */
export const cmSurveyControllerCreatePeerFeedbackSurvey = (
    cycleId: string,
    createPeerFeedbackSurveyDtoModel: CreatePeerFeedbackSurveyDtoModel,
 ) => {
      
      
      return apiClient<CmSurveyControllerCreatePeerFeedbackSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPeerFeedbackSurveyDtoModel
    },
      );
    }
  


export const getCmSurveyControllerCreatePeerFeedbackSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>, {cycleId: string;data: CreatePeerFeedbackSurveyDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmSurveyControllerCreatePeerFeedbackSurvey(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerCreatePeerFeedbackSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>>
    export type CmSurveyControllerCreatePeerFeedbackSurveyMutationBody = CreatePeerFeedbackSurveyDtoModel
    export type CmSurveyControllerCreatePeerFeedbackSurveyMutationError = unknown

    /**
 * @summary 사이클 동료피드백 설문 생성
 */
export const useCmSurveyControllerCreatePeerFeedbackSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurvey>>,
        TError,
        {cycleId: string;data: CreatePeerFeedbackSurveyDtoModel},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerCreatePeerFeedbackSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 동료피드백 설문 bulk 생성
 */
export const cmSurveyControllerCreatePeerFeedbackSurveys = (
    cycleId: string,
    createPeerFeedbackSurveyBulkDtoModel: CreatePeerFeedbackSurveyBulkDtoModel,
 ) => {
      
      
      return apiClient<CmSurveyControllerCreatePeerFeedbackSurveys200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPeerFeedbackSurveyBulkDtoModel
    },
      );
    }
  


export const getCmSurveyControllerCreatePeerFeedbackSurveysMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyBulkDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyBulkDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>, {cycleId: string;data: CreatePeerFeedbackSurveyBulkDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmSurveyControllerCreatePeerFeedbackSurveys(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerCreatePeerFeedbackSurveysMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>>
    export type CmSurveyControllerCreatePeerFeedbackSurveysMutationBody = CreatePeerFeedbackSurveyBulkDtoModel
    export type CmSurveyControllerCreatePeerFeedbackSurveysMutationError = unknown

    /**
 * @summary 사이클 동료피드백 설문 bulk 생성
 */
export const useCmSurveyControllerCreatePeerFeedbackSurveys = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>, TError,{cycleId: string;data: CreatePeerFeedbackSurveyBulkDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackSurveys>>,
        TError,
        {cycleId: string;data: CreatePeerFeedbackSurveyBulkDtoModel},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerCreatePeerFeedbackSurveysMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 동료피드백 설문 수정
 */
export const cmSurveyControllerUpdatePeerFeedbackSurvey = (
    cycleId: string,
    surveyId: string,
    updatePeerFeedbackSurveyDtoModel: UpdatePeerFeedbackSurveyDtoModel,
 ) => {
      
      
      return apiClient<CmSurveyControllerUpdatePeerFeedbackSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback/${surveyId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePeerFeedbackSurveyDtoModel
    },
      );
    }
  


export const getCmSurveyControllerUpdatePeerFeedbackSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string;data: UpdatePeerFeedbackSurveyDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string;data: UpdatePeerFeedbackSurveyDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>, {cycleId: string;surveyId: string;data: UpdatePeerFeedbackSurveyDtoModel}> = (props) => {
          const {cycleId,surveyId,data} = props ?? {};

          return  cmSurveyControllerUpdatePeerFeedbackSurvey(cycleId,surveyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerUpdatePeerFeedbackSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>>
    export type CmSurveyControllerUpdatePeerFeedbackSurveyMutationBody = UpdatePeerFeedbackSurveyDtoModel
    export type CmSurveyControllerUpdatePeerFeedbackSurveyMutationError = unknown

    /**
 * @summary 사이클 동료피드백 설문 수정
 */
export const useCmSurveyControllerUpdatePeerFeedbackSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string;data: UpdatePeerFeedbackSurveyDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackSurvey>>,
        TError,
        {cycleId: string;surveyId: string;data: UpdatePeerFeedbackSurveyDtoModel},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerUpdatePeerFeedbackSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클 동료피드백 설문 삭제
 */
export const cmSurveyControllerDeletePeerFeedbackSurvey = (
    cycleId: string,
    surveyId: string,
 ) => {
      
      
      return apiClient<CmSurveyControllerDeletePeerFeedbackSurvey200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/surveys/peer-feedback/${surveyId}`, method: 'DELETE'
    },
      );
    }
  


export const getCmSurveyControllerDeletePeerFeedbackSurveyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>, {cycleId: string;surveyId: string}> = (props) => {
          const {cycleId,surveyId} = props ?? {};

          return  cmSurveyControllerDeletePeerFeedbackSurvey(cycleId,surveyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerDeletePeerFeedbackSurveyMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>>
    
    export type CmSurveyControllerDeletePeerFeedbackSurveyMutationError = unknown

    /**
 * @summary 사이클 동료피드백 설문 삭제
 */
export const useCmSurveyControllerDeletePeerFeedbackSurvey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>, TError,{cycleId: string;surveyId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerDeletePeerFeedbackSurvey>>,
        TError,
        {cycleId: string;surveyId: string},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerDeletePeerFeedbackSurveyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 생성
 */
export const cmSurveyControllerCreatePeerFeedbackReport = (
    cycleId: string,
    createPeerFeedbackReportDtoModel: CreatePeerFeedbackReportDtoModel,
 ) => {
      
      
      return apiClient<CmSurveyControllerCreatePeerFeedbackReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPeerFeedbackReportDtoModel
    },
      );
    }
  


export const getCmSurveyControllerCreatePeerFeedbackReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>, TError,{cycleId: string;data: CreatePeerFeedbackReportDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>, TError,{cycleId: string;data: CreatePeerFeedbackReportDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>, {cycleId: string;data: CreatePeerFeedbackReportDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmSurveyControllerCreatePeerFeedbackReport(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerCreatePeerFeedbackReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>>
    export type CmSurveyControllerCreatePeerFeedbackReportMutationBody = CreatePeerFeedbackReportDtoModel
    export type CmSurveyControllerCreatePeerFeedbackReportMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 생성
 */
export const useCmSurveyControllerCreatePeerFeedbackReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>, TError,{cycleId: string;data: CreatePeerFeedbackReportDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerCreatePeerFeedbackReport>>,
        TError,
        {cycleId: string;data: CreatePeerFeedbackReportDtoModel},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerCreatePeerFeedbackReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const cmSurveyControllerGetPeerFeedbackReport = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmSurveyControllerGetPeerFeedbackReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports`, method: 'GET', signal
    },
      );
    }
  

export const getCmSurveyControllerGetPeerFeedbackReportQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports`] as const;
    }

    
export const getCmSurveyControllerGetPeerFeedbackReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerGetPeerFeedbackReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>> = ({ signal }) => cmSurveyControllerGetPeerFeedbackReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerGetPeerFeedbackReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>>
export type CmSurveyControllerGetPeerFeedbackReportInfiniteQueryError = unknown

/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const useCmSurveyControllerGetPeerFeedbackReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerGetPeerFeedbackReportInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmSurveyControllerGetPeerFeedbackReportQueryOptions = <TData = Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmSurveyControllerGetPeerFeedbackReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>> = ({ signal }) => cmSurveyControllerGetPeerFeedbackReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CmSurveyControllerGetPeerFeedbackReportQueryResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>>
export type CmSurveyControllerGetPeerFeedbackReportQueryError = unknown

/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const useCmSurveyControllerGetPeerFeedbackReport = <TData = Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmSurveyControllerGetPeerFeedbackReportQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 리더십 다면진단 리포트 수정
 */
export const cmSurveyControllerUpdatePeerFeedbackReport = (
    cycleId: string,
    peerFeedbackReportId: string,
    updatePeerFeedbackReportDtoModel: UpdatePeerFeedbackReportDtoModel,
 ) => {
      
      
      return apiClient<CmSurveyControllerUpdatePeerFeedbackReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports/${peerFeedbackReportId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePeerFeedbackReportDtoModel
    },
      );
    }
  


export const getCmSurveyControllerUpdatePeerFeedbackReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>, TError,{cycleId: string;peerFeedbackReportId: string;data: UpdatePeerFeedbackReportDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>, TError,{cycleId: string;peerFeedbackReportId: string;data: UpdatePeerFeedbackReportDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>, {cycleId: string;peerFeedbackReportId: string;data: UpdatePeerFeedbackReportDtoModel}> = (props) => {
          const {cycleId,peerFeedbackReportId,data} = props ?? {};

          return  cmSurveyControllerUpdatePeerFeedbackReport(cycleId,peerFeedbackReportId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerUpdatePeerFeedbackReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>>
    export type CmSurveyControllerUpdatePeerFeedbackReportMutationBody = UpdatePeerFeedbackReportDtoModel
    export type CmSurveyControllerUpdatePeerFeedbackReportMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 수정
 */
export const useCmSurveyControllerUpdatePeerFeedbackReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>, TError,{cycleId: string;peerFeedbackReportId: string;data: UpdatePeerFeedbackReportDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerUpdatePeerFeedbackReport>>,
        TError,
        {cycleId: string;peerFeedbackReportId: string;data: UpdatePeerFeedbackReportDtoModel},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerUpdatePeerFeedbackReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 완료 처리
 */
export const cmSurveyControllerMarkAsCompletedPeerFeedbackReport = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmSurveyControllerMarkAsCompletedPeerFeedbackReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports/complete`, method: 'PATCH'
    },
      );
    }
  


export const getCmSurveyControllerMarkAsCompletedPeerFeedbackReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmSurveyControllerMarkAsCompletedPeerFeedbackReport(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerMarkAsCompletedPeerFeedbackReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>>
    
    export type CmSurveyControllerMarkAsCompletedPeerFeedbackReportMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 완료 처리
 */
export const useCmSurveyControllerMarkAsCompletedPeerFeedbackReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerMarkAsCompletedPeerFeedbackReport>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerMarkAsCompletedPeerFeedbackReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 케이스에 전송
 */
export const cmSurveyControllerSendToCasePeerFeedbackReport = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmSurveyControllerSendToCasePeerFeedbackReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports/send-to-case`, method: 'PATCH'
    },
      );
    }
  


export const getCmSurveyControllerSendToCasePeerFeedbackReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmSurveyControllerSendToCasePeerFeedbackReport(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerSendToCasePeerFeedbackReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>>
    
    export type CmSurveyControllerSendToCasePeerFeedbackReportMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 케이스에 전송
 */
export const useCmSurveyControllerSendToCasePeerFeedbackReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerSendToCasePeerFeedbackReport>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerSendToCasePeerFeedbackReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 AI 분석 요청
 */
export const cmSurveyControllerRequestPeerFeedbackReportAiAnalysis = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmSurveyControllerRequestPeerFeedbackReportAiAnalysis200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports/ai-analysis`, method: 'POST'
    },
      );
    }
  


export const getCmSurveyControllerRequestPeerFeedbackReportAiAnalysisMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmSurveyControllerRequestPeerFeedbackReportAiAnalysis(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmSurveyControllerRequestPeerFeedbackReportAiAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>>
    
    export type CmSurveyControllerRequestPeerFeedbackReportAiAnalysisMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 AI 분석 요청
 */
export const useCmSurveyControllerRequestPeerFeedbackReportAiAnalysis = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmSurveyControllerRequestPeerFeedbackReportAiAnalysis>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmSurveyControllerRequestPeerFeedbackReportAiAnalysisMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 선택한 사이클의 후보 코치 HR 공유용 코치 매칭 리포트를 docx로 요청합니다.
 * @summary HR 코치후보 공유 데이터 요청
 */
export const cmDataExportControllerRequestHrCoachCandidateShareData = (
    hrCoachCandidateShareDataRequestDtoModel: HrCoachCandidateShareDataRequestDtoModel,
 ) => {
      
      
      return apiClient<Blob>(
      {url: `/v2/coaching-managers/me/data-export/hr-coach-candidate-share`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hrCoachCandidateShareDataRequestDtoModel,
        responseType: 'blob'
    },
      );
    }
  


export const getCmDataExportControllerRequestHrCoachCandidateShareDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>, TError,{data: HrCoachCandidateShareDataRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>, TError,{data: HrCoachCandidateShareDataRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>, {data: HrCoachCandidateShareDataRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmDataExportControllerRequestHrCoachCandidateShareData(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmDataExportControllerRequestHrCoachCandidateShareDataMutationResult = NonNullable<Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>>
    export type CmDataExportControllerRequestHrCoachCandidateShareDataMutationBody = HrCoachCandidateShareDataRequestDtoModel
    export type CmDataExportControllerRequestHrCoachCandidateShareDataMutationError = unknown

    /**
 * @summary HR 코치후보 공유 데이터 요청
 */
export const useCmDataExportControllerRequestHrCoachCandidateShareData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>, TError,{data: HrCoachCandidateShareDataRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmDataExportControllerRequestHrCoachCandidateShareData>>,
        TError,
        {data: HrCoachCandidateShareDataRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmDataExportControllerRequestHrCoachCandidateShareDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 데이터 내보내기 권한을 확인합니다.
 * @summary 데이터 내보내기 권한 확인
 */
export const cmDataExportControllerIsAuthorized = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmDataExportControllerIsAuthorized200>(
      {url: `/v2/coaching-managers/me/data-export/is-authorized`, method: 'GET', signal
    },
      );
    }
  

export const getCmDataExportControllerIsAuthorizedQueryKey = () => {
    return [`/v2/coaching-managers/me/data-export/is-authorized`] as const;
    }

    
export const getCmDataExportControllerIsAuthorizedInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmDataExportControllerIsAuthorizedQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>> = ({ signal }) => cmDataExportControllerIsAuthorized(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData> & { queryKey: QueryKey }
}

export type CmDataExportControllerIsAuthorizedInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>>
export type CmDataExportControllerIsAuthorizedInfiniteQueryError = unknown

/**
 * @summary 데이터 내보내기 권한 확인
 */
export const useCmDataExportControllerIsAuthorizedInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmDataExportControllerIsAuthorizedInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmDataExportControllerIsAuthorizedQueryOptions = <TData = Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmDataExportControllerIsAuthorizedQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>> = ({ signal }) => cmDataExportControllerIsAuthorized(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData> & { queryKey: QueryKey }
}

export type CmDataExportControllerIsAuthorizedQueryResult = NonNullable<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>>
export type CmDataExportControllerIsAuthorizedQueryError = unknown

/**
 * @summary 데이터 내보내기 권한 확인
 */
export const useCmDataExportControllerIsAuthorized = <TData = Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmDataExportControllerIsAuthorized>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmDataExportControllerIsAuthorizedQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 선택한 사이클의 코칭 데이터를 AI 로 분석해 캐치업 미팅용 리포트(.docx)를 만듭니다. 한 고객사의 사이클만 넣을 수 있고, 외부 CPM 은 본인이 담당한 사이클만 넣을 수 있습니다.
 * @summary 캐치업 리포트 요청
 */
export const cmDataExportControllerRequestCatchUpReportData = (
    catchUpReportDataRequestDtoModel: CatchUpReportDataRequestDtoModel,
 ) => {
      
      
      return apiClient<Blob>(
      {url: `/v2/coaching-managers/me/data-export/catch-up-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: catchUpReportDataRequestDtoModel,
        responseType: 'blob'
    },
      );
    }
  


export const getCmDataExportControllerRequestCatchUpReportDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>, TError,{data: CatchUpReportDataRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>, TError,{data: CatchUpReportDataRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>, {data: CatchUpReportDataRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmDataExportControllerRequestCatchUpReportData(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmDataExportControllerRequestCatchUpReportDataMutationResult = NonNullable<Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>>
    export type CmDataExportControllerRequestCatchUpReportDataMutationBody = CatchUpReportDataRequestDtoModel
    export type CmDataExportControllerRequestCatchUpReportDataMutationError = unknown

    /**
 * @summary 캐치업 리포트 요청
 */
export const useCmDataExportControllerRequestCatchUpReportData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>, TError,{data: CatchUpReportDataRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmDataExportControllerRequestCatchUpReportData>>,
        TError,
        {data: CatchUpReportDataRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmDataExportControllerRequestCatchUpReportDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * LCD, 온보딩서베이, 자가 리더십진단(사전), 다면진단 레포트, 웨이마크 존재 여부를 반환합니다. (INTERNAL_COACHING_MANAGER 사용자만 호출 가능)
 * @summary 포뮬레이션 데이터 가용성
 */
export const cmCoachMatchingControllerGetFormulationDataAvailability = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/formulation-data-availability`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachMatchingControllerGetFormulationDataAvailabilityQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/formulation-data-availability`] as const;
    }

    
export const getCmCoachMatchingControllerGetFormulationDataAvailabilityInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetFormulationDataAvailabilityQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>> = ({ signal }) => cmCoachMatchingControllerGetFormulationDataAvailability(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetFormulationDataAvailabilityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>>
export type CmCoachMatchingControllerGetFormulationDataAvailabilityInfiniteQueryError = unknown

/**
 * @summary 포뮬레이션 데이터 가용성
 */
export const useCmCoachMatchingControllerGetFormulationDataAvailabilityInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetFormulationDataAvailabilityInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachMatchingControllerGetFormulationDataAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetFormulationDataAvailabilityQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>> = ({ signal }) => cmCoachMatchingControllerGetFormulationDataAvailability(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetFormulationDataAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>>
export type CmCoachMatchingControllerGetFormulationDataAvailabilityQueryError = unknown

/**
 * @summary 포뮬레이션 데이터 가용성
 */
export const useCmCoachMatchingControllerGetFormulationDataAvailability = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetFormulationDataAvailability>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetFormulationDataAvailabilityQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * cycleCoachMatching 전체 문서(status, formulation, formulationSummary, evaluationSheet, coachMatchingList, coachMatchingDetail)를 반환합니다. 문서 없으면 status: NO_PROGRESS, 나머지 빈 문자열. (INTERNAL_COACHING_MANAGER 사용자만 호출 가능)
 * @summary AI 코치 매칭 상태
 */
export const cmCoachMatchingControllerGetCoachMatchingStatus = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CycleCoachMatchingDetailResponseDtoModel>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coach-matching-status`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachMatchingControllerGetCoachMatchingStatusQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coach-matching-status`] as const;
    }

    
export const getCmCoachMatchingControllerGetCoachMatchingStatusInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetCoachMatchingStatusQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>> = ({ signal }) => cmCoachMatchingControllerGetCoachMatchingStatus(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetCoachMatchingStatusInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>>
export type CmCoachMatchingControllerGetCoachMatchingStatusInfiniteQueryError = unknown

/**
 * @summary AI 코치 매칭 상태
 */
export const useCmCoachMatchingControllerGetCoachMatchingStatusInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetCoachMatchingStatusInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachMatchingControllerGetCoachMatchingStatusQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetCoachMatchingStatusQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>> = ({ signal }) => cmCoachMatchingControllerGetCoachMatchingStatus(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetCoachMatchingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>>
export type CmCoachMatchingControllerGetCoachMatchingStatusQueryError = unknown

/**
 * @summary AI 코치 매칭 상태
 */
export const useCmCoachMatchingControllerGetCoachMatchingStatus = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingStatus>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetCoachMatchingStatusQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 포뮬레이션·후보로 등록된 코치 목록만 반환합니다. evaluationSheet·전체 순위표는 포함하지 않습니다. 코칭 매니저 JWT만 필요합니다(InternalCoachingManagerGuard 없음).
 * @summary 코치 매칭 공개 뷰 (PRD 2.35)
 */
export const cmCoachMatchingControllerGetCoachMatchingPublicView = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CycleCoachMatchingPublicViewResponseDtoModel>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coach-matching-public-view`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachMatchingControllerGetCoachMatchingPublicViewQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coach-matching-public-view`] as const;
    }

    
export const getCmCoachMatchingControllerGetCoachMatchingPublicViewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetCoachMatchingPublicViewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>> = ({ signal }) => cmCoachMatchingControllerGetCoachMatchingPublicView(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetCoachMatchingPublicViewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>>
export type CmCoachMatchingControllerGetCoachMatchingPublicViewInfiniteQueryError = unknown

/**
 * @summary 코치 매칭 공개 뷰 (PRD 2.35)
 */
export const useCmCoachMatchingControllerGetCoachMatchingPublicViewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetCoachMatchingPublicViewInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachMatchingControllerGetCoachMatchingPublicViewQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetCoachMatchingPublicViewQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>> = ({ signal }) => cmCoachMatchingControllerGetCoachMatchingPublicView(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetCoachMatchingPublicViewQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>>
export type CmCoachMatchingControllerGetCoachMatchingPublicViewQueryError = unknown

/**
 * @summary 코치 매칭 공개 뷰 (PRD 2.35)
 */
export const useCmCoachMatchingControllerGetCoachMatchingPublicView = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetCoachMatchingPublicView>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetCoachMatchingPublicViewQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 대상자·담당 코치·코치 프로필·매칭 배경 4셀 문자열을 반환합니다. 사이클 접근: 담당 coachingManagerId인 CM이거나 INTERNAL_COACHING_MANAGER_USER_IDS에 포함된 CM만 성공(그 외 403). coachId는 해당 사이클 coachMatchingList에서 candidate_selected === true인 행의 id여야 합니다. InternalCoachingManagerGuard 없음.
 * @summary HR 공유용 코치 매칭안 미리보기 (PRD 2.54)
 */
export const cmCoachMatchingControllerGetHrCoachMatchingSharePreview = (
    cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrCoachMatchingSharePreviewResponseDtoModel>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/hr-coach-matching-share-preview`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryKey = (cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/hr-coach-matching-share-preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']>, TError = unknown>(cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData, Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, QueryKey, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, QueryKey, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']> = ({ signal, pageParam }) => cmCoachMatchingControllerGetHrCoachMatchingSharePreview(cycleId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData, Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, QueryKey, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetHrCoachMatchingSharePreviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>>
export type CmCoachMatchingControllerGetHrCoachMatchingSharePreviewInfiniteQueryError = unknown

/**
 * @summary HR 공유용 코치 매칭안 미리보기 (PRD 2.54)
 */
export const useCmCoachMatchingControllerGetHrCoachMatchingSharePreviewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']>, TError = unknown>(
 cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData, Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, QueryKey, CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewInfiniteQueryOptions(cycleId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError = unknown>(cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>> = ({ signal }) => cmCoachMatchingControllerGetHrCoachMatchingSharePreview(cycleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>>
export type CmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryError = unknown

/**
 * @summary HR 공유용 코치 매칭안 미리보기 (PRD 2.54)
 */
export const useCmCoachMatchingControllerGetHrCoachMatchingSharePreview = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError = unknown>(
 cycleId: string,
    params: CmCoachMatchingControllerGetHrCoachMatchingSharePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetHrCoachMatchingSharePreview>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetHrCoachMatchingSharePreviewQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * formulationForHr(사이클 공통)와 matchingIntroForHr(코치별)을 저장합니다. 사이클 접근: 담당 coachingManagerId인 CM이거나 INTERNAL_COACHING_MANAGER_USER_IDS에 포함된 CM만 성공(그 외 403). coachId는 해당 사이클 후보 코치여야 합니다. AI 코치 매칭 재실행 시 수동 편집분은 덮어써질 수 있습니다.
 * @summary HR 공유용 코치 매칭안 매칭 배경 편집 (PRD 13)
 */
export const cmCoachMatchingControllerPatchHrCoachMatchingShareContent = (
    cycleId: string,
    patchHrCoachMatchingShareContentRequestDtoModel: PatchHrCoachMatchingShareContentRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/hr-coach-matching-share-content`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchHrCoachMatchingShareContentRequestDtoModel
    },
      );
    }
  


export const getCmCoachMatchingControllerPatchHrCoachMatchingShareContentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>, TError,{cycleId: string;data: PatchHrCoachMatchingShareContentRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>, TError,{cycleId: string;data: PatchHrCoachMatchingShareContentRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>, {cycleId: string;data: PatchHrCoachMatchingShareContentRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCoachMatchingControllerPatchHrCoachMatchingShareContent(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachMatchingControllerPatchHrCoachMatchingShareContentMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>>
    export type CmCoachMatchingControllerPatchHrCoachMatchingShareContentMutationBody = PatchHrCoachMatchingShareContentRequestDtoModel
    export type CmCoachMatchingControllerPatchHrCoachMatchingShareContentMutationError = unknown

    /**
 * @summary HR 공유용 코치 매칭안 매칭 배경 편집 (PRD 13)
 */
export const useCmCoachMatchingControllerPatchHrCoachMatchingShareContent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>, TError,{cycleId: string;data: PatchHrCoachMatchingShareContentRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachMatchingControllerPatchHrCoachMatchingShareContent>>,
        TError,
        {cycleId: string;data: PatchHrCoachMatchingShareContentRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachMatchingControllerPatchHrCoachMatchingShareContentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 대상자 데이터를 수집하여 AI 서버에 포뮬레이션을 실행합니다. (INTERNAL_COACHING_MANAGER 사용자만 호출 가능)
 * @summary 포뮬레이션 실행
 */
export const cmCoachMatchingControllerRequestUserFormulation = (
    cycleId: string,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/user-formulation`, method: 'POST'
    },
      );
    }
  


export const getCmCoachMatchingControllerRequestUserFormulationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachMatchingControllerRequestUserFormulation(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachMatchingControllerRequestUserFormulationMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>>
    
    export type CmCoachMatchingControllerRequestUserFormulationMutationError = unknown

    /**
 * @summary 포뮬레이션 실행
 */
export const useCmCoachMatchingControllerRequestUserFormulation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachMatchingControllerRequestUserFormulation>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachMatchingControllerRequestUserFormulationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * formulation과 코치 프로필을 AI 서버에 전달하여 코치 매칭안 생성을 요청합니다. (INTERNAL_COACHING_MANAGER 사용자만 호출 가능)
 * @summary AI 코치매칭안 생성
 */
export const cmCoachMatchingControllerRequestCoachMatching = (
    cycleId: string,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coach-matching`, method: 'POST'
    },
      );
    }
  


export const getCmCoachMatchingControllerRequestCoachMatchingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachMatchingControllerRequestCoachMatching(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachMatchingControllerRequestCoachMatchingMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>>
    
    export type CmCoachMatchingControllerRequestCoachMatchingMutationError = unknown

    /**
 * @summary AI 코치매칭안 생성
 */
export const useCmCoachMatchingControllerRequestCoachMatching = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachMatchingControllerRequestCoachMatching>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachMatchingControllerRequestCoachMatchingMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * LCD 파일의 텍스트 내용을 반환합니다. 없으면 content: null. 코칭 매니저(COACHING_MANAGER) 권한이 필요합니다.
 * @summary LCD 텍스트 내용 조회
 */
export const cmCoachMatchingControllerGetLcdContent = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<LcdContentResponseDtoModel>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/lcd-content`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachMatchingControllerGetLcdContentQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/lcd-content`] as const;
    }

    
export const getCmCoachMatchingControllerGetLcdContentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetLcdContentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>> = ({ signal }) => cmCoachMatchingControllerGetLcdContent(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetLcdContentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>>
export type CmCoachMatchingControllerGetLcdContentInfiniteQueryError = unknown

/**
 * @summary LCD 텍스트 내용 조회
 */
export const useCmCoachMatchingControllerGetLcdContentInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetLcdContentInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachMatchingControllerGetLcdContentQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachMatchingControllerGetLcdContentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>> = ({ signal }) => cmCoachMatchingControllerGetLcdContent(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachMatchingControllerGetLcdContentQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>>
export type CmCoachMatchingControllerGetLcdContentQueryError = unknown

/**
 * @summary LCD 텍스트 내용 조회
 */
export const useCmCoachMatchingControllerGetLcdContent = <TData = Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerGetLcdContent>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachMatchingControllerGetLcdContentQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * LCD 텍스트를 txt 파일로 GCS에 저장합니다. 빈 문자열이면 기존 LCD를 삭제합니다. 코칭 매니저(COACHING_MANAGER) 권한이 필요합니다.
 * @summary LCD 텍스트 저장
 */
export const cmCoachMatchingControllerSaveLcdContent = (
    cycleId: string,
    saveLcdContentRequestDtoModel: SaveLcdContentRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/lcd-content`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: saveLcdContentRequestDtoModel
    },
      );
    }
  


export const getCmCoachMatchingControllerSaveLcdContentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>, TError,{cycleId: string;data: SaveLcdContentRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>, TError,{cycleId: string;data: SaveLcdContentRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>, {cycleId: string;data: SaveLcdContentRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCoachMatchingControllerSaveLcdContent(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachMatchingControllerSaveLcdContentMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>>
    export type CmCoachMatchingControllerSaveLcdContentMutationBody = SaveLcdContentRequestDtoModel
    export type CmCoachMatchingControllerSaveLcdContentMutationError = unknown

    /**
 * @summary LCD 텍스트 저장
 */
export const useCmCoachMatchingControllerSaveLcdContent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>, TError,{cycleId: string;data: SaveLcdContentRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachMatchingControllerSaveLcdContent>>,
        TError,
        {cycleId: string;data: SaveLcdContentRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachMatchingControllerSaveLcdContentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * coachMatchingList 내 특정 코치의 후보 등록 여부를 설정합니다. 후보 등록(candidateSelected=true)은 INTERNAL_COACHING_MANAGER 사용자만 가능하며, 후보 해제(candidateSelected=false)는 해당 사이클 담당 코칭 매니저 또는 INTERNAL_COACHING_MANAGER 사용자만 가능합니다.
 * @summary 후보 등록 토글
 */
export const cmCoachMatchingControllerSetCandidateSelection = (
    cycleId: string,
    setCandidateSelectionRequestDtoModel: SetCandidateSelectionRequestDtoModel,
 ) => {
      
      
      return apiClient<unknown>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/candidate-selection`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setCandidateSelectionRequestDtoModel
    },
      );
    }
  


export const getCmCoachMatchingControllerSetCandidateSelectionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>, TError,{cycleId: string;data: SetCandidateSelectionRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>, TError,{cycleId: string;data: SetCandidateSelectionRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>, {cycleId: string;data: SetCandidateSelectionRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCoachMatchingControllerSetCandidateSelection(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachMatchingControllerSetCandidateSelectionMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>>
    export type CmCoachMatchingControllerSetCandidateSelectionMutationBody = SetCandidateSelectionRequestDtoModel
    export type CmCoachMatchingControllerSetCandidateSelectionMutationError = void

    /**
 * @summary 후보 등록 토글
 */
export const useCmCoachMatchingControllerSetCandidateSelection = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>, TError,{cycleId: string;data: SetCandidateSelectionRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachMatchingControllerSetCandidateSelection>>,
        TError,
        {cycleId: string;data: SetCandidateSelectionRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachMatchingControllerSetCandidateSelectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 미완료(콜 필요 & 아직 처리 안 된) 얼라인먼트 콜 대상을 세션 시작 오름차순으로 반환합니다. (내부 CPM 전용)
 * @summary 얼라인먼트 콜 대상 목록
 */
export const cmAlignmentCallAssessmentControllerGetPendingTargets = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmAlignmentCallAssessmentControllerGetPendingTargets200>(
      {url: `/v2/coaching-managers/me/alignment-calls`, method: 'GET', signal
    },
      );
    }
  

export const getCmAlignmentCallAssessmentControllerGetPendingTargetsQueryKey = () => {
    return [`/v2/coaching-managers/me/alignment-calls`] as const;
    }

    
export const getCmAlignmentCallAssessmentControllerGetPendingTargetsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmAlignmentCallAssessmentControllerGetPendingTargetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>> = ({ signal }) => cmAlignmentCallAssessmentControllerGetPendingTargets(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type CmAlignmentCallAssessmentControllerGetPendingTargetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>>
export type CmAlignmentCallAssessmentControllerGetPendingTargetsInfiniteQueryError = unknown

/**
 * @summary 얼라인먼트 콜 대상 목록
 */
export const useCmAlignmentCallAssessmentControllerGetPendingTargetsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmAlignmentCallAssessmentControllerGetPendingTargetsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmAlignmentCallAssessmentControllerGetPendingTargetsQueryOptions = <TData = Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmAlignmentCallAssessmentControllerGetPendingTargetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>> = ({ signal }) => cmAlignmentCallAssessmentControllerGetPendingTargets(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData> & { queryKey: QueryKey }
}

export type CmAlignmentCallAssessmentControllerGetPendingTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>>
export type CmAlignmentCallAssessmentControllerGetPendingTargetsQueryError = unknown

/**
 * @summary 얼라인먼트 콜 대상 목록
 */
export const useCmAlignmentCallAssessmentControllerGetPendingTargets = <TData = Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerGetPendingTargets>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmAlignmentCallAssessmentControllerGetPendingTargetsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * CPM이 해당 사이클의 얼라인먼트 콜을 완료했음을 기록합니다(manualCallCompletedAt). 이미 완료됐거나 대상이 없으면 404. (내부 CPM 전용)
 * @summary 얼라인먼트 콜 완료 처리
 */
export const cmAlignmentCallAssessmentControllerCompleteCall = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmAlignmentCallAssessmentControllerCompleteCall200>(
      {url: `/v2/coaching-managers/me/alignment-calls/${cycleId}`, method: 'PATCH'
    },
      );
    }
  


export const getCmAlignmentCallAssessmentControllerCompleteCallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmAlignmentCallAssessmentControllerCompleteCall(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmAlignmentCallAssessmentControllerCompleteCallMutationResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>>
    
    export type CmAlignmentCallAssessmentControllerCompleteCallMutationError = unknown

    /**
 * @summary 얼라인먼트 콜 완료 처리
 */
export const useCmAlignmentCallAssessmentControllerCompleteCall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmAlignmentCallAssessmentControllerCompleteCall>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmAlignmentCallAssessmentControllerCompleteCallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코치 사이클 대시보드 조회
 */
export const coachCycleControllerGetCyclesDashboard = (
    params?: CoachCycleControllerGetCyclesDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetCyclesDashboard200>(
      {url: `/v2/coaches/me/cycles/dashboard`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCoachCycleControllerGetCyclesDashboardQueryKey = (params?: CoachCycleControllerGetCyclesDashboardParams,) => {
    return [`/v2/coaches/me/cycles/dashboard`, ...(params ? [params]: [])] as const;
    }

    
export const getCoachCycleControllerGetCyclesDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, CoachCycleControllerGetCyclesDashboardParams['page']>, TError = unknown>(params?: CoachCycleControllerGetCyclesDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData, Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, QueryKey, CoachCycleControllerGetCyclesDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, QueryKey, CoachCycleControllerGetCyclesDashboardParams['page']> = ({ signal, pageParam }) => coachCycleControllerGetCyclesDashboard({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData, Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, QueryKey, CoachCycleControllerGetCyclesDashboardParams['page']> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>>
export type CoachCycleControllerGetCyclesDashboardInfiniteQueryError = unknown

/**
 * @summary 코치 사이클 대시보드 조회
 */
export const useCoachCycleControllerGetCyclesDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, CoachCycleControllerGetCyclesDashboardParams['page']>, TError = unknown>(
 params?: CoachCycleControllerGetCyclesDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData, Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, QueryKey, CoachCycleControllerGetCyclesDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesDashboardInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCyclesDashboardQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError = unknown>(params?: CoachCycleControllerGetCyclesDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>> = ({ signal }) => coachCycleControllerGetCyclesDashboard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>>
export type CoachCycleControllerGetCyclesDashboardQueryError = unknown

/**
 * @summary 코치 사이클 대시보드 조회
 */
export const useCoachCycleControllerGetCyclesDashboard = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError = unknown>(
 params?: CoachCycleControllerGetCyclesDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 상세 조회
 */
export const coachCycleControllerFindOne = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerFindOne200>(
      {url: `/v2/coaches/me/cycles/${cycleId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerFindOneQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}`] as const;
    }

    
export const getCoachCycleControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerFindOne>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerFindOneQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerFindOne>>> = ({ signal }) => coachCycleControllerFindOne(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerFindOne>>>
export type CoachCycleControllerFindOneInfiniteQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCoachCycleControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerFindOne>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerFindOneInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerFindOneQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerFindOne>>> = ({ signal }) => coachCycleControllerFindOne(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerFindOne>>>
export type CoachCycleControllerFindOneQueryError = unknown

/**
 * @summary 사이클 상세 조회
 */
export const useCoachCycleControllerFindOne = <TData = Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerFindOne>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerFindOneQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클 목록을 조회합니다.
 * @summary 사이클 목록 조회
 */
export const coachCycleControllerGetCycles = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetCycles200>(
      {url: `/v2/coaches/me/cycles`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetCyclesQueryKey = () => {
    return [`/v2/coaches/me/cycles`] as const;
    }

    
export const getCoachCycleControllerGetCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>> = ({ signal }) => coachCycleControllerGetCycles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>>
export type CoachCycleControllerGetCyclesInfiniteQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCoachCycleControllerGetCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCyclesQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>> = ({ signal }) => coachCycleControllerGetCycles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>>
export type CoachCycleControllerGetCyclesQueryError = unknown

/**
 * @summary 사이클 목록 조회
 */
export const useCoachCycleControllerGetCycles = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 사이클 메모 수정
 */
export const coachCycleControllerUpdateCycleMemo = (
    cycleId: string,
    updateCycleMemoDtoModel: UpdateCycleMemoDtoModel,
 ) => {
      
      
      return apiClient<CoachCycleControllerUpdateCycleMemo200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/memo`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCycleMemoDtoModel
    },
      );
    }
  


export const getCoachCycleControllerUpdateCycleMemoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>, {cycleId: string;data: UpdateCycleMemoDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  coachCycleControllerUpdateCycleMemo(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCycleControllerUpdateCycleMemoMutationResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>>
    export type CoachCycleControllerUpdateCycleMemoMutationBody = UpdateCycleMemoDtoModel
    export type CoachCycleControllerUpdateCycleMemoMutationError = unknown

    /**
 * @summary 사이클 메모 수정
 */
export const useCoachCycleControllerUpdateCycleMemo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>, TError,{cycleId: string;data: UpdateCycleMemoDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCycleControllerUpdateCycleMemo>>,
        TError,
        {cycleId: string;data: UpdateCycleMemoDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachCycleControllerUpdateCycleMemoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 담당 코치만 해당 사이클의 포뮬레이션(status, formulation, formulationSummary)을 조회할 수 있습니다. 담당 코치가 아닌 경우 403을 반환합니다.
 * @summary 사이클 포뮬레이션 조회 (PRD 2.42)
 */
export const coachCycleControllerGetCycleFormulation = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CycleFormulationForCoachResponseDtoModel>(
      {url: `/v2/coaches/me/cycles/${cycleId}/formulation`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetCycleFormulationQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/formulation`] as const;
    }

    
export const getCoachCycleControllerGetCycleFormulationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCycleFormulationQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>> = ({ signal }) => coachCycleControllerGetCycleFormulation(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCycleFormulationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>>
export type CoachCycleControllerGetCycleFormulationInfiniteQueryError = unknown

/**
 * @summary 사이클 포뮬레이션 조회 (PRD 2.42)
 */
export const useCoachCycleControllerGetCycleFormulationInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCycleFormulationInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCycleFormulationQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCycleFormulationQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>> = ({ signal }) => coachCycleControllerGetCycleFormulation(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCycleFormulationQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>>
export type CoachCycleControllerGetCycleFormulationQueryError = unknown

/**
 * @summary 사이클 포뮬레이션 조회 (PRD 2.42)
 */
export const useCoachCycleControllerGetCycleFormulation = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCycleFormulation>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCycleFormulationQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 담당 코치만 해당 사이클의 LCD(Leadership Context Document)를 조회할 수 있습니다. 담당 코치가 아닌 경우 403을 반환합니다.
 * @summary 사이클 LCD 조회 (PRD 2.49)
 */
export const coachCycleControllerGetLcdContent = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<LcdContentResponseDtoModel>(
      {url: `/v2/coaches/me/cycles/${cycleId}/lcd-content`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetLcdContentQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/lcd-content`] as const;
    }

    
export const getCoachCycleControllerGetLcdContentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetLcdContentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>> = ({ signal }) => coachCycleControllerGetLcdContent(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetLcdContentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>>
export type CoachCycleControllerGetLcdContentInfiniteQueryError = unknown

/**
 * @summary 사이클 LCD 조회 (PRD 2.49)
 */
export const useCoachCycleControllerGetLcdContentInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetLcdContentInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetLcdContentQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetLcdContentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>> = ({ signal }) => coachCycleControllerGetLcdContent(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetLcdContentQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>>
export type CoachCycleControllerGetLcdContentQueryError = unknown

/**
 * @summary 사이클 LCD 조회 (PRD 2.49)
 */
export const useCoachCycleControllerGetLcdContent = <TData = Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetLcdContent>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetLcdContentQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 본인이 담당한 적 있는 케이스의 사이클 목록을 조회합니다. 본인 최고 회차 이하의 사이클만 반환됩니다.
 * @summary 케이스 사이클 목록 조회 (코치용)
 */
export const coachCycleControllerGetCyclesByCaseId = (
    caseId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetCyclesByCaseId200>(
      {url: `/v2/coaches/me/cases/${caseId}/cycles`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetCyclesByCaseIdQueryKey = (caseId: string,) => {
    return [`/v2/coaches/me/cases/${caseId}/cycles`] as const;
    }

    
export const getCoachCycleControllerGetCyclesByCaseIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesByCaseIdQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>> = ({ signal }) => coachCycleControllerGetCyclesByCaseId(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesByCaseIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>>
export type CoachCycleControllerGetCyclesByCaseIdInfiniteQueryError = unknown

/**
 * @summary 케이스 사이클 목록 조회 (코치용)
 */
export const useCoachCycleControllerGetCyclesByCaseIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesByCaseIdInfiniteQueryOptions(caseId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCyclesByCaseIdQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError = unknown>(caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCyclesByCaseIdQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>> = ({ signal }) => coachCycleControllerGetCyclesByCaseId(caseId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCyclesByCaseIdQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>>
export type CoachCycleControllerGetCyclesByCaseIdQueryError = unknown

/**
 * @summary 케이스 사이클 목록 조회 (코치용)
 */
export const useCoachCycleControllerGetCyclesByCaseId = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError = unknown>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCyclesByCaseId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCyclesByCaseIdQueryOptions(caseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * [대상자 통보] 버튼 노출 여부와 오픈 슬랏 보유 여부를 반환합니다. 슬랏이 없어도 통보는 가능하며, 경고 문구 노출 판단에만 사용합니다.
 * @summary 대상자 통보 가능 여부 조회
 */
export const coachCycleControllerGetCaseNotificationAvailability = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetCaseNotificationAvailability200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/case-notification`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetCaseNotificationAvailabilityQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/case-notification`] as const;
    }

    
export const getCoachCycleControllerGetCaseNotificationAvailabilityInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCaseNotificationAvailabilityQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>> = ({ signal }) => coachCycleControllerGetCaseNotificationAvailability(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCaseNotificationAvailabilityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>>
export type CoachCycleControllerGetCaseNotificationAvailabilityInfiniteQueryError = unknown

/**
 * @summary 대상자 통보 가능 여부 조회
 */
export const useCoachCycleControllerGetCaseNotificationAvailabilityInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCaseNotificationAvailabilityInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCaseNotificationAvailabilityQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCaseNotificationAvailabilityQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>> = ({ signal }) => coachCycleControllerGetCaseNotificationAvailability(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCaseNotificationAvailabilityQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>>
export type CoachCycleControllerGetCaseNotificationAvailabilityQueryError = unknown

/**
 * @summary 대상자 통보 가능 여부 조회
 */
export const useCoachCycleControllerGetCaseNotificationAvailability = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCaseNotificationAvailability>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCaseNotificationAvailabilityQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 담당 코치가 대상자에게 1회기 예약 안내 메일을 발송합니다. CPM이 [코치 매칭] 탭에서 누르는 것과 동일한 로직이며, 이미 통보된 사이클은 400을 반환합니다.
 * @summary 대상자 통보
 */
export const coachCycleControllerNotifyCase = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CoachCycleControllerNotifyCase200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/case-notification`, method: 'POST'
    },
      );
    }
  


export const getCoachCycleControllerNotifyCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  coachCycleControllerNotifyCase(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCycleControllerNotifyCaseMutationResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>>
    
    export type CoachCycleControllerNotifyCaseMutationError = unknown

    /**
 * @summary 대상자 통보
 */
export const useCoachCycleControllerNotifyCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCycleControllerNotifyCase>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCoachCycleControllerNotifyCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 이 사이클의 다운로드 콜 요청을 반환합니다. 요청한 적이 없으면 request 가 null.
 * @summary 다운로드 콜 요청 조회
 */
export const coachCycleControllerGetDownloadCallRequest = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetDownloadCallRequest200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/download-call-request`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetDownloadCallRequestQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/download-call-request`] as const;
    }

    
export const getCoachCycleControllerGetDownloadCallRequestInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetDownloadCallRequestQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>> = ({ signal }) => coachCycleControllerGetDownloadCallRequest(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetDownloadCallRequestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>>
export type CoachCycleControllerGetDownloadCallRequestInfiniteQueryError = unknown

/**
 * @summary 다운로드 콜 요청 조회
 */
export const useCoachCycleControllerGetDownloadCallRequestInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetDownloadCallRequestInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetDownloadCallRequestQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetDownloadCallRequestQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>> = ({ signal }) => coachCycleControllerGetDownloadCallRequest(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetDownloadCallRequestQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>>
export type CoachCycleControllerGetDownloadCallRequestQueryError = unknown

/**
 * @summary 다운로드 콜 요청 조회
 */
export const useCoachCycleControllerGetDownloadCallRequest = <TData = Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetDownloadCallRequest>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetDownloadCallRequestQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 현재 담당 코치가 담당 CPM 에게 다운로드 콜을 요청합니다. 담당 CPM 에게 메일, 내부 트래킹 채널에 알림이 갑니다. 담당 코치마다 한 번만 요청할 수 있어 이미 요청했으면 409, 현재 담당 코치가 아니면 403을 반환합니다. 코치가 바뀌면 새 코치가 다시 요청할 수 있습니다.
 * @summary 다운로드 콜 요청
 */
export const coachCycleControllerRequestDownloadCall = (
    cycleId: string,
    createDownloadCallRequestDtoModel: CreateDownloadCallRequestDtoModel,
 ) => {
      
      
      return apiClient<CoachCycleControllerRequestDownloadCall201>(
      {url: `/v2/coaches/me/cycles/${cycleId}/download-call-request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDownloadCallRequestDtoModel
    },
      );
    }
  


export const getCoachCycleControllerRequestDownloadCallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>, TError,{cycleId: string;data: CreateDownloadCallRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>, TError,{cycleId: string;data: CreateDownloadCallRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>, {cycleId: string;data: CreateDownloadCallRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  coachCycleControllerRequestDownloadCall(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCycleControllerRequestDownloadCallMutationResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>>
    export type CoachCycleControllerRequestDownloadCallMutationBody = CreateDownloadCallRequestDtoModel
    export type CoachCycleControllerRequestDownloadCallMutationError = unknown

    /**
 * @summary 다운로드 콜 요청
 */
export const useCoachCycleControllerRequestDownloadCall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>, TError,{cycleId: string;data: CreateDownloadCallRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCycleControllerRequestDownloadCall>>,
        TError,
        {cycleId: string;data: CreateDownloadCallRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachCycleControllerRequestDownloadCallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 배정 때 만든 메모(배정 이유·진행 시 유의사항)와 코칭 개요를 반환합니다. 현재 담당 코치의 배정으로 만든 메모가 없으면 memo 가 null. 생성 중(PENDING)이면 다시 조회해 결과를 확인합니다.
 * @summary 코치 배정 메모 조회
 */
export const coachCycleControllerGetCoachAssignmentMemo = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCycleControllerGetCoachAssignmentMemo200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coach-assignment-memo`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCycleControllerGetCoachAssignmentMemoQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coach-assignment-memo`] as const;
    }

    
export const getCoachCycleControllerGetCoachAssignmentMemoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCoachAssignmentMemoQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>> = ({ signal }) => coachCycleControllerGetCoachAssignmentMemo(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCoachAssignmentMemoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>>
export type CoachCycleControllerGetCoachAssignmentMemoInfiniteQueryError = unknown

/**
 * @summary 코치 배정 메모 조회
 */
export const useCoachCycleControllerGetCoachAssignmentMemoInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCoachAssignmentMemoInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCycleControllerGetCoachAssignmentMemoQueryOptions = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCycleControllerGetCoachAssignmentMemoQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>> = ({ signal }) => coachCycleControllerGetCoachAssignmentMemo(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCycleControllerGetCoachAssignmentMemoQueryResult = NonNullable<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>>
export type CoachCycleControllerGetCoachAssignmentMemoQueryError = unknown

/**
 * @summary 코치 배정 메모 조회
 */
export const useCoachCycleControllerGetCoachAssignmentMemo = <TData = Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCycleControllerGetCoachAssignmentMemo>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCycleControllerGetCoachAssignmentMemoQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치 가용 사이클 정보 조회
 */
export const coachCapacityControllerGetCoachCapacity = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCapacityControllerGetCoachCapacity200>(
      {url: `/v2/coaches/me/capacity`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCapacityControllerGetCoachCapacityQueryKey = () => {
    return [`/v2/coaches/me/capacity`] as const;
    }

    
export const getCoachCapacityControllerGetCoachCapacityInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCapacityControllerGetCoachCapacityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>> = ({ signal }) => coachCapacityControllerGetCoachCapacity(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCapacityControllerGetCoachCapacityInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>>
export type CoachCapacityControllerGetCoachCapacityInfiniteQueryError = unknown

/**
 * @summary 코치 가용 사이클 정보 조회
 */
export const useCoachCapacityControllerGetCoachCapacityInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCapacityControllerGetCoachCapacityInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCapacityControllerGetCoachCapacityQueryOptions = <TData = Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCapacityControllerGetCoachCapacityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>> = ({ signal }) => coachCapacityControllerGetCoachCapacity(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCapacityControllerGetCoachCapacityQueryResult = NonNullable<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>>
export type CoachCapacityControllerGetCoachCapacityQueryError = unknown

/**
 * @summary 코치 가용 사이클 정보 조회
 */
export const useCoachCapacityControllerGetCoachCapacity = <TData = Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCapacityControllerGetCoachCapacity>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCapacityControllerGetCoachCapacityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치 가용 사이클 수 수정
 */
export const coachCapacityControllerUpdateCoachCapacity = (
    updateCoachCapacityDtoModel: UpdateCoachCapacityDtoModel,
 ) => {
      
      
      return apiClient<CoachCapacityControllerUpdateCoachCapacity200>(
      {url: `/v2/coaches/me/capacity`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachCapacityDtoModel
    },
      );
    }
  


export const getCoachCapacityControllerUpdateCoachCapacityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>, TError,{data: UpdateCoachCapacityDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>, TError,{data: UpdateCoachCapacityDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>, {data: UpdateCoachCapacityDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  coachCapacityControllerUpdateCoachCapacity(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCapacityControllerUpdateCoachCapacityMutationResult = NonNullable<Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>>
    export type CoachCapacityControllerUpdateCoachCapacityMutationBody = UpdateCoachCapacityDtoModel
    export type CoachCapacityControllerUpdateCoachCapacityMutationError = unknown

    /**
 * @summary 코치 가용 사이클 수 수정
 */
export const useCoachCapacityControllerUpdateCoachCapacity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>, TError,{data: UpdateCoachCapacityDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCapacityControllerUpdateCoachCapacity>>,
        TError,
        {data: UpdateCoachCapacityDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachCapacityControllerUpdateCoachCapacityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 슬롯 목록 조회
 */
export const coachSlotControllerGetSlots = (
    params: CoachSlotControllerGetSlotsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSlotControllerGetSlots200>(
      {url: `/v2/coaches/me/slots`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCoachSlotControllerGetSlotsQueryKey = (params: CoachSlotControllerGetSlotsParams,) => {
    return [`/v2/coaches/me/slots`, ...(params ? [params]: [])] as const;
    }

    
export const getCoachSlotControllerGetSlotsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, CoachSlotControllerGetSlotsParams['page']>, TError = unknown>(params: CoachSlotControllerGetSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData, Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, QueryKey, CoachSlotControllerGetSlotsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSlotControllerGetSlotsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, QueryKey, CoachSlotControllerGetSlotsParams['page']> = ({ signal, pageParam }) => coachSlotControllerGetSlots({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData, Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, QueryKey, CoachSlotControllerGetSlotsParams['page']> & { queryKey: QueryKey }
}

export type CoachSlotControllerGetSlotsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>>
export type CoachSlotControllerGetSlotsInfiniteQueryError = unknown

/**
 * @summary 슬롯 목록 조회
 */
export const useCoachSlotControllerGetSlotsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, CoachSlotControllerGetSlotsParams['page']>, TError = unknown>(
 params: CoachSlotControllerGetSlotsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData, Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, QueryKey, CoachSlotControllerGetSlotsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSlotControllerGetSlotsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSlotControllerGetSlotsQueryOptions = <TData = Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError = unknown>(params: CoachSlotControllerGetSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSlotControllerGetSlotsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>> = ({ signal }) => coachSlotControllerGetSlots(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSlotControllerGetSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>>
export type CoachSlotControllerGetSlotsQueryError = unknown

/**
 * @summary 슬롯 목록 조회
 */
export const useCoachSlotControllerGetSlots = <TData = Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError = unknown>(
 params: CoachSlotControllerGetSlotsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSlotControllerGetSlots>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSlotControllerGetSlotsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 슬롯 열기
 */
export const coachSlotControllerOpenSlot = (
    slotId: string,
 ) => {
      
      
      return apiClient<CoachSlotControllerOpenSlot200>(
      {url: `/v2/coaches/me/slots/${slotId}/open`, method: 'POST'
    },
      );
    }
  


export const getCoachSlotControllerOpenSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>, TError,{slotId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>, {slotId: string}> = (props) => {
          const {slotId} = props ?? {};

          return  coachSlotControllerOpenSlot(slotId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSlotControllerOpenSlotMutationResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>>
    
    export type CoachSlotControllerOpenSlotMutationError = unknown

    /**
 * @summary 슬롯 열기
 */
export const useCoachSlotControllerOpenSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSlotControllerOpenSlot>>,
        TError,
        {slotId: string},
        TContext
      > => {

      const mutationOptions = getCoachSlotControllerOpenSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 슬롯 닫기
 */
export const coachSlotControllerCloseSlot = (
    slotId: string,
 ) => {
      
      
      return apiClient<CoachSlotControllerCloseSlot200>(
      {url: `/v2/coaches/me/slots/${slotId}/close`, method: 'POST'
    },
      );
    }
  


export const getCoachSlotControllerCloseSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>, TError,{slotId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>, {slotId: string}> = (props) => {
          const {slotId} = props ?? {};

          return  coachSlotControllerCloseSlot(slotId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSlotControllerCloseSlotMutationResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>>
    
    export type CoachSlotControllerCloseSlotMutationError = unknown

    /**
 * @summary 슬롯 닫기
 */
export const useCoachSlotControllerCloseSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSlotControllerCloseSlot>>,
        TError,
        {slotId: string},
        TContext
      > => {

      const mutationOptions = getCoachSlotControllerCloseSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 슬롯 예약
 */
export const coachSlotControllerReserveSlot = (
    slotId: string,
    reserveSlotDtoModel: ReserveSlotDtoModel,
 ) => {
      
      
      return apiClient<CoachSlotControllerReserveSlot200>(
      {url: `/v2/coaches/me/slots/${slotId}/reserve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reserveSlotDtoModel
    },
      );
    }
  


export const getCoachSlotControllerReserveSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>, TError,{slotId: string;data: ReserveSlotDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>, TError,{slotId: string;data: ReserveSlotDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>, {slotId: string;data: ReserveSlotDtoModel}> = (props) => {
          const {slotId,data} = props ?? {};

          return  coachSlotControllerReserveSlot(slotId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSlotControllerReserveSlotMutationResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>>
    export type CoachSlotControllerReserveSlotMutationBody = ReserveSlotDtoModel
    export type CoachSlotControllerReserveSlotMutationError = unknown

    /**
 * @summary 슬롯 예약
 */
export const useCoachSlotControllerReserveSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>, TError,{slotId: string;data: ReserveSlotDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSlotControllerReserveSlot>>,
        TError,
        {slotId: string;data: ReserveSlotDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachSlotControllerReserveSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 슬롯 취소
 */
export const coachSlotControllerCancelSlot = (
    slotId: string,
 ) => {
      
      
      return apiClient<CoachSlotControllerCancelSlot200>(
      {url: `/v2/coaches/me/slots/${slotId}/cancel`, method: 'POST'
    },
      );
    }
  


export const getCoachSlotControllerCancelSlotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>, TError,{slotId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>, {slotId: string}> = (props) => {
          const {slotId} = props ?? {};

          return  coachSlotControllerCancelSlot(slotId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSlotControllerCancelSlotMutationResult = NonNullable<Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>>
    
    export type CoachSlotControllerCancelSlotMutationError = unknown

    /**
 * @summary 슬롯 취소
 */
export const useCoachSlotControllerCancelSlot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>, TError,{slotId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSlotControllerCancelSlot>>,
        TError,
        {slotId: string},
        TContext
      > => {

      const mutationOptions = getCoachSlotControllerCancelSlotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 담당하는 고객사 목록을 조회합니다.
 * @summary 코치가 담당하는 고객사 목록
 */
export const coachCompanyControllerFindAllWithFavorite = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachCompanyControllerFindAllWithFavorite200>(
      {url: `/v2/coaches/me/companies`, method: 'GET', signal
    },
      );
    }
  

export const getCoachCompanyControllerFindAllWithFavoriteQueryKey = () => {
    return [`/v2/coaches/me/companies`] as const;
    }

    
export const getCoachCompanyControllerFindAllWithFavoriteInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCompanyControllerFindAllWithFavoriteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>> = ({ signal }) => coachCompanyControllerFindAllWithFavorite(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCompanyControllerFindAllWithFavoriteInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>>
export type CoachCompanyControllerFindAllWithFavoriteInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 고객사 목록
 */
export const useCoachCompanyControllerFindAllWithFavoriteInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCompanyControllerFindAllWithFavoriteInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachCompanyControllerFindAllWithFavoriteQueryOptions = <TData = Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachCompanyControllerFindAllWithFavoriteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>> = ({ signal }) => coachCompanyControllerFindAllWithFavorite(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachCompanyControllerFindAllWithFavoriteQueryResult = NonNullable<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>>
export type CoachCompanyControllerFindAllWithFavoriteQueryError = unknown

/**
 * @summary 코치가 담당하는 고객사 목록
 */
export const useCoachCompanyControllerFindAllWithFavorite = <TData = Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachCompanyControllerFindAllWithFavorite>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachCompanyControllerFindAllWithFavoriteQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 즐겨찾기 고객사를 등록합니다.
 * @summary 즐겨찾기 고객사 등록
 */
export const coachCompanyControllerCreateFavoriteCompany = (
    companyId: string,
 ) => {
      
      
      return apiClient<CoachCompanyControllerCreateFavoriteCompany201>(
      {url: `/v2/coaches/me/companies/${companyId}/favorite`, method: 'POST'
    },
      );
    }
  


export const getCoachCompanyControllerCreateFavoriteCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>, {companyId: string}> = (props) => {
          const {companyId} = props ?? {};

          return  coachCompanyControllerCreateFavoriteCompany(companyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCompanyControllerCreateFavoriteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>>
    
    export type CoachCompanyControllerCreateFavoriteCompanyMutationError = unknown

    /**
 * @summary 즐겨찾기 고객사 등록
 */
export const useCoachCompanyControllerCreateFavoriteCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCompanyControllerCreateFavoriteCompany>>,
        TError,
        {companyId: string},
        TContext
      > => {

      const mutationOptions = getCoachCompanyControllerCreateFavoriteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 즐겨찾기 고객사를 삭제합니다.
 * @summary 즐겨찾기 고객사 삭제
 */
export const coachCompanyControllerDeleteFavoriteCompany = (
    companyId: string,
 ) => {
      
      
      return apiClient<CoachCompanyControllerDeleteFavoriteCompany200>(
      {url: `/v2/coaches/me/companies/${companyId}/favorite`, method: 'DELETE'
    },
      );
    }
  


export const getCoachCompanyControllerDeleteFavoriteCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>, {companyId: string}> = (props) => {
          const {companyId} = props ?? {};

          return  coachCompanyControllerDeleteFavoriteCompany(companyId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachCompanyControllerDeleteFavoriteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>>
    
    export type CoachCompanyControllerDeleteFavoriteCompanyMutationError = unknown

    /**
 * @summary 즐겨찾기 고객사 삭제
 */
export const useCoachCompanyControllerDeleteFavoriteCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>, TError,{companyId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachCompanyControllerDeleteFavoriteCompany>>,
        TError,
        {companyId: string},
        TContext
      > => {

      const mutationOptions = getCoachCompanyControllerDeleteFavoriteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코치가 담당하는 코칭 플랜 수정
 */
export const coachingPlanControllerUpdateCoachingPlan = (
    cycleId: string,
    coachingPlanUpdateDtoModel: CoachingPlanUpdateDtoModel,
 ) => {
      
      
      return apiClient<CoachingPlanControllerUpdateCoachingPlan200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-plans`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: coachingPlanUpdateDtoModel
    },
      );
    }
  


export const getCoachingPlanControllerUpdateCoachingPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>, TError,{cycleId: string;data: CoachingPlanUpdateDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>, TError,{cycleId: string;data: CoachingPlanUpdateDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>, {cycleId: string;data: CoachingPlanUpdateDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  coachingPlanControllerUpdateCoachingPlan(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingPlanControllerUpdateCoachingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>>
    export type CoachingPlanControllerUpdateCoachingPlanMutationBody = CoachingPlanUpdateDtoModel
    export type CoachingPlanControllerUpdateCoachingPlanMutationError = unknown

    /**
 * @summary 코치가 담당하는 코칭 플랜 수정
 */
export const useCoachingPlanControllerUpdateCoachingPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>, TError,{cycleId: string;data: CoachingPlanUpdateDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingPlanControllerUpdateCoachingPlan>>,
        TError,
        {cycleId: string;data: CoachingPlanUpdateDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachingPlanControllerUpdateCoachingPlanMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI 코칭 플랜 초안 조회
 */
export const coachingPlanControllerGetCoachingPlanAiDraft = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingPlanControllerGetCoachingPlanAiDraft200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-plan-ai-draft`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingPlanControllerGetCoachingPlanAiDraftQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coaching-plan-ai-draft`] as const;
    }

    
export const getCoachingPlanControllerGetCoachingPlanAiDraftInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingPlanControllerGetCoachingPlanAiDraftQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>> = ({ signal }) => coachingPlanControllerGetCoachingPlanAiDraft(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingPlanControllerGetCoachingPlanAiDraftInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>>
export type CoachingPlanControllerGetCoachingPlanAiDraftInfiniteQueryError = unknown

/**
 * @summary AI 코칭 플랜 초안 조회
 */
export const useCoachingPlanControllerGetCoachingPlanAiDraftInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingPlanControllerGetCoachingPlanAiDraftInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingPlanControllerGetCoachingPlanAiDraftQueryOptions = <TData = Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingPlanControllerGetCoachingPlanAiDraftQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>> = ({ signal }) => coachingPlanControllerGetCoachingPlanAiDraft(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingPlanControllerGetCoachingPlanAiDraftQueryResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>>
export type CoachingPlanControllerGetCoachingPlanAiDraftQueryError = unknown

/**
 * @summary AI 코칭 플랜 초안 조회
 */
export const useCoachingPlanControllerGetCoachingPlanAiDraft = <TData = Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerGetCoachingPlanAiDraft>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingPlanControllerGetCoachingPlanAiDraftQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 코칭 플랜을 코칭 매니저에게 전송합니다.
 * @summary 코칭 플랜 코칭 매니저에게 전송
 */
export const coachingPlanControllerSendToCoachingManager = (
    cycleId: string,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-plans/send-to-coaching-manager`, method: 'POST'
    },
      );
    }
  


export const getCoachingPlanControllerSendToCoachingManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  coachingPlanControllerSendToCoachingManager(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingPlanControllerSendToCoachingManagerMutationResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>>
    
    export type CoachingPlanControllerSendToCoachingManagerMutationError = unknown

    /**
 * @summary 코칭 플랜 코칭 매니저에게 전송
 */
export const useCoachingPlanControllerSendToCoachingManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingPlanControllerSendToCoachingManager>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCoachingPlanControllerSendToCoachingManagerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 내 코칭 플랜에 달린 피드백 목록
 */
export const coachingPlanControllerListFeedbacks = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingPlanControllerListFeedbacks200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-plan/feedbacks`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingPlanControllerListFeedbacksQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coaching-plan/feedbacks`] as const;
    }

    
export const getCoachingPlanControllerListFeedbacksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingPlanControllerListFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>> = ({ signal }) => coachingPlanControllerListFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingPlanControllerListFeedbacksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>>
export type CoachingPlanControllerListFeedbacksInfiniteQueryError = unknown

/**
 * @summary 내 코칭 플랜에 달린 피드백 목록
 */
export const useCoachingPlanControllerListFeedbacksInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingPlanControllerListFeedbacksInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingPlanControllerListFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingPlanControllerListFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>> = ({ signal }) => coachingPlanControllerListFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingPlanControllerListFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>>
export type CoachingPlanControllerListFeedbacksQueryError = unknown

/**
 * @summary 내 코칭 플랜에 달린 피드백 목록
 */
export const useCoachingPlanControllerListFeedbacks = <TData = Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingPlanControllerListFeedbacks>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingPlanControllerListFeedbacksQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 플랜 피드백 수정 완료 처리
 */
export const coachingPlanControllerResolveFeedback = (
    cycleId: string,
    feedbackId: string,
 ) => {
      
      
      return apiClient<CoachingPlanControllerResolveFeedback200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-plan/feedbacks/${feedbackId}/resolutions`, method: 'PATCH'
    },
      );
    }
  


export const getCoachingPlanControllerResolveFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>, {cycleId: string;feedbackId: string}> = (props) => {
          const {cycleId,feedbackId} = props ?? {};

          return  coachingPlanControllerResolveFeedback(cycleId,feedbackId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingPlanControllerResolveFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>>
    
    export type CoachingPlanControllerResolveFeedbackMutationError = unknown

    /**
 * @summary 코칭 플랜 피드백 수정 완료 처리
 */
export const useCoachingPlanControllerResolveFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingPlanControllerResolveFeedback>>,
        TError,
        {cycleId: string;feedbackId: string},
        TContext
      > => {

      const mutationOptions = getCoachingPlanControllerResolveFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 리포트 내용 또는 슬라이드 편집 내용을 저장합니다.
 * @summary 코칭 리포트 저장
 */
export const coachingReportControllerUpdateCoachingReport = (
    cycleId: string,
    coachingReportUpdateDtoModel: CoachingReportUpdateDtoModel,
 ) => {
      
      
      return apiClient<CoachingReportControllerUpdateCoachingReport200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-reports`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: coachingReportUpdateDtoModel
    },
      );
    }
  


export const getCoachingReportControllerUpdateCoachingReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>, {cycleId: string;data: CoachingReportUpdateDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  coachingReportControllerUpdateCoachingReport(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingReportControllerUpdateCoachingReportMutationResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>>
    export type CoachingReportControllerUpdateCoachingReportMutationBody = CoachingReportUpdateDtoModel
    export type CoachingReportControllerUpdateCoachingReportMutationError = unknown

    /**
 * @summary 코칭 리포트 저장
 */
export const useCoachingReportControllerUpdateCoachingReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingReportControllerUpdateCoachingReport>>,
        TError,
        {cycleId: string;data: CoachingReportUpdateDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachingReportControllerUpdateCoachingReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * reportVersion이 v1이면 슬라이드 데이터를 포함합니다.
 * @summary 코칭 리포트 조회
 */
export const coachingReportControllerGetCoachingReport = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingReportControllerGetCoachingReport200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-reports`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingReportControllerGetCoachingReportQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coaching-reports`] as const;
    }

    
export const getCoachingReportControllerGetCoachingReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingReportControllerGetCoachingReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>> = ({ signal }) => coachingReportControllerGetCoachingReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingReportControllerGetCoachingReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>>
export type CoachingReportControllerGetCoachingReportInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 조회
 */
export const useCoachingReportControllerGetCoachingReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingReportControllerGetCoachingReportInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingReportControllerGetCoachingReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingReportControllerGetCoachingReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>> = ({ signal }) => coachingReportControllerGetCoachingReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingReportControllerGetCoachingReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>>
export type CoachingReportControllerGetCoachingReportQueryError = unknown

/**
 * @summary 코칭 리포트 조회
 */
export const useCoachingReportControllerGetCoachingReport = <TData = Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingReportControllerGetCoachingReportQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 데이터를 기반으로 슬라이드 빈 필드를 AI로 생성합니다.
 * @summary 코칭 리포트 슬라이드 AI 생성
 */
export const coachingReportControllerGenerateSlideDataWithAi = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CoachingReportControllerGenerateSlideDataWithAi200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-reports/slide-data`, method: 'POST'
    },
      );
    }
  


export const getCoachingReportControllerGenerateSlideDataWithAiMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  coachingReportControllerGenerateSlideDataWithAi(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingReportControllerGenerateSlideDataWithAiMutationResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>>
    
    export type CoachingReportControllerGenerateSlideDataWithAiMutationError = unknown

    /**
 * @summary 코칭 리포트 슬라이드 AI 생성
 */
export const useCoachingReportControllerGenerateSlideDataWithAi = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingReportControllerGenerateSlideDataWithAi>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCoachingReportControllerGenerateSlideDataWithAiMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 담당하는 사이클의 코칭 리포트를 코칭 매니저에게 전송합니다.
 * @summary 코칭 리포트 코칭 매니저에게 전송
 */
export const coachingReportControllerSendToCoachingManager = (
    cycleId: string,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-reports/send-to-coaching-manager`, method: 'POST'
    },
      );
    }
  


export const getCoachingReportControllerSendToCoachingManagerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  coachingReportControllerSendToCoachingManager(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingReportControllerSendToCoachingManagerMutationResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>>
    
    export type CoachingReportControllerSendToCoachingManagerMutationError = unknown

    /**
 * @summary 코칭 리포트 코칭 매니저에게 전송
 */
export const useCoachingReportControllerSendToCoachingManager = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingReportControllerSendToCoachingManager>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCoachingReportControllerSendToCoachingManagerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 내 코칭 리포트에 달린 피드백 목록
 */
export const coachingReportControllerListFeedbacks = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingReportControllerListFeedbacks200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-report/feedbacks`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingReportControllerListFeedbacksQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coaching-report/feedbacks`] as const;
    }

    
export const getCoachingReportControllerListFeedbacksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingReportControllerListFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>> = ({ signal }) => coachingReportControllerListFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingReportControllerListFeedbacksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>>
export type CoachingReportControllerListFeedbacksInfiniteQueryError = unknown

/**
 * @summary 내 코칭 리포트에 달린 피드백 목록
 */
export const useCoachingReportControllerListFeedbacksInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingReportControllerListFeedbacksInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingReportControllerListFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingReportControllerListFeedbacksQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>> = ({ signal }) => coachingReportControllerListFeedbacks(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingReportControllerListFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>>
export type CoachingReportControllerListFeedbacksQueryError = unknown

/**
 * @summary 내 코칭 리포트에 달린 피드백 목록
 */
export const useCoachingReportControllerListFeedbacks = <TData = Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingReportControllerListFeedbacks>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingReportControllerListFeedbacksQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 리포트 피드백 수정 완료 처리
 */
export const coachingReportControllerResolveFeedback = (
    cycleId: string,
    feedbackId: string,
 ) => {
      
      
      return apiClient<CoachingReportControllerResolveFeedback200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-report/feedbacks/${feedbackId}/resolutions`, method: 'PATCH'
    },
      );
    }
  


export const getCoachingReportControllerResolveFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>, {cycleId: string;feedbackId: string}> = (props) => {
          const {cycleId,feedbackId} = props ?? {};

          return  coachingReportControllerResolveFeedback(cycleId,feedbackId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingReportControllerResolveFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>>
    
    export type CoachingReportControllerResolveFeedbackMutationError = unknown

    /**
 * @summary 코칭 리포트 피드백 수정 완료 처리
 */
export const useCoachingReportControllerResolveFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>, TError,{cycleId: string;feedbackId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingReportControllerResolveFeedback>>,
        TError,
        {cycleId: string;feedbackId: string},
        TContext
      > => {

      const mutationOptions = getCoachingReportControllerResolveFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코치가 담당하는 사이클의 온보딩 설문지를 조회합니다.
 * @summary 코치가 담당하는 사이클의 온보딩 설문지 조회
 */
export const coachSurveyControllerFindOneOnboardingSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindOneOnboardingSurvey200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/onboarding`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindOneOnboardingSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/onboarding`] as const;
    }

    
export const getCoachSurveyControllerFindOneOnboardingSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneOnboardingSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>> = ({ signal }) => coachSurveyControllerFindOneOnboardingSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneOnboardingSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>>
export type CoachSurveyControllerFindOneOnboardingSurveyInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 온보딩 설문지 조회
 */
export const useCoachSurveyControllerFindOneOnboardingSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneOnboardingSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindOneOnboardingSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneOnboardingSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>> = ({ signal }) => coachSurveyControllerFindOneOnboardingSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneOnboardingSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>>
export type CoachSurveyControllerFindOneOnboardingSurveyQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 온보딩 설문지 조회
 */
export const useCoachSurveyControllerFindOneOnboardingSurvey = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneOnboardingSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneOnboardingSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 웨이마크 설문지를 조회합니다.
 * @summary 코치가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const coachSurveyControllerFindOneWaymarkSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindOneWaymarkSurvey200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/waymark`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindOneWaymarkSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/waymark`] as const;
    }

    
export const getCoachSurveyControllerFindOneWaymarkSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>> = ({ signal }) => coachSurveyControllerFindOneWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneWaymarkSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>>
export type CoachSurveyControllerFindOneWaymarkSurveyInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const useCoachSurveyControllerFindOneWaymarkSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneWaymarkSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindOneWaymarkSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>> = ({ signal }) => coachSurveyControllerFindOneWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneWaymarkSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>>
export type CoachSurveyControllerFindOneWaymarkSurveyQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 웨이마크 설문지 조회
 */
export const useCoachSurveyControllerFindOneWaymarkSurvey = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneWaymarkSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneWaymarkSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 코칭 후 웨이마크 설문지를 조회합니다.
 * @summary 코치가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const coachSurveyControllerFindOnePostWaymarkSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindOnePostWaymarkSurvey200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/post-waymark`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindOnePostWaymarkSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/post-waymark`] as const;
    }

    
export const getCoachSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOnePostWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>> = ({ signal }) => coachSurveyControllerFindOnePostWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>>
export type CoachSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const useCoachSurveyControllerFindOnePostWaymarkSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOnePostWaymarkSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindOnePostWaymarkSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOnePostWaymarkSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>> = ({ signal }) => coachSurveyControllerFindOnePostWaymarkSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOnePostWaymarkSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>>
export type CoachSurveyControllerFindOnePostWaymarkSurveyQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 코칭 후 웨이마크 설문지 조회
 */
export const useCoachSurveyControllerFindOnePostWaymarkSurvey = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostWaymarkSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOnePostWaymarkSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 사전 리더십 설문지를 조회합니다.
 * @summary 코치가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const coachSurveyControllerFindOneLeadershipSelfSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindOneLeadershipSelfSurvey200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/pre-leadership-self`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindOneLeadershipSelfSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/pre-leadership-self`] as const;
    }

    
export const getCoachSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>> = ({ signal }) => coachSurveyControllerFindOneLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>>
export type CoachSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const useCoachSurveyControllerFindOneLeadershipSelfSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneLeadershipSelfSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindOneLeadershipSelfSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOneLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>> = ({ signal }) => coachSurveyControllerFindOneLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOneLeadershipSelfSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>>
export type CoachSurveyControllerFindOneLeadershipSelfSurveyQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 사전 리더십 설문지 조회
 */
export const useCoachSurveyControllerFindOneLeadershipSelfSurvey = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOneLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOneLeadershipSelfSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 사후 리더십 설문지를 조회합니다.
 * @summary 코치가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const coachSurveyControllerFindOnePostLeadershipSelfSurvey = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindOnePostLeadershipSelfSurvey200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/post-leadership-self`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/post-leadership-self`] as const;
    }

    
export const getCoachSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>> = ({ signal }) => coachSurveyControllerFindOnePostLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>>
export type CoachSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const useCoachSurveyControllerFindOnePostLeadershipSelfSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOnePostLeadershipSelfSurveyInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>> = ({ signal }) => coachSurveyControllerFindOnePostLeadershipSelfSurvey(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>>
export type CoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 사후 리더십 설문지 조회
 */
export const useCoachSurveyControllerFindOnePostLeadershipSelfSurvey = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindOnePostLeadershipSelfSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindOnePostLeadershipSelfSurveyQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코치가 담당하는 사이클의 동료피드백 설문지 목록을 조회합니다.
 * @summary 코치가 담당하는 사이클의 동료피드백 설문지 목록 조회
 */
export const coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleId200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/surveys/peer-feedback`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/surveys/peer-feedback`] as const;
    }

    
export const getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>> = ({ signal }) => coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>
export type CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 동료피드백 설문지 목록 조회
 */
export const useCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>> = ({ signal }) => coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>>
export type CoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 동료피드백 설문지 목록 조회
 */
export const useCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleId = <TData = Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerFindAllPeerFeedbackSurveysByCycleId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerFindAllPeerFeedbackSurveysByCycleIdQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치가 담당하는 사이클의 리더십 다면진단 리포트 조회
 */
export const coachSurveyControllerGetPeerFeedbackReport = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachSurveyControllerGetPeerFeedbackReport200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/peer-feedback-reports`, method: 'GET', signal
    },
      );
    }
  

export const getCoachSurveyControllerGetPeerFeedbackReportQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/peer-feedback-reports`] as const;
    }

    
export const getCoachSurveyControllerGetPeerFeedbackReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerGetPeerFeedbackReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>> = ({ signal }) => coachSurveyControllerGetPeerFeedbackReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerGetPeerFeedbackReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>>
export type CoachSurveyControllerGetPeerFeedbackReportInfiniteQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 리더십 다면진단 리포트 조회
 */
export const useCoachSurveyControllerGetPeerFeedbackReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerGetPeerFeedbackReportInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachSurveyControllerGetPeerFeedbackReportQueryOptions = <TData = Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachSurveyControllerGetPeerFeedbackReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>> = ({ signal }) => coachSurveyControllerGetPeerFeedbackReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachSurveyControllerGetPeerFeedbackReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>>
export type CoachSurveyControllerGetPeerFeedbackReportQueryError = unknown

/**
 * @summary 코치가 담당하는 사이클의 리더십 다면진단 리포트 조회
 */
export const useCoachSurveyControllerGetPeerFeedbackReport = <TData = Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachSurveyControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachSurveyControllerGetPeerFeedbackReportQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치 코칭 노트 생성
 */
export const coachingNoteControllerCreateCoachingNote = (
    cycleId: string,
    createCoachingNoteDtoModel: CreateCoachingNoteDtoModel,
 ) => {
      
      
      return apiClient<CoachingNoteControllerCreateCoachingNote200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-notes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCoachingNoteDtoModel
    },
      );
    }
  


export const getCoachingNoteControllerCreateCoachingNoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>, TError,{cycleId: string;data: CreateCoachingNoteDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>, TError,{cycleId: string;data: CreateCoachingNoteDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>, {cycleId: string;data: CreateCoachingNoteDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  coachingNoteControllerCreateCoachingNote(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingNoteControllerCreateCoachingNoteMutationResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>>
    export type CoachingNoteControllerCreateCoachingNoteMutationBody = CreateCoachingNoteDtoModel
    export type CoachingNoteControllerCreateCoachingNoteMutationError = unknown

    /**
 * @summary 코치 코칭 노트 생성
 */
export const useCoachingNoteControllerCreateCoachingNote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>, TError,{cycleId: string;data: CreateCoachingNoteDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingNoteControllerCreateCoachingNote>>,
        TError,
        {cycleId: string;data: CreateCoachingNoteDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachingNoteControllerCreateCoachingNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const coachingNoteControllerFindAllCoachingNotesFromCycle = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingNoteControllerFindAllCoachingNotesFromCycle200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-notes`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingNoteControllerFindAllCoachingNotesFromCycleQueryKey = (cycleId: string,) => {
    return [`/v2/coaches/me/cycles/${cycleId}/coaching-notes`] as const;
    }

    
export const getCoachingNoteControllerFindAllCoachingNotesFromCycleInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingNoteControllerFindAllCoachingNotesFromCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>> = ({ signal }) => coachingNoteControllerFindAllCoachingNotesFromCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingNoteControllerFindAllCoachingNotesFromCycleInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>>
export type CoachingNoteControllerFindAllCoachingNotesFromCycleInfiniteQueryError = unknown

/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const useCoachingNoteControllerFindAllCoachingNotesFromCycleInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingNoteControllerFindAllCoachingNotesFromCycleInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingNoteControllerFindAllCoachingNotesFromCycleQueryOptions = <TData = Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingNoteControllerFindAllCoachingNotesFromCycleQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>> = ({ signal }) => coachingNoteControllerFindAllCoachingNotesFromCycle(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingNoteControllerFindAllCoachingNotesFromCycleQueryResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>>
export type CoachingNoteControllerFindAllCoachingNotesFromCycleQueryError = unknown

/**
 * @summary 코치 코칭 노트 목록 조회
 */
export const useCoachingNoteControllerFindAllCoachingNotesFromCycle = <TData = Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerFindAllCoachingNotesFromCycle>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingNoteControllerFindAllCoachingNotesFromCycleQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 세션의 AI 초안 전사 상태를 조회합니다. (NONE: 전사 없음, IN_PROGRESS: 생성 중, COMPLETED: 완료)
 * @summary AI 초안 전사 상태 조회
 */
export const coachingNoteControllerGetTranscriptState = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingNoteControllerGetTranscriptState200>(
      {url: `/v2/coaches/me/sessions/${sessionId}/transcript-state`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingNoteControllerGetTranscriptStateQueryKey = (sessionId: string,) => {
    return [`/v2/coaches/me/sessions/${sessionId}/transcript-state`] as const;
    }

    
export const getCoachingNoteControllerGetTranscriptStateInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>>, TError = unknown>(sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingNoteControllerGetTranscriptStateQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>> = ({ signal }) => coachingNoteControllerGetTranscriptState(sessionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingNoteControllerGetTranscriptStateInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>>
export type CoachingNoteControllerGetTranscriptStateInfiniteQueryError = unknown

/**
 * @summary AI 초안 전사 상태 조회
 */
export const useCoachingNoteControllerGetTranscriptStateInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>>, TError = unknown>(
 sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingNoteControllerGetTranscriptStateInfiniteQueryOptions(sessionId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingNoteControllerGetTranscriptStateQueryOptions = <TData = Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError = unknown>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingNoteControllerGetTranscriptStateQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>> = ({ signal }) => coachingNoteControllerGetTranscriptState(sessionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingNoteControllerGetTranscriptStateQueryResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>>
export type CoachingNoteControllerGetTranscriptStateQueryError = unknown

/**
 * @summary AI 초안 전사 상태 조회
 */
export const useCoachingNoteControllerGetTranscriptState = <TData = Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError = unknown>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingNoteControllerGetTranscriptState>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingNoteControllerGetTranscriptStateQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치 코칭 노트 수정
 */
export const coachingNoteControllerUpdateCoachingNote = (
    cycleId: string,
    coachingNoteId: string,
    updateCoachingNoteDtoModel: UpdateCoachingNoteDtoModel,
 ) => {
      
      
      return apiClient<CoachingNoteControllerUpdateCoachingNote200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/coaching-notes/${coachingNoteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCoachingNoteDtoModel
    },
      );
    }
  


export const getCoachingNoteControllerUpdateCoachingNoteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>, TError,{cycleId: string;coachingNoteId: string;data: UpdateCoachingNoteDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>, TError,{cycleId: string;coachingNoteId: string;data: UpdateCoachingNoteDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>, {cycleId: string;coachingNoteId: string;data: UpdateCoachingNoteDtoModel}> = (props) => {
          const {cycleId,coachingNoteId,data} = props ?? {};

          return  coachingNoteControllerUpdateCoachingNote(cycleId,coachingNoteId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingNoteControllerUpdateCoachingNoteMutationResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>>
    export type CoachingNoteControllerUpdateCoachingNoteMutationBody = UpdateCoachingNoteDtoModel
    export type CoachingNoteControllerUpdateCoachingNoteMutationError = unknown

    /**
 * @summary 코치 코칭 노트 수정
 */
export const useCoachingNoteControllerUpdateCoachingNote = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>, TError,{cycleId: string;coachingNoteId: string;data: UpdateCoachingNoteDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingNoteControllerUpdateCoachingNote>>,
        TError,
        {cycleId: string;coachingNoteId: string;data: UpdateCoachingNoteDtoModel},
        TContext
      > => {

      const mutationOptions = getCoachingNoteControllerUpdateCoachingNoteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary AI 코칭 노트 초안 불러오기 (사용 기록 저장)
 */
export const coachingNoteControllerLoadCoachingNoteAiDraft = (
    sessionId: string,
 ) => {
      
      
      return apiClient<CoachingNoteControllerLoadCoachingNoteAiDraft200>(
      {url: `/v2/coaches/me/sessions/${sessionId}/coaching-note-ai-draft/load`, method: 'POST'
    },
      );
    }
  


export const getCoachingNoteControllerLoadCoachingNoteAiDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  coachingNoteControllerLoadCoachingNoteAiDraft(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingNoteControllerLoadCoachingNoteAiDraftMutationResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>>
    
    export type CoachingNoteControllerLoadCoachingNoteAiDraftMutationError = unknown

    /**
 * @summary AI 코칭 노트 초안 불러오기 (사용 기록 저장)
 */
export const useCoachingNoteControllerLoadCoachingNoteAiDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingNoteControllerLoadCoachingNoteAiDraft>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getCoachingNoteControllerLoadCoachingNoteAiDraftMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 코칭 노트를 케이스에 전송합니다.
 * @summary 코칭 노트 전송
 */
export const coachingNoteControllerSendToCase = (
    cycleId: string,
    sessionId: string,
 ) => {
      
      
      return apiClient<CoachingNoteControllerSendToCase200>(
      {url: `/v2/coaches/me/cycles/${cycleId}/sessions/${sessionId}/coaching-notes/send-to-case`, method: 'POST'
    },
      );
    }
  


export const getCoachingNoteControllerSendToCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>, TError,{cycleId: string;sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>, TError,{cycleId: string;sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>, {cycleId: string;sessionId: string}> = (props) => {
          const {cycleId,sessionId} = props ?? {};

          return  coachingNoteControllerSendToCase(cycleId,sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachingNoteControllerSendToCaseMutationResult = NonNullable<Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>>
    
    export type CoachingNoteControllerSendToCaseMutationError = unknown

    /**
 * @summary 코칭 노트 전송
 */
export const useCoachingNoteControllerSendToCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>, TError,{cycleId: string;sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachingNoteControllerSendToCase>>,
        TError,
        {cycleId: string;sessionId: string},
        TContext
      > => {

      const mutationOptions = getCoachingNoteControllerSendToCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 세션 지연 입장 알림 전송
 */
export const coachSessionControllerSendLateEntryReminder = (
    sessionId: string,
 ) => {
      
      
      return apiClient<CoachSessionControllerSendLateEntryReminder200>(
      {url: `/v2/coaches/me/sessions/${sessionId}/send-late-entry-reminder`, method: 'POST'
    },
      );
    }
  


export const getCoachSessionControllerSendLateEntryReminderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  coachSessionControllerSendLateEntryReminder(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSessionControllerSendLateEntryReminderMutationResult = NonNullable<Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>>
    
    export type CoachSessionControllerSendLateEntryReminderMutationError = unknown

    /**
 * @summary 세션 지연 입장 알림 전송
 */
export const useCoachSessionControllerSendLateEntryReminder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSessionControllerSendLateEntryReminder>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getCoachSessionControllerSendLateEntryReminderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 세션 완료
 */
export const coachSessionControllerCompleteSession = (
    sessionId: string,
 ) => {
      
      
      return apiClient<CoachSessionControllerCompleteSession200>(
      {url: `/v2/coaches/me/sessions/${sessionId}/complete`, method: 'POST'
    },
      );
    }
  


export const getCoachSessionControllerCompleteSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  coachSessionControllerCompleteSession(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSessionControllerCompleteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>>
    
    export type CoachSessionControllerCompleteSessionMutationError = unknown

    /**
 * @summary 세션 완료
 */
export const useCoachSessionControllerCompleteSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSessionControllerCompleteSession>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getCoachSessionControllerCompleteSessionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 세션 노쇼 처리
 */
export const coachSessionControllerMarkAsNoShow = (
    sessionId: string,
 ) => {
      
      
      return apiClient<CoachSessionControllerMarkAsNoShow200>(
      {url: `/v2/coaches/me/sessions/${sessionId}/no-show`, method: 'POST'
    },
      );
    }
  


export const getCoachSessionControllerMarkAsNoShowMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>, TError,{sessionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>, TError,{sessionId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  coachSessionControllerMarkAsNoShow(sessionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CoachSessionControllerMarkAsNoShowMutationResult = NonNullable<Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>>
    
    export type CoachSessionControllerMarkAsNoShowMutationError = unknown

    /**
 * @summary 세션 노쇼 처리
 */
export const useCoachSessionControllerMarkAsNoShow = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>, TError,{sessionId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof coachSessionControllerMarkAsNoShow>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getCoachSessionControllerMarkAsNoShowMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 노트 문서 조회
 */
export const coachingDocumentControllerGetCoachingNote = (
    coachingNoteId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetCoachingNote200>(
      {url: `/v2/coaching-documents/docs/coaching-notes/${coachingNoteId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetCoachingNoteQueryKey = (coachingNoteId: string,) => {
    return [`/v2/coaching-documents/docs/coaching-notes/${coachingNoteId}`] as const;
    }

    
export const getCoachingDocumentControllerGetCoachingNoteInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>>, TError = unknown>(coachingNoteId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingNoteQueryKey(coachingNoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>> = ({ signal }) => coachingDocumentControllerGetCoachingNote(coachingNoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingNoteId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingNoteInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>>
export type CoachingDocumentControllerGetCoachingNoteInfiniteQueryError = unknown

/**
 * @summary 코칭 노트 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingNoteInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>>, TError = unknown>(
 coachingNoteId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingNoteInfiniteQueryOptions(coachingNoteId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetCoachingNoteQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError = unknown>(coachingNoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingNoteQueryKey(coachingNoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>> = ({ signal }) => coachingDocumentControllerGetCoachingNote(coachingNoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingNoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingNoteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>>
export type CoachingDocumentControllerGetCoachingNoteQueryError = unknown

/**
 * @summary 코칭 노트 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingNote = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError = unknown>(
 coachingNoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingNote>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingNoteQueryOptions(coachingNoteId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 플랜 문서 조회
 */
export const coachingDocumentControllerGetCoachingPlan = (
    coachingPlanId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetCoachingPlan200>(
      {url: `/v2/coaching-documents/docs/coaching-plans/${coachingPlanId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetCoachingPlanQueryKey = (coachingPlanId: string,) => {
    return [`/v2/coaching-documents/docs/coaching-plans/${coachingPlanId}`] as const;
    }

    
export const getCoachingDocumentControllerGetCoachingPlanInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>>, TError = unknown>(coachingPlanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingPlanQueryKey(coachingPlanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>> = ({ signal }) => coachingDocumentControllerGetCoachingPlan(coachingPlanId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingPlanId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingPlanInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>>
export type CoachingDocumentControllerGetCoachingPlanInfiniteQueryError = unknown

/**
 * @summary 코칭 플랜 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingPlanInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>>, TError = unknown>(
 coachingPlanId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingPlanInfiniteQueryOptions(coachingPlanId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetCoachingPlanQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError = unknown>(coachingPlanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingPlanQueryKey(coachingPlanId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>> = ({ signal }) => coachingDocumentControllerGetCoachingPlan(coachingPlanId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingPlanId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingPlanQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>>
export type CoachingDocumentControllerGetCoachingPlanQueryError = unknown

/**
 * @summary 코칭 플랜 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingPlan = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError = unknown>(
 coachingPlanId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingPlan>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingPlanQueryOptions(coachingPlanId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 리포트 문서 조회
 */
export const coachingDocumentControllerGetCoachingReport = (
    coachingReportId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetCoachingReport200>(
      {url: `/v2/coaching-documents/docs/coaching-reports/${coachingReportId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetCoachingReportQueryKey = (coachingReportId: string,) => {
    return [`/v2/coaching-documents/docs/coaching-reports/${coachingReportId}`] as const;
    }

    
export const getCoachingDocumentControllerGetCoachingReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>>, TError = unknown>(coachingReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingReportQueryKey(coachingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>> = ({ signal }) => coachingDocumentControllerGetCoachingReport(coachingReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingReportId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>>
export type CoachingDocumentControllerGetCoachingReportInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>>, TError = unknown>(
 coachingReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingReportInfiniteQueryOptions(coachingReportId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetCoachingReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError = unknown>(coachingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetCoachingReportQueryKey(coachingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>> = ({ signal }) => coachingDocumentControllerGetCoachingReport(coachingReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetCoachingReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>>
export type CoachingDocumentControllerGetCoachingReportQueryError = unknown

/**
 * @summary 코칭 리포트 문서 조회
 */
export const useCoachingDocumentControllerGetCoachingReport = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError = unknown>(
 coachingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetCoachingReportQueryOptions(coachingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const coachingDocumentControllerGetPeerFeedbackReport = (
    peerFeedbackReportId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetPeerFeedbackReport200>(
      {url: `/v2/coaching-documents/docs/peer-feedback-reports/${peerFeedbackReportId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetPeerFeedbackReportQueryKey = (peerFeedbackReportId: string,) => {
    return [`/v2/coaching-documents/docs/peer-feedback-reports/${peerFeedbackReportId}`] as const;
    }

    
export const getCoachingDocumentControllerGetPeerFeedbackReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>>, TError = unknown>(peerFeedbackReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetPeerFeedbackReportQueryKey(peerFeedbackReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>> = ({ signal }) => coachingDocumentControllerGetPeerFeedbackReport(peerFeedbackReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(peerFeedbackReportId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetPeerFeedbackReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>>
export type CoachingDocumentControllerGetPeerFeedbackReportInfiniteQueryError = unknown

/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const useCoachingDocumentControllerGetPeerFeedbackReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>>, TError = unknown>(
 peerFeedbackReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetPeerFeedbackReportInfiniteQueryOptions(peerFeedbackReportId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetPeerFeedbackReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError = unknown>(peerFeedbackReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetPeerFeedbackReportQueryKey(peerFeedbackReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>> = ({ signal }) => coachingDocumentControllerGetPeerFeedbackReport(peerFeedbackReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(peerFeedbackReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetPeerFeedbackReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>>
export type CoachingDocumentControllerGetPeerFeedbackReportQueryError = unknown

/**
 * @summary 리더십 다면진단 리포트 조회
 */
export const useCoachingDocumentControllerGetPeerFeedbackReport = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError = unknown>(
 peerFeedbackReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetPeerFeedbackReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetPeerFeedbackReportQueryOptions(peerFeedbackReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 목표 달성도 추이 (종합 비교) 조회
 */
export const coachingDocumentControllerGetMissionSummaryReport = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetMissionSummaryReport200>(
      {url: `/v2/coaching-documents/docs/mission-summary-reports/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetMissionSummaryReportQueryKey = (id: string,) => {
    return [`/v2/coaching-documents/docs/mission-summary-reports/${id}`] as const;
    }

    
export const getCoachingDocumentControllerGetMissionSummaryReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetMissionSummaryReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>> = ({ signal }) => coachingDocumentControllerGetMissionSummaryReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetMissionSummaryReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>>
export type CoachingDocumentControllerGetMissionSummaryReportInfiniteQueryError = unknown

/**
 * @summary 목표 달성도 추이 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetMissionSummaryReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetMissionSummaryReportInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetMissionSummaryReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetMissionSummaryReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>> = ({ signal }) => coachingDocumentControllerGetMissionSummaryReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetMissionSummaryReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>>
export type CoachingDocumentControllerGetMissionSummaryReportQueryError = unknown

/**
 * @summary 목표 달성도 추이 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetMissionSummaryReport = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetMissionSummaryReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetMissionSummaryReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const coachingDocumentControllerGetLeadershipSummaryReport = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetLeadershipSummaryReport200>(
      {url: `/v2/coaching-documents/docs/leadership-summary-reports/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetLeadershipSummaryReportQueryKey = (id: string,) => {
    return [`/v2/coaching-documents/docs/leadership-summary-reports/${id}`] as const;
    }

    
export const getCoachingDocumentControllerGetLeadershipSummaryReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetLeadershipSummaryReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>> = ({ signal }) => coachingDocumentControllerGetLeadershipSummaryReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetLeadershipSummaryReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>>
export type CoachingDocumentControllerGetLeadershipSummaryReportInfiniteQueryError = unknown

/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetLeadershipSummaryReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetLeadershipSummaryReportInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetLeadershipSummaryReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetLeadershipSummaryReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>> = ({ signal }) => coachingDocumentControllerGetLeadershipSummaryReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetLeadershipSummaryReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>>
export type CoachingDocumentControllerGetLeadershipSummaryReportQueryError = unknown

/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetLeadershipSummaryReport = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetLeadershipSummaryReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetLeadershipSummaryReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 온보딩 설문지 조회
 */
export const coachingDocumentControllerGetOnboardingSurvey = (
    onboardingSurveyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetOnboardingSurvey200>(
      {url: `/v2/coaching-documents/docs/onboarding-survey/${onboardingSurveyId}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetOnboardingSurveyQueryKey = (onboardingSurveyId: string,) => {
    return [`/v2/coaching-documents/docs/onboarding-survey/${onboardingSurveyId}`] as const;
    }

    
export const getCoachingDocumentControllerGetOnboardingSurveyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>>, TError = unknown>(onboardingSurveyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetOnboardingSurveyQueryKey(onboardingSurveyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>> = ({ signal }) => coachingDocumentControllerGetOnboardingSurvey(onboardingSurveyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(onboardingSurveyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetOnboardingSurveyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>>
export type CoachingDocumentControllerGetOnboardingSurveyInfiniteQueryError = unknown

/**
 * @summary 온보딩 설문지 조회
 */
export const useCoachingDocumentControllerGetOnboardingSurveyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>>, TError = unknown>(
 onboardingSurveyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetOnboardingSurveyInfiniteQueryOptions(onboardingSurveyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetOnboardingSurveyQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError = unknown>(onboardingSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetOnboardingSurveyQueryKey(onboardingSurveyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>> = ({ signal }) => coachingDocumentControllerGetOnboardingSurvey(onboardingSurveyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(onboardingSurveyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetOnboardingSurveyQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>>
export type CoachingDocumentControllerGetOnboardingSurveyQueryError = unknown

/**
 * @summary 온보딩 설문지 조회
 */
export const useCoachingDocumentControllerGetOnboardingSurvey = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError = unknown>(
 onboardingSurveyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOnboardingSurvey>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetOnboardingSurveyQueryOptions(onboardingSurveyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const coachingDocumentControllerGetOccupationalHealthReport = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachingDocumentControllerGetOccupationalHealthReport200>(
      {url: `/v2/coaching-documents/docs/occupational-health-reports/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getCoachingDocumentControllerGetOccupationalHealthReportQueryKey = (id: string,) => {
    return [`/v2/coaching-documents/docs/occupational-health-reports/${id}`] as const;
    }

    
export const getCoachingDocumentControllerGetOccupationalHealthReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetOccupationalHealthReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>> = ({ signal }) => coachingDocumentControllerGetOccupationalHealthReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetOccupationalHealthReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>>
export type CoachingDocumentControllerGetOccupationalHealthReportInfiniteQueryError = unknown

/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetOccupationalHealthReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetOccupationalHealthReportInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachingDocumentControllerGetOccupationalHealthReportQueryOptions = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachingDocumentControllerGetOccupationalHealthReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>> = ({ signal }) => coachingDocumentControllerGetOccupationalHealthReport(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachingDocumentControllerGetOccupationalHealthReportQueryResult = NonNullable<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>>
export type CoachingDocumentControllerGetOccupationalHealthReportQueryError = unknown

/**
 * @summary 리더십 자가 진단 (종합 비교) 조회
 */
export const useCoachingDocumentControllerGetOccupationalHealthReport = <TData = Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachingDocumentControllerGetOccupationalHealthReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachingDocumentControllerGetOccupationalHealthReportQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * CM이 이메일 미리보기를 조회합니다.
 * @summary 이메일 미리보기
 */
export const cmEmailControllerGetEmailPreview = (
    params?: CmEmailControllerGetEmailPreviewParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmEmailControllerGetEmailPreview200>(
      {url: `/v2/coaching-managers/me/email/preview`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmEmailControllerGetEmailPreviewQueryKey = (params?: CmEmailControllerGetEmailPreviewParams,) => {
    return [`/v2/coaching-managers/me/email/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCmEmailControllerGetEmailPreviewInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, CmEmailControllerGetEmailPreviewParams['page']>, TError = unknown>(params?: CmEmailControllerGetEmailPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData, Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, QueryKey, CmEmailControllerGetEmailPreviewParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmEmailControllerGetEmailPreviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, QueryKey, CmEmailControllerGetEmailPreviewParams['page']> = ({ signal, pageParam }) => cmEmailControllerGetEmailPreview({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData, Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, QueryKey, CmEmailControllerGetEmailPreviewParams['page']> & { queryKey: QueryKey }
}

export type CmEmailControllerGetEmailPreviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>>
export type CmEmailControllerGetEmailPreviewInfiniteQueryError = unknown

/**
 * @summary 이메일 미리보기
 */
export const useCmEmailControllerGetEmailPreviewInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, CmEmailControllerGetEmailPreviewParams['page']>, TError = unknown>(
 params?: CmEmailControllerGetEmailPreviewParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData, Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, QueryKey, CmEmailControllerGetEmailPreviewParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmEmailControllerGetEmailPreviewInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmEmailControllerGetEmailPreviewQueryOptions = <TData = Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError = unknown>(params?: CmEmailControllerGetEmailPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmEmailControllerGetEmailPreviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>> = ({ signal }) => cmEmailControllerGetEmailPreview(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData> & { queryKey: QueryKey }
}

export type CmEmailControllerGetEmailPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>>
export type CmEmailControllerGetEmailPreviewQueryError = unknown

/**
 * @summary 이메일 미리보기
 */
export const useCmEmailControllerGetEmailPreview = <TData = Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError = unknown>(
 params?: CmEmailControllerGetEmailPreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmEmailControllerGetEmailPreview>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmEmailControllerGetEmailPreviewQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * CM이 온보딩 메일을 발송합니다.
 * @summary 이메일 온보딩 메일 발송
 */
export const cmEmailControllerSendOnboardingEmail = (
    sendEmailRequestDtoModel: SendEmailRequestDtoModel,
 ) => {
      
      
      return apiClient<CmEmailControllerSendOnboardingEmail200>(
      {url: `/v2/coaching-managers/me/email/send-onboarding`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailRequestDtoModel
    },
      );
    }
  


export const getCmEmailControllerSendOnboardingEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>, {data: SendEmailRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmEmailControllerSendOnboardingEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmEmailControllerSendOnboardingEmailMutationResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>>
    export type CmEmailControllerSendOnboardingEmailMutationBody = SendEmailRequestDtoModel
    export type CmEmailControllerSendOnboardingEmailMutationError = unknown

    /**
 * @summary 이메일 온보딩 메일 발송
 */
export const useCmEmailControllerSendOnboardingEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmEmailControllerSendOnboardingEmail>>,
        TError,
        {data: SendEmailRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmEmailControllerSendOnboardingEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 동료피드백 메일을 발송합니다.
 * @summary 이메일 동료피드백 메일 발송
 */
export const cmEmailControllerSendPeerFeedbackEmail = (
    sendEmailRequestDtoModel: SendEmailRequestDtoModel,
 ) => {
      
      
      return apiClient<CmEmailControllerSendPeerFeedbackEmail200>(
      {url: `/v2/coaching-managers/me/email/send-peer-feedback`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendEmailRequestDtoModel
    },
      );
    }
  


export const getCmEmailControllerSendPeerFeedbackEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>, {data: SendEmailRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmEmailControllerSendPeerFeedbackEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmEmailControllerSendPeerFeedbackEmailMutationResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>>
    export type CmEmailControllerSendPeerFeedbackEmailMutationBody = SendEmailRequestDtoModel
    export type CmEmailControllerSendPeerFeedbackEmailMutationError = unknown

    /**
 * @summary 이메일 동료피드백 메일 발송
 */
export const useCmEmailControllerSendPeerFeedbackEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>, TError,{data: SendEmailRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackEmail>>,
        TError,
        {data: SendEmailRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmEmailControllerSendPeerFeedbackEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 동료피드백 리마인더 메일을 발송합니다.
 * @summary 이메일 동료피드백 리마인더 메일 발송
 */
export const cmEmailControllerSendPeerFeedbackReminderEmail = (
    
 ) => {
      
      
      return apiClient<CmEmailControllerSendPeerFeedbackReminderEmail200>(
      {url: `/v2/coaching-managers/me/email/send-peer-feedback-reminder`, method: 'POST'
    },
      );
    }
  


export const getCmEmailControllerSendPeerFeedbackReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>, void> = () => {
          

          return  cmEmailControllerSendPeerFeedbackReminderEmail()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmEmailControllerSendPeerFeedbackReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>>
    
    export type CmEmailControllerSendPeerFeedbackReminderEmailMutationError = unknown

    /**
 * @summary 이메일 동료피드백 리마인더 메일 발송
 */
export const useCmEmailControllerSendPeerFeedbackReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmEmailControllerSendPeerFeedbackReminderEmail>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCmEmailControllerSendPeerFeedbackReminderEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * CM이 온보딩 리마인더 메일을 발송합니다.
 * @summary 이메일 온보딩 리마인더 메일 발송
 */
export const cmEmailControllerSendOnboardingReminderEmail = (
    
 ) => {
      
      
      return apiClient<CmEmailControllerSendOnboardingReminderEmail200>(
      {url: `/v2/coaching-managers/me/email/send-onboarding-reminder`, method: 'POST'
    },
      );
    }
  


export const getCmEmailControllerSendOnboardingReminderEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>, void> = () => {
          

          return  cmEmailControllerSendOnboardingReminderEmail()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmEmailControllerSendOnboardingReminderEmailMutationResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>>
    
    export type CmEmailControllerSendOnboardingReminderEmailMutationError = unknown

    /**
 * @summary 이메일 온보딩 리마인더 메일 발송
 */
export const useCmEmailControllerSendOnboardingReminderEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmEmailControllerSendOnboardingReminderEmail>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCmEmailControllerSendOnboardingReminderEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 크론 없이 세션 D-1 리마인더를 즉시 실행합니다. 로컬에서는 실제 발송 안 됩니다.
 * @summary 세션 D-1 리마인더 수동 트리거 (테스트용)
 */
export const cmEmailControllerSendSessionReminder = (
    
 ) => {
      
      
      return apiClient<CmEmailControllerSendSessionReminder200>(
      {url: `/v2/coaching-managers/me/email/send-session-reminder`, method: 'POST'
    },
      );
    }
  


export const getCmEmailControllerSendSessionReminderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>, void> = () => {
          

          return  cmEmailControllerSendSessionReminder()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmEmailControllerSendSessionReminderMutationResult = NonNullable<Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>>
    
    export type CmEmailControllerSendSessionReminderMutationError = unknown

    /**
 * @summary 세션 D-1 리마인더 수동 트리거 (테스트용)
 */
export const useCmEmailControllerSendSessionReminder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmEmailControllerSendSessionReminder>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getCmEmailControllerSendSessionReminderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 만족도 대시보드 메인 조회
 */
export const cmInsightsControllerGetDashboard = (
    params?: CmInsightsControllerGetDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmInsightsControllerGetDashboard200>(
      {url: `/v2/coaching-managers/me/insights`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmInsightsControllerGetDashboardQueryKey = (params?: CmInsightsControllerGetDashboardParams,) => {
    return [`/v2/coaching-managers/me/insights`, ...(params ? [params]: [])] as const;
    }

    
export const getCmInsightsControllerGetDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, CmInsightsControllerGetDashboardParams['page']>, TError = unknown>(params?: CmInsightsControllerGetDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, QueryKey, CmInsightsControllerGetDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, QueryKey, CmInsightsControllerGetDashboardParams['page']> = ({ signal, pageParam }) => cmInsightsControllerGetDashboard({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, QueryKey, CmInsightsControllerGetDashboardParams['page']> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>>
export type CmInsightsControllerGetDashboardInfiniteQueryError = unknown

/**
 * @summary 만족도 대시보드 메인 조회
 */
export const useCmInsightsControllerGetDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, CmInsightsControllerGetDashboardParams['page']>, TError = unknown>(
 params?: CmInsightsControllerGetDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, QueryKey, CmInsightsControllerGetDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetDashboardInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmInsightsControllerGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError = unknown>(params?: CmInsightsControllerGetDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>> = ({ signal }) => cmInsightsControllerGetDashboard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>>
export type CmInsightsControllerGetDashboardQueryError = unknown

/**
 * @summary 만족도 대시보드 메인 조회
 */
export const useCmInsightsControllerGetDashboard = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError = unknown>(
 params?: CmInsightsControllerGetDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 만족도 대시보드 코치 상세 조회
 */
export const cmInsightsControllerGetCoachDashboard = (
    coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmInsightsControllerGetCoachDashboard200>(
      {url: `/v2/coaching-managers/me/insights/coaches/${coachId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmInsightsControllerGetCoachDashboardQueryKey = (coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams,) => {
    return [`/v2/coaching-managers/me/insights/coaches/${coachId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCmInsightsControllerGetCoachDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, CmInsightsControllerGetCoachDashboardParams['page']>, TError = unknown>(coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, QueryKey, CmInsightsControllerGetCoachDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetCoachDashboardQueryKey(coachId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, QueryKey, CmInsightsControllerGetCoachDashboardParams['page']> = ({ signal, pageParam }) => cmInsightsControllerGetCoachDashboard(coachId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, QueryKey, CmInsightsControllerGetCoachDashboardParams['page']> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetCoachDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>>
export type CmInsightsControllerGetCoachDashboardInfiniteQueryError = unknown

/**
 * @summary 만족도 대시보드 코치 상세 조회
 */
export const useCmInsightsControllerGetCoachDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, CmInsightsControllerGetCoachDashboardParams['page']>, TError = unknown>(
 coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, QueryKey, CmInsightsControllerGetCoachDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetCoachDashboardInfiniteQueryOptions(coachId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmInsightsControllerGetCoachDashboardQueryOptions = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError = unknown>(coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetCoachDashboardQueryKey(coachId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>> = ({ signal }) => cmInsightsControllerGetCoachDashboard(coachId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetCoachDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>>
export type CmInsightsControllerGetCoachDashboardQueryError = unknown

/**
 * @summary 만족도 대시보드 코치 상세 조회
 */
export const useCmInsightsControllerGetCoachDashboard = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError = unknown>(
 coachId: string,
    params?: CmInsightsControllerGetCoachDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCoachDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetCoachDashboardQueryOptions(coachId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 만족도 대시보드 기업 상세 조회
 */
export const cmInsightsControllerGetCompanyDashboard = (
    companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmInsightsControllerGetCompanyDashboard200>(
      {url: `/v2/coaching-managers/me/insights/companies/${companyId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCmInsightsControllerGetCompanyDashboardQueryKey = (companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams,) => {
    return [`/v2/coaching-managers/me/insights/companies/${companyId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCmInsightsControllerGetCompanyDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, CmInsightsControllerGetCompanyDashboardParams['page']>, TError = unknown>(companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, QueryKey, CmInsightsControllerGetCompanyDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetCompanyDashboardQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, QueryKey, CmInsightsControllerGetCompanyDashboardParams['page']> = ({ signal, pageParam }) => cmInsightsControllerGetCompanyDashboard(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, QueryKey, CmInsightsControllerGetCompanyDashboardParams['page']> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetCompanyDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>>
export type CmInsightsControllerGetCompanyDashboardInfiniteQueryError = unknown

/**
 * @summary 만족도 대시보드 기업 상세 조회
 */
export const useCmInsightsControllerGetCompanyDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, CmInsightsControllerGetCompanyDashboardParams['page']>, TError = unknown>(
 companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData, Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, QueryKey, CmInsightsControllerGetCompanyDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetCompanyDashboardInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmInsightsControllerGetCompanyDashboardQueryOptions = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError = unknown>(companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmInsightsControllerGetCompanyDashboardQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>> = ({ signal }) => cmInsightsControllerGetCompanyDashboard(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CmInsightsControllerGetCompanyDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>>
export type CmInsightsControllerGetCompanyDashboardQueryError = unknown

/**
 * @summary 만족도 대시보드 기업 상세 조회
 */
export const useCmInsightsControllerGetCompanyDashboard = <TData = Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError = unknown>(
 companyId: string,
    params?: CmInsightsControllerGetCompanyDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmInsightsControllerGetCompanyDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmInsightsControllerGetCompanyDashboardQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코치 만족도 대시보드 조회
 */
export const coachInsightsControllerGetMyDashboard = (
    params?: CoachInsightsControllerGetMyDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CoachInsightsControllerGetMyDashboard200>(
      {url: `/v2/coaches/me/insights`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCoachInsightsControllerGetMyDashboardQueryKey = (params?: CoachInsightsControllerGetMyDashboardParams,) => {
    return [`/v2/coaches/me/insights`, ...(params ? [params]: [])] as const;
    }

    
export const getCoachInsightsControllerGetMyDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, CoachInsightsControllerGetMyDashboardParams['page']>, TError = unknown>(params?: CoachInsightsControllerGetMyDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData, Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, QueryKey, CoachInsightsControllerGetMyDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachInsightsControllerGetMyDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, QueryKey, CoachInsightsControllerGetMyDashboardParams['page']> = ({ signal, pageParam }) => coachInsightsControllerGetMyDashboard({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData, Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, QueryKey, CoachInsightsControllerGetMyDashboardParams['page']> & { queryKey: QueryKey }
}

export type CoachInsightsControllerGetMyDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>>
export type CoachInsightsControllerGetMyDashboardInfiniteQueryError = unknown

/**
 * @summary 코치 만족도 대시보드 조회
 */
export const useCoachInsightsControllerGetMyDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, CoachInsightsControllerGetMyDashboardParams['page']>, TError = unknown>(
 params?: CoachInsightsControllerGetMyDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData, Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, QueryKey, CoachInsightsControllerGetMyDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachInsightsControllerGetMyDashboardInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCoachInsightsControllerGetMyDashboardQueryOptions = <TData = Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError = unknown>(params?: CoachInsightsControllerGetMyDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCoachInsightsControllerGetMyDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>> = ({ signal }) => coachInsightsControllerGetMyDashboard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type CoachInsightsControllerGetMyDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>>
export type CoachInsightsControllerGetMyDashboardQueryError = unknown

/**
 * @summary 코치 만족도 대시보드 조회
 */
export const useCoachInsightsControllerGetMyDashboard = <TData = Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError = unknown>(
 params?: CoachInsightsControllerGetMyDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof coachInsightsControllerGetMyDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCoachInsightsControllerGetMyDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 케이스 현황 노션 링크를 수정합니다.
 * @summary 케이스 현황 노션 링크 수정
 */
export const cmCaseControllerUpdateCaseDetailNotionUrl = (
    caseId: string,
    updateCaseDetailNotionUrlDtoModel: UpdateCaseDetailNotionUrlDtoModel,
 ) => {
      
      
      return apiClient<CmCaseControllerUpdateCaseDetailNotionUrl200>(
      {url: `/v2/coaching-managers/me/cases/${caseId}/detail-notion-url`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCaseDetailNotionUrlDtoModel
    },
      );
    }
  


export const getCmCaseControllerUpdateCaseDetailNotionUrlMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>, TError,{caseId: string;data: UpdateCaseDetailNotionUrlDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>, TError,{caseId: string;data: UpdateCaseDetailNotionUrlDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>, {caseId: string;data: UpdateCaseDetailNotionUrlDtoModel}> = (props) => {
          const {caseId,data} = props ?? {};

          return  cmCaseControllerUpdateCaseDetailNotionUrl(caseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCaseControllerUpdateCaseDetailNotionUrlMutationResult = NonNullable<Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>>
    export type CmCaseControllerUpdateCaseDetailNotionUrlMutationBody = UpdateCaseDetailNotionUrlDtoModel
    export type CmCaseControllerUpdateCaseDetailNotionUrlMutationError = unknown

    /**
 * @summary 케이스 현황 노션 링크 수정
 */
export const useCmCaseControllerUpdateCaseDetailNotionUrl = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>, TError,{caseId: string;data: UpdateCaseDetailNotionUrlDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCaseControllerUpdateCaseDetailNotionUrl>>,
        TError,
        {caseId: string;data: UpdateCaseDetailNotionUrlDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCaseControllerUpdateCaseDetailNotionUrlMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * reportVersion이 v1이면 슬라이드 데이터를 포함합니다.
 * @summary 코칭 리포트 조회
 */
export const cmCoachingDocumentControllerGetCoachingReport = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCoachingDocumentControllerGetCoachingReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-reports`, method: 'GET', signal
    },
      );
    }
  

export const getCmCoachingDocumentControllerGetCoachingReportQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/coaching-reports`] as const;
    }

    
export const getCmCoachingDocumentControllerGetCoachingReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachingDocumentControllerGetCoachingReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>> = ({ signal }) => cmCoachingDocumentControllerGetCoachingReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachingDocumentControllerGetCoachingReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>>
export type CmCoachingDocumentControllerGetCoachingReportInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 조회
 */
export const useCmCoachingDocumentControllerGetCoachingReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachingDocumentControllerGetCoachingReportInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCoachingDocumentControllerGetCoachingReportQueryOptions = <TData = Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCoachingDocumentControllerGetCoachingReportQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>> = ({ signal }) => cmCoachingDocumentControllerGetCoachingReport(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCoachingDocumentControllerGetCoachingReportQueryResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>>
export type CmCoachingDocumentControllerGetCoachingReportQueryError = unknown

/**
 * @summary 코칭 리포트 조회
 */
export const useCmCoachingDocumentControllerGetCoachingReport = <TData = Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerGetCoachingReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCoachingDocumentControllerGetCoachingReportQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 슬라이드 편집 내용을 저장합니다.
 * @summary 코칭 리포트 슬라이드 저장
 */
export const cmCoachingDocumentControllerSaveSlideData = (
    cycleId: string,
    coachingReportUpdateDtoModel: CoachingReportUpdateDtoModel,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerSaveSlideData200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-reports`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: coachingReportUpdateDtoModel
    },
      );
    }
  


export const getCmCoachingDocumentControllerSaveSlideDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>, {cycleId: string;data: CoachingReportUpdateDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmCoachingDocumentControllerSaveSlideData(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerSaveSlideDataMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>>
    export type CmCoachingDocumentControllerSaveSlideDataMutationBody = CoachingReportUpdateDtoModel
    export type CmCoachingDocumentControllerSaveSlideDataMutationError = unknown

    /**
 * @summary 코칭 리포트 슬라이드 저장
 */
export const useCmCoachingDocumentControllerSaveSlideData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>, TError,{cycleId: string;data: CoachingReportUpdateDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerSaveSlideData>>,
        TError,
        {cycleId: string;data: CoachingReportUpdateDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerSaveSlideDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 플랜 완료 취소
 */
export const cmCoachingDocumentControllerUndoCoachingPlanCompletion = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerUndoCoachingPlanCompletion200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plans/incomplete`, method: 'PATCH'
    },
      );
    }
  


export const getCmCoachingDocumentControllerUndoCoachingPlanCompletionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachingDocumentControllerUndoCoachingPlanCompletion(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerUndoCoachingPlanCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>>
    
    export type CmCoachingDocumentControllerUndoCoachingPlanCompletionMutationError = unknown

    /**
 * @summary 코칭 플랜 완료 취소
 */
export const useCmCoachingDocumentControllerUndoCoachingPlanCompletion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingPlanCompletion>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerUndoCoachingPlanCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 리포트 완료 취소
 */
export const cmCoachingDocumentControllerUndoCoachingReportCompletion = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerUndoCoachingReportCompletion200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-reports/incomplete`, method: 'PATCH'
    },
      );
    }
  


export const getCmCoachingDocumentControllerUndoCoachingReportCompletionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachingDocumentControllerUndoCoachingReportCompletion(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerUndoCoachingReportCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>>
    
    export type CmCoachingDocumentControllerUndoCoachingReportCompletionMutationError = unknown

    /**
 * @summary 코칭 리포트 완료 취소
 */
export const useCmCoachingDocumentControllerUndoCoachingReportCompletion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoCoachingReportCompletion>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerUndoCoachingReportCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리더십 다면진단 리포트 완료 취소
 */
export const cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerUndoPeerFeedbackReportCompletion200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/peer-feedback-reports/incomplete`, method: 'PATCH'
    },
      );
    }
  


export const getCmCoachingDocumentControllerUndoPeerFeedbackReportCompletionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerUndoPeerFeedbackReportCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>>
    
    export type CmCoachingDocumentControllerUndoPeerFeedbackReportCompletionMutationError = unknown

    /**
 * @summary 리더십 다면진단 리포트 완료 취소
 */
export const useCmCoachingDocumentControllerUndoPeerFeedbackReportCompletion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerUndoPeerFeedbackReportCompletion>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerUndoPeerFeedbackReportCompletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 플랜 완료 처리
 */
export const cmCoachingDocumentControllerCompleteCoachingPlan = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerCompleteCoachingPlan200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-plans/complete`, method: 'PATCH'
    },
      );
    }
  


export const getCmCoachingDocumentControllerCompleteCoachingPlanMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachingDocumentControllerCompleteCoachingPlan(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerCompleteCoachingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>>
    
    export type CmCoachingDocumentControllerCompleteCoachingPlanMutationError = unknown

    /**
 * @summary 코칭 플랜 완료 처리
 */
export const useCmCoachingDocumentControllerCompleteCoachingPlan = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingPlan>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerCompleteCoachingPlanMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 코칭 리포트 완료 처리
 */
export const cmCoachingDocumentControllerCompleteCoachingReport = (
    cycleId: string,
 ) => {
      
      
      return apiClient<CmCoachingDocumentControllerCompleteCoachingReport200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/coaching-reports/complete`, method: 'PATCH'
    },
      );
    }
  


export const getCmCoachingDocumentControllerCompleteCoachingReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>, TError,{cycleId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>, {cycleId: string}> = (props) => {
          const {cycleId} = props ?? {};

          return  cmCoachingDocumentControllerCompleteCoachingReport(cycleId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCoachingDocumentControllerCompleteCoachingReportMutationResult = NonNullable<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>>
    
    export type CmCoachingDocumentControllerCompleteCoachingReportMutationError = unknown

    /**
 * @summary 코칭 리포트 완료 처리
 */
export const useCmCoachingDocumentControllerCompleteCoachingReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>, TError,{cycleId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCoachingDocumentControllerCompleteCoachingReport>>,
        TError,
        {cycleId: string},
        TContext
      > => {

      const mutationOptions = getCmCoachingDocumentControllerCompleteCoachingReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 사이클에 할당된 대상자 만족도 조사 결과 목록 조회
 */
export const caseFeedbackControllerGetCaseFeedbacks = (
    cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseFeedbackControllerGetCaseFeedbacks200>(
      {url: `/v2/case-feedbacks/cycles/${cycleId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getCaseFeedbackControllerGetCaseFeedbacksQueryKey = (cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams,) => {
    return [`/v2/case-feedbacks/cycles/${cycleId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCaseFeedbackControllerGetCaseFeedbacksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, CaseFeedbackControllerGetCaseFeedbacksParams['page']>, TError = unknown>(cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData, Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, QueryKey, CaseFeedbackControllerGetCaseFeedbacksParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerGetCaseFeedbacksQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, QueryKey, CaseFeedbackControllerGetCaseFeedbacksParams['page']> = ({ signal, pageParam }) => caseFeedbackControllerGetCaseFeedbacks(cycleId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData, Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, QueryKey, CaseFeedbackControllerGetCaseFeedbacksParams['page']> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerGetCaseFeedbacksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>>
export type CaseFeedbackControllerGetCaseFeedbacksInfiniteQueryError = unknown

/**
 * @summary 사이클에 할당된 대상자 만족도 조사 결과 목록 조회
 */
export const useCaseFeedbackControllerGetCaseFeedbacksInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, CaseFeedbackControllerGetCaseFeedbacksParams['page']>, TError = unknown>(
 cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData, Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, QueryKey, CaseFeedbackControllerGetCaseFeedbacksParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerGetCaseFeedbacksInfiniteQueryOptions(cycleId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseFeedbackControllerGetCaseFeedbacksQueryOptions = <TData = Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError = unknown>(cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerGetCaseFeedbacksQueryKey(cycleId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>> = ({ signal }) => caseFeedbackControllerGetCaseFeedbacks(cycleId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerGetCaseFeedbacksQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>>
export type CaseFeedbackControllerGetCaseFeedbacksQueryError = unknown

/**
 * @summary 사이클에 할당된 대상자 만족도 조사 결과 목록 조회
 */
export const useCaseFeedbackControllerGetCaseFeedbacks = <TData = Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError = unknown>(
 cycleId: string,
    params?: CaseFeedbackControllerGetCaseFeedbacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerGetCaseFeedbacks>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerGetCaseFeedbacksQueryOptions(cycleId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 만족도 조사 제출
 */
export const caseFeedbackControllerSubmitCaseFeedback = (
    cycleId: string,
    caseFeedbackRequestDtoModel: CaseFeedbackRequestDtoModel,
 ) => {
      
      
      return apiClient<CaseFeedbackControllerSubmitCaseFeedback200>(
      {url: `/v2/case-feedbacks/cycles/${cycleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: caseFeedbackRequestDtoModel
    },
      );
    }
  


export const getCaseFeedbackControllerSubmitCaseFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>, TError,{cycleId: string;data: CaseFeedbackRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>, TError,{cycleId: string;data: CaseFeedbackRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>, {cycleId: string;data: CaseFeedbackRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  caseFeedbackControllerSubmitCaseFeedback(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseFeedbackControllerSubmitCaseFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>>
    export type CaseFeedbackControllerSubmitCaseFeedbackMutationBody = CaseFeedbackRequestDtoModel
    export type CaseFeedbackControllerSubmitCaseFeedbackMutationError = unknown

    /**
 * @summary 만족도 조사 제출
 */
export const useCaseFeedbackControllerSubmitCaseFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>, TError,{cycleId: string;data: CaseFeedbackRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseFeedbackControllerSubmitCaseFeedback>>,
        TError,
        {cycleId: string;data: CaseFeedbackRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseFeedbackControllerSubmitCaseFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 세션 만족도 조사 제출 여부 확인
 */
export const caseFeedbackControllerCheckSessionFeedbackExists = (
    sessionId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseFeedbackControllerCheckSessionFeedbackExists200>(
      {url: `/v2/case-feedbacks/sessions/${sessionId}/exists`, method: 'GET', signal
    },
      );
    }
  

export const getCaseFeedbackControllerCheckSessionFeedbackExistsQueryKey = (sessionId: string,) => {
    return [`/v2/case-feedbacks/sessions/${sessionId}/exists`] as const;
    }

    
export const getCaseFeedbackControllerCheckSessionFeedbackExistsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>>, TError = unknown>(sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckSessionFeedbackExistsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>> = ({ signal }) => caseFeedbackControllerCheckSessionFeedbackExists(sessionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckSessionFeedbackExistsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>>
export type CaseFeedbackControllerCheckSessionFeedbackExistsInfiniteQueryError = unknown

/**
 * @summary 세션 만족도 조사 제출 여부 확인
 */
export const useCaseFeedbackControllerCheckSessionFeedbackExistsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>>, TError = unknown>(
 sessionId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckSessionFeedbackExistsInfiniteQueryOptions(sessionId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseFeedbackControllerCheckSessionFeedbackExistsQueryOptions = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError = unknown>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckSessionFeedbackExistsQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>> = ({ signal }) => caseFeedbackControllerCheckSessionFeedbackExists(sessionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckSessionFeedbackExistsQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>>
export type CaseFeedbackControllerCheckSessionFeedbackExistsQueryError = unknown

/**
 * @summary 세션 만족도 조사 제출 여부 확인
 */
export const useCaseFeedbackControllerCheckSessionFeedbackExists = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError = unknown>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckSessionFeedbackExists>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckSessionFeedbackExistsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 리포트 조회 시 7회기 만족도 조사 트리거 여부 조회
 */
export const caseFeedbackControllerCheckByCoachingReportId = (
    coachingReportId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseFeedbackControllerCheckByCoachingReportId200>(
      {url: `/v2/case-feedbacks/check-by-coaching-report/${coachingReportId}`, method: 'GET', signal
    },
      );
    }
  

export const getCaseFeedbackControllerCheckByCoachingReportIdQueryKey = (coachingReportId: string,) => {
    return [`/v2/case-feedbacks/check-by-coaching-report/${coachingReportId}`] as const;
    }

    
export const getCaseFeedbackControllerCheckByCoachingReportIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>>, TError = unknown>(coachingReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckByCoachingReportIdQueryKey(coachingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>> = ({ signal }) => caseFeedbackControllerCheckByCoachingReportId(coachingReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingReportId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckByCoachingReportIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>>
export type CaseFeedbackControllerCheckByCoachingReportIdInfiniteQueryError = unknown

/**
 * @summary 코칭 리포트 조회 시 7회기 만족도 조사 트리거 여부 조회
 */
export const useCaseFeedbackControllerCheckByCoachingReportIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>>, TError = unknown>(
 coachingReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckByCoachingReportIdInfiniteQueryOptions(coachingReportId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseFeedbackControllerCheckByCoachingReportIdQueryOptions = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError = unknown>(coachingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckByCoachingReportIdQueryKey(coachingReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>> = ({ signal }) => caseFeedbackControllerCheckByCoachingReportId(coachingReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckByCoachingReportIdQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>>
export type CaseFeedbackControllerCheckByCoachingReportIdQueryError = unknown

/**
 * @summary 코칭 리포트 조회 시 7회기 만족도 조사 트리거 여부 조회
 */
export const useCaseFeedbackControllerCheckByCoachingReportId = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError = unknown>(
 coachingReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingReportId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckByCoachingReportIdQueryOptions(coachingReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 코칭 노트 조회 시 만족도 조사 트리거 여부 조회
 */
export const caseFeedbackControllerCheckByCoachingNoteId = (
    coachingNoteId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CaseFeedbackControllerCheckByCoachingNoteId200>(
      {url: `/v2/case-feedbacks/check-by-coaching-note/${coachingNoteId}`, method: 'GET', signal
    },
      );
    }
  

export const getCaseFeedbackControllerCheckByCoachingNoteIdQueryKey = (coachingNoteId: string,) => {
    return [`/v2/case-feedbacks/check-by-coaching-note/${coachingNoteId}`] as const;
    }

    
export const getCaseFeedbackControllerCheckByCoachingNoteIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>>, TError = unknown>(coachingNoteId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckByCoachingNoteIdQueryKey(coachingNoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>> = ({ signal }) => caseFeedbackControllerCheckByCoachingNoteId(coachingNoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingNoteId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckByCoachingNoteIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>>
export type CaseFeedbackControllerCheckByCoachingNoteIdInfiniteQueryError = unknown

/**
 * @summary 코칭 노트 조회 시 만족도 조사 트리거 여부 조회
 */
export const useCaseFeedbackControllerCheckByCoachingNoteIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>>, TError = unknown>(
 coachingNoteId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckByCoachingNoteIdInfiniteQueryOptions(coachingNoteId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCaseFeedbackControllerCheckByCoachingNoteIdQueryOptions = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError = unknown>(coachingNoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCaseFeedbackControllerCheckByCoachingNoteIdQueryKey(coachingNoteId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>> = ({ signal }) => caseFeedbackControllerCheckByCoachingNoteId(coachingNoteId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(coachingNoteId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData> & { queryKey: QueryKey }
}

export type CaseFeedbackControllerCheckByCoachingNoteIdQueryResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>>
export type CaseFeedbackControllerCheckByCoachingNoteIdQueryError = unknown

/**
 * @summary 코칭 노트 조회 시 만족도 조사 트리거 여부 조회
 */
export const useCaseFeedbackControllerCheckByCoachingNoteId = <TData = Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError = unknown>(
 coachingNoteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof caseFeedbackControllerCheckByCoachingNoteId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCaseFeedbackControllerCheckByCoachingNoteIdQueryOptions(coachingNoteId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 만족도 조사 부분 응답(점수만) 저장
 */
export const caseFeedbackControllerSavePartialCaseFeedback = (
    cycleId: string,
    partialCaseFeedbackRequestDtoModel: PartialCaseFeedbackRequestDtoModel,
 ) => {
      
      
      return apiClient<CaseFeedbackControllerSavePartialCaseFeedback200>(
      {url: `/v2/case-feedbacks/cycles/${cycleId}/partial-responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: partialCaseFeedbackRequestDtoModel
    },
      );
    }
  


export const getCaseFeedbackControllerSavePartialCaseFeedbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>, TError,{cycleId: string;data: PartialCaseFeedbackRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>, TError,{cycleId: string;data: PartialCaseFeedbackRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>, {cycleId: string;data: PartialCaseFeedbackRequestDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  caseFeedbackControllerSavePartialCaseFeedback(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CaseFeedbackControllerSavePartialCaseFeedbackMutationResult = NonNullable<Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>>
    export type CaseFeedbackControllerSavePartialCaseFeedbackMutationBody = PartialCaseFeedbackRequestDtoModel
    export type CaseFeedbackControllerSavePartialCaseFeedbackMutationError = unknown

    /**
 * @summary 만족도 조사 부분 응답(점수만) 저장
 */
export const useCaseFeedbackControllerSavePartialCaseFeedback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>, TError,{cycleId: string;data: PartialCaseFeedbackRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof caseFeedbackControllerSavePartialCaseFeedback>>,
        TError,
        {cycleId: string;data: PartialCaseFeedbackRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCaseFeedbackControllerSavePartialCaseFeedbackMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 업피플 코치 목록을 조회합니다
 * @summary 코치 목록 조회
 */
export const settlementControllerGetCoaches = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<SettlementControllerGetCoaches200>(
      {url: `/v2/settlement/coaches`, method: 'GET', signal
    },
      );
    }
  

export const getSettlementControllerGetCoachesQueryKey = () => {
    return [`/v2/settlement/coaches`] as const;
    }

    
export const getSettlementControllerGetCoachesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof settlementControllerGetCoaches>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettlementControllerGetCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof settlementControllerGetCoaches>>> = ({ signal }) => settlementControllerGetCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type SettlementControllerGetCoachesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof settlementControllerGetCoaches>>>
export type SettlementControllerGetCoachesInfiniteQueryError = unknown

/**
 * @summary 코치 목록 조회
 */
export const useSettlementControllerGetCoachesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof settlementControllerGetCoaches>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSettlementControllerGetCoachesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSettlementControllerGetCoachesQueryOptions = <TData = Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettlementControllerGetCoachesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof settlementControllerGetCoaches>>> = ({ signal }) => settlementControllerGetCoaches(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData> & { queryKey: QueryKey }
}

export type SettlementControllerGetCoachesQueryResult = NonNullable<Awaited<ReturnType<typeof settlementControllerGetCoaches>>>
export type SettlementControllerGetCoachesQueryError = unknown

/**
 * @summary 코치 목록 조회
 */
export const useSettlementControllerGetCoaches = <TData = Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoaches>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSettlementControllerGetCoachesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 기간별 업피플 코칭 세션 목록을 조회합니다
 * @summary 기간별 코칭 세션 목록 조회
 */
export const settlementControllerGetCoachingSessions = (
    params: SettlementControllerGetCoachingSessionsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SettlementControllerGetCoachingSessions200>(
      {url: `/v2/settlement/sessions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getSettlementControllerGetCoachingSessionsQueryKey = (params: SettlementControllerGetCoachingSessionsParams,) => {
    return [`/v2/settlement/sessions`, ...(params ? [params]: [])] as const;
    }

    
export const getSettlementControllerGetCoachingSessionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, SettlementControllerGetCoachingSessionsParams['page']>, TError = unknown>(params: SettlementControllerGetCoachingSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData, Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, QueryKey, SettlementControllerGetCoachingSessionsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettlementControllerGetCoachingSessionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, QueryKey, SettlementControllerGetCoachingSessionsParams['page']> = ({ signal, pageParam }) => settlementControllerGetCoachingSessions({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData, Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, QueryKey, SettlementControllerGetCoachingSessionsParams['page']> & { queryKey: QueryKey }
}

export type SettlementControllerGetCoachingSessionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>>
export type SettlementControllerGetCoachingSessionsInfiniteQueryError = unknown

/**
 * @summary 기간별 코칭 세션 목록 조회
 */
export const useSettlementControllerGetCoachingSessionsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, SettlementControllerGetCoachingSessionsParams['page']>, TError = unknown>(
 params: SettlementControllerGetCoachingSessionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData, Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, QueryKey, SettlementControllerGetCoachingSessionsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSettlementControllerGetCoachingSessionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSettlementControllerGetCoachingSessionsQueryOptions = <TData = Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError = unknown>(params: SettlementControllerGetCoachingSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSettlementControllerGetCoachingSessionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>> = ({ signal }) => settlementControllerGetCoachingSessions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData> & { queryKey: QueryKey }
}

export type SettlementControllerGetCoachingSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>>
export type SettlementControllerGetCoachingSessionsQueryError = unknown

/**
 * @summary 기간별 코칭 세션 목록 조회
 */
export const useSettlementControllerGetCoachingSessions = <TData = Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError = unknown>(
 params: SettlementControllerGetCoachingSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof settlementControllerGetCoachingSessions>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSettlementControllerGetCoachingSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 인사담당자 진행중인 사이클 목록 조회
 */
export const hrCycleControllerGetActiveCycles = (
    params: HrCycleControllerGetActiveCyclesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrCycleControllerGetActiveCycles200>(
      {url: `/v2/hrs/cycles/active`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHrCycleControllerGetActiveCyclesQueryKey = (params: HrCycleControllerGetActiveCyclesParams,) => {
    return [`/v2/hrs/cycles/active`, ...(params ? [params]: [])] as const;
    }

    
export const getHrCycleControllerGetActiveCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, HrCycleControllerGetActiveCyclesParams['page']>, TError = unknown>(params: HrCycleControllerGetActiveCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, QueryKey, HrCycleControllerGetActiveCyclesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCycleControllerGetActiveCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, QueryKey, HrCycleControllerGetActiveCyclesParams['page']> = ({ signal, pageParam }) => hrCycleControllerGetActiveCycles({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, QueryKey, HrCycleControllerGetActiveCyclesParams['page']> & { queryKey: QueryKey }
}

export type HrCycleControllerGetActiveCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>>
export type HrCycleControllerGetActiveCyclesInfiniteQueryError = unknown

/**
 * @summary 인사담당자 진행중인 사이클 목록 조회
 */
export const useHrCycleControllerGetActiveCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, HrCycleControllerGetActiveCyclesParams['page']>, TError = unknown>(
 params: HrCycleControllerGetActiveCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, QueryKey, HrCycleControllerGetActiveCyclesParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCycleControllerGetActiveCyclesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHrCycleControllerGetActiveCyclesQueryOptions = <TData = Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError = unknown>(params: HrCycleControllerGetActiveCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCycleControllerGetActiveCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>> = ({ signal }) => hrCycleControllerGetActiveCycles(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type HrCycleControllerGetActiveCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>>
export type HrCycleControllerGetActiveCyclesQueryError = unknown

/**
 * @summary 인사담당자 진행중인 사이클 목록 조회
 */
export const useHrCycleControllerGetActiveCycles = <TData = Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError = unknown>(
 params: HrCycleControllerGetActiveCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetActiveCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCycleControllerGetActiveCyclesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 인사담당자 완료된 사이클 목록 조회
 */
export const hrCycleControllerGetCompleteCycles = (
    params: HrCycleControllerGetCompleteCyclesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrCycleControllerGetCompleteCycles200>(
      {url: `/v2/hrs/cycles/complete`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHrCycleControllerGetCompleteCyclesQueryKey = (params: HrCycleControllerGetCompleteCyclesParams,) => {
    return [`/v2/hrs/cycles/complete`, ...(params ? [params]: [])] as const;
    }

    
export const getHrCycleControllerGetCompleteCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, HrCycleControllerGetCompleteCyclesParams['page']>, TError = unknown>(params: HrCycleControllerGetCompleteCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, QueryKey, HrCycleControllerGetCompleteCyclesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCycleControllerGetCompleteCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, QueryKey, HrCycleControllerGetCompleteCyclesParams['page']> = ({ signal, pageParam }) => hrCycleControllerGetCompleteCycles({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, QueryKey, HrCycleControllerGetCompleteCyclesParams['page']> & { queryKey: QueryKey }
}

export type HrCycleControllerGetCompleteCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>>
export type HrCycleControllerGetCompleteCyclesInfiniteQueryError = unknown

/**
 * @summary 인사담당자 완료된 사이클 목록 조회
 */
export const useHrCycleControllerGetCompleteCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, HrCycleControllerGetCompleteCyclesParams['page']>, TError = unknown>(
 params: HrCycleControllerGetCompleteCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData, Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, QueryKey, HrCycleControllerGetCompleteCyclesParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCycleControllerGetCompleteCyclesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHrCycleControllerGetCompleteCyclesQueryOptions = <TData = Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError = unknown>(params: HrCycleControllerGetCompleteCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCycleControllerGetCompleteCyclesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>> = ({ signal }) => hrCycleControllerGetCompleteCycles(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type HrCycleControllerGetCompleteCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>>
export type HrCycleControllerGetCompleteCyclesQueryError = unknown

/**
 * @summary 인사담당자 완료된 사이클 목록 조회
 */
export const useHrCycleControllerGetCompleteCycles = <TData = Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError = unknown>(
 params: HrCycleControllerGetCompleteCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCycleControllerGetCompleteCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCycleControllerGetCompleteCyclesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 인사담당자 목록 조회
 */
export const hrControllerGetHrs = (
    params: HrControllerGetHrsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrControllerGetHrs200>(
      {url: `/v2/hrs`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHrControllerGetHrsQueryKey = (params: HrControllerGetHrsParams,) => {
    return [`/v2/hrs`, ...(params ? [params]: [])] as const;
    }

    
export const getHrControllerGetHrsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hrControllerGetHrs>>, HrControllerGetHrsParams['page']>, TError = unknown>(params: HrControllerGetHrsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData, Awaited<ReturnType<typeof hrControllerGetHrs>>, QueryKey, HrControllerGetHrsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrControllerGetHrsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrControllerGetHrs>>, QueryKey, HrControllerGetHrsParams['page']> = ({ signal, pageParam }) => hrControllerGetHrs({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData, Awaited<ReturnType<typeof hrControllerGetHrs>>, QueryKey, HrControllerGetHrsParams['page']> & { queryKey: QueryKey }
}

export type HrControllerGetHrsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hrControllerGetHrs>>>
export type HrControllerGetHrsInfiniteQueryError = unknown

/**
 * @summary 인사담당자 목록 조회
 */
export const useHrControllerGetHrsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof hrControllerGetHrs>>, HrControllerGetHrsParams['page']>, TError = unknown>(
 params: HrControllerGetHrsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData, Awaited<ReturnType<typeof hrControllerGetHrs>>, QueryKey, HrControllerGetHrsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrControllerGetHrsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHrControllerGetHrsQueryOptions = <TData = Awaited<ReturnType<typeof hrControllerGetHrs>>, TError = unknown>(params: HrControllerGetHrsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrControllerGetHrsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrControllerGetHrs>>> = ({ signal }) => hrControllerGetHrs(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData> & { queryKey: QueryKey }
}

export type HrControllerGetHrsQueryResult = NonNullable<Awaited<ReturnType<typeof hrControllerGetHrs>>>
export type HrControllerGetHrsQueryError = unknown

/**
 * @summary 인사담당자 목록 조회
 */
export const useHrControllerGetHrs = <TData = Awaited<ReturnType<typeof hrControllerGetHrs>>, TError = unknown>(
 params: HrControllerGetHrsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrControllerGetHrs>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrControllerGetHrsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 특정 고객회사의 사이클 목록을 조회합니다. showCompleted=true로 설정하면 완료된 사이클도 포함됩니다.
 * @summary 고객회사의 사이클 목록 조회
 */
export const consoleDataDashboardControllerGetCompanyCycles = (
    companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ConsoleDataDashboardControllerGetCompanyCycles200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/cycles`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerGetCompanyCyclesQueryKey = (companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/cycles`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerGetCompanyCyclesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, QueryKey, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetCompanyCyclesQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, QueryKey, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerGetCompanyCycles(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, QueryKey, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetCompanyCyclesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>>
export type ConsoleDataDashboardControllerGetCompanyCyclesInfiniteQueryError = unknown

/**
 * @summary 고객회사의 사이클 목록 조회
 */
export const useConsoleDataDashboardControllerGetCompanyCyclesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, QueryKey, ConsoleDataDashboardControllerGetCompanyCyclesParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetCompanyCyclesInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerGetCompanyCyclesQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetCompanyCyclesQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>> = ({ signal }) => consoleDataDashboardControllerGetCompanyCycles(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetCompanyCyclesQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>>
export type ConsoleDataDashboardControllerGetCompanyCyclesQueryError = unknown

/**
 * @summary 고객회사의 사이클 목록 조회
 */
export const useConsoleDataDashboardControllerGetCompanyCycles = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetCompanyCyclesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetCompanyCycles>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetCompanyCyclesQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 여러 사이클을 선택하여 데이터 대시보드를 조회합니다.
 * @summary 대시보드 데이터 조회 (다중 사이클 지원)
 */
export const consoleDataDashboardControllerGetDashboard = (
    companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ConsoleDataDashboardControllerGetDashboard200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/dashboard`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerGetDashboardQueryKey = (companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/dashboard`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerGetDashboardInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, ConsoleDataDashboardControllerGetDashboardParams['page']>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, QueryKey, ConsoleDataDashboardControllerGetDashboardParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetDashboardQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, QueryKey, ConsoleDataDashboardControllerGetDashboardParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerGetDashboard(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, QueryKey, ConsoleDataDashboardControllerGetDashboardParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetDashboardInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>>
export type ConsoleDataDashboardControllerGetDashboardInfiniteQueryError = unknown

/**
 * @summary 대시보드 데이터 조회 (다중 사이클 지원)
 */
export const useConsoleDataDashboardControllerGetDashboardInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, ConsoleDataDashboardControllerGetDashboardParams['page']>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, QueryKey, ConsoleDataDashboardControllerGetDashboardParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetDashboardInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetDashboardQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>> = ({ signal }) => consoleDataDashboardControllerGetDashboard(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>>
export type ConsoleDataDashboardControllerGetDashboardQueryError = unknown

/**
 * @summary 대시보드 데이터 조회 (다중 사이클 지원)
 */
export const useConsoleDataDashboardControllerGetDashboard = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboard>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetDashboardQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 고객사 기본 정보 섹션의 모든 파일(코칭 배경, 회사 문화, 기타 파일)을 zip으로 압축하여 다운로드합니다.
 * @summary 고객사 기본 정보 전체 원본 다운로드 (zip 압축)
 */
export const consoleDataDashboardControllerDownloadCompanyBasicInfoZip = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/download-company-basic-info-zip`, method: 'GET', signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryKey = (companyId: string,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/download-company-basic-info-zip`] as const;
    }

    
export const getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>> = ({ signal }) => consoleDataDashboardControllerDownloadCompanyBasicInfoZip(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCompanyBasicInfoZipInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>>
export type ConsoleDataDashboardControllerDownloadCompanyBasicInfoZipInfiniteQueryError = unknown

/**
 * @summary 고객사 기본 정보 전체 원본 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadCompanyBasicInfoZipInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>> = ({ signal }) => consoleDataDashboardControllerDownloadCompanyBasicInfoZip(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>>
export type ConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryError = unknown

/**
 * @summary 고객사 기본 정보 전체 원본 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadCompanyBasicInfoZip = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyBasicInfoZip>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCompanyBasicInfoZipQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 코칭 대상자 개별 데이터 섹션의 특정 사이클에 속한 모든 파일(LCD, 코칭 플랜 txt, 코칭 노트 txt, 코칭 리포트 txt, 기타 파일)을 zip으로 압축하여 다운로드합니다.
 * @summary 코칭 대상자 개별 데이터 전체 원본 다운로드 (zip 압축)
 */
export const consoleDataDashboardControllerDownloadCaseIndividualDataZip = (
    companyId: string,
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/download-case-individual-data-zip`, method: 'GET', signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryKey = (companyId: string,
    cycleId: string,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/download-case-individual-data-zip`] as const;
    }

    
export const getConsoleDataDashboardControllerDownloadCaseIndividualDataZipInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>>, TError = unknown>(companyId: string,
    cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryKey(companyId,cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>> = ({ signal }) => consoleDataDashboardControllerDownloadCaseIndividualDataZip(companyId,cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCaseIndividualDataZipInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>>
export type ConsoleDataDashboardControllerDownloadCaseIndividualDataZipInfiniteQueryError = unknown

/**
 * @summary 코칭 대상자 개별 데이터 전체 원본 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadCaseIndividualDataZipInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>>, TError = unknown>(
 companyId: string,
    cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCaseIndividualDataZipInfiniteQueryOptions(companyId,cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError = unknown>(companyId: string,
    cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryKey(companyId,cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>> = ({ signal }) => consoleDataDashboardControllerDownloadCaseIndividualDataZip(companyId,cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>>
export type ConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryError = unknown

/**
 * @summary 코칭 대상자 개별 데이터 전체 원본 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadCaseIndividualDataZip = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError = unknown>(
 companyId: string,
    cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCaseIndividualDataZip>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCaseIndividualDataZipQueryOptions(companyId,cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 데이터 대시보드에 개인별 데이터 파일을 업로드합니다.
 * @summary 파일 업로드 (개인별 데이터)
 */
export const consoleDataDashboardControllerUploadCycleFile = (
    companyId: string,
    cycleId: string,
    consoleDataDashboardControllerUploadCycleFileBody: ConsoleDataDashboardControllerUploadCycleFileBody,
 ) => {
      
      const formData = new FormData();
formData.append('file', consoleDataDashboardControllerUploadCycleFileBody.file)
formData.append('fileType', consoleDataDashboardControllerUploadCycleFileBody.fileType)
if(consoleDataDashboardControllerUploadCycleFileBody.context !== undefined) {
 formData.append('context', consoleDataDashboardControllerUploadCycleFileBody.context)
 }
if(consoleDataDashboardControllerUploadCycleFileBody.fileName !== undefined) {
 formData.append('fileName', consoleDataDashboardControllerUploadCycleFileBody.fileName)
 }

      return apiClient<ConsoleDataDashboardControllerUploadCycleFile200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getConsoleDataDashboardControllerUploadCycleFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>, TError,{companyId: string;cycleId: string;data: ConsoleDataDashboardControllerUploadCycleFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>, TError,{companyId: string;cycleId: string;data: ConsoleDataDashboardControllerUploadCycleFileBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>, {companyId: string;cycleId: string;data: ConsoleDataDashboardControllerUploadCycleFileBody}> = (props) => {
          const {companyId,cycleId,data} = props ?? {};

          return  consoleDataDashboardControllerUploadCycleFile(companyId,cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerUploadCycleFileMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>>
    export type ConsoleDataDashboardControllerUploadCycleFileMutationBody = ConsoleDataDashboardControllerUploadCycleFileBody
    export type ConsoleDataDashboardControllerUploadCycleFileMutationError = unknown

    /**
 * @summary 파일 업로드 (개인별 데이터)
 */
export const useConsoleDataDashboardControllerUploadCycleFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>, TError,{companyId: string;cycleId: string;data: ConsoleDataDashboardControllerUploadCycleFileBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCycleFile>>,
        TError,
        {companyId: string;cycleId: string;data: ConsoleDataDashboardControllerUploadCycleFileBody},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerUploadCycleFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 데이터 대시보드에 회사 공통 데이터 파일을 업로드합니다.
 * @summary 파일 업로드 (회사 공통 데이터)
 */
export const consoleDataDashboardControllerUploadCompanyFile = (
    companyId: string,
    consoleDataDashboardControllerUploadCompanyFileBody: ConsoleDataDashboardControllerUploadCompanyFileBody,
 ) => {
      
      const formData = new FormData();
formData.append('file', consoleDataDashboardControllerUploadCompanyFileBody.file)
formData.append('fileType', consoleDataDashboardControllerUploadCompanyFileBody.fileType)
if(consoleDataDashboardControllerUploadCompanyFileBody.context !== undefined) {
 formData.append('context', consoleDataDashboardControllerUploadCompanyFileBody.context)
 }
if(consoleDataDashboardControllerUploadCompanyFileBody.fileName !== undefined) {
 formData.append('fileName', consoleDataDashboardControllerUploadCompanyFileBody.fileName)
 }

      return apiClient<ConsoleDataDashboardControllerUploadCompanyFile200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/upload`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getConsoleDataDashboardControllerUploadCompanyFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>, TError,{companyId: string;data: ConsoleDataDashboardControllerUploadCompanyFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>, TError,{companyId: string;data: ConsoleDataDashboardControllerUploadCompanyFileBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>, {companyId: string;data: ConsoleDataDashboardControllerUploadCompanyFileBody}> = (props) => {
          const {companyId,data} = props ?? {};

          return  consoleDataDashboardControllerUploadCompanyFile(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerUploadCompanyFileMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>>
    export type ConsoleDataDashboardControllerUploadCompanyFileMutationBody = ConsoleDataDashboardControllerUploadCompanyFileBody
    export type ConsoleDataDashboardControllerUploadCompanyFileMutationError = unknown

    /**
 * @summary 파일 업로드 (회사 공통 데이터)
 */
export const useConsoleDataDashboardControllerUploadCompanyFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>, TError,{companyId: string;data: ConsoleDataDashboardControllerUploadCompanyFileBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerUploadCompanyFile>>,
        TError,
        {companyId: string;data: ConsoleDataDashboardControllerUploadCompanyFileBody},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerUploadCompanyFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 고객사의 조직 리포트 목록을 최신순으로 조회합니다.
 * @summary 조직 리포트 목록 조회
 */
export const consoleDataDashboardControllerGetOrgReports = (
    companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ConsoleDataDashboardControllerGetOrgReports200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/org-reports`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerGetOrgReportsQueryKey = (companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/org-reports`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerGetOrgReportsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, ConsoleDataDashboardControllerGetOrgReportsParams['page']>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, QueryKey, ConsoleDataDashboardControllerGetOrgReportsParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetOrgReportsQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, QueryKey, ConsoleDataDashboardControllerGetOrgReportsParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerGetOrgReports(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, QueryKey, ConsoleDataDashboardControllerGetOrgReportsParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetOrgReportsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>>
export type ConsoleDataDashboardControllerGetOrgReportsInfiniteQueryError = unknown

/**
 * @summary 조직 리포트 목록 조회
 */
export const useConsoleDataDashboardControllerGetOrgReportsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, ConsoleDataDashboardControllerGetOrgReportsParams['page']>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, QueryKey, ConsoleDataDashboardControllerGetOrgReportsParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetOrgReportsInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerGetOrgReportsQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError = unknown>(companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetOrgReportsQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>> = ({ signal }) => consoleDataDashboardControllerGetOrgReports(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetOrgReportsQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>>
export type ConsoleDataDashboardControllerGetOrgReportsQueryError = unknown

/**
 * @summary 조직 리포트 목록 조회
 */
export const useConsoleDataDashboardControllerGetOrgReports = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError = unknown>(
 companyId: string,
    params?: ConsoleDataDashboardControllerGetOrgReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetOrgReports>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetOrgReportsQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 선택한 사이클들의 개인 슬라이드 데이터를 종합하여 AI로 조직 단위 인사이트 리포트를 생성합니다.
 * @summary 조직 리포트 생성
 */
export const consoleDataDashboardControllerGenerateOrgReport = (
    companyId: string,
    consoleDataDashboardControllerGenerateOrgReportBody: ConsoleDataDashboardControllerGenerateOrgReportBody,
 ) => {
      
      const formData = new FormData();
consoleDataDashboardControllerGenerateOrgReportBody.cycleIds.forEach(value => formData.append('cycleIds', value));
if(consoleDataDashboardControllerGenerateOrgReportBody.name !== undefined && consoleDataDashboardControllerGenerateOrgReportBody.name !== null) {
 formData.append('name', consoleDataDashboardControllerGenerateOrgReportBody.name)
 }
if(consoleDataDashboardControllerGenerateOrgReportBody.prepcallFiles !== undefined && consoleDataDashboardControllerGenerateOrgReportBody.prepcallFiles !== null) {
 consoleDataDashboardControllerGenerateOrgReportBody.prepcallFiles.forEach(value => formData.append('prepcallFiles', value));
 }

      return apiClient<ConsoleDataDashboardControllerGenerateOrgReport200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/org-reports`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      );
    }
  


export const getConsoleDataDashboardControllerGenerateOrgReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrgReportBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrgReportBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>, {companyId: string;data: ConsoleDataDashboardControllerGenerateOrgReportBody}> = (props) => {
          const {companyId,data} = props ?? {};

          return  consoleDataDashboardControllerGenerateOrgReport(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerGenerateOrgReportMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>>
    export type ConsoleDataDashboardControllerGenerateOrgReportMutationBody = ConsoleDataDashboardControllerGenerateOrgReportBody
    export type ConsoleDataDashboardControllerGenerateOrgReportMutationError = unknown

    /**
 * @summary 조직 리포트 생성
 */
export const useConsoleDataDashboardControllerGenerateOrgReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrgReportBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrgReport>>,
        TError,
        {companyId: string;data: ConsoleDataDashboardControllerGenerateOrgReportBody},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerGenerateOrgReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 선택된 모든 사이클의 개별 데이터를 하나의 zip 파일로 묶어 다운로드합니다.
 * @summary 선택된 케이스 전체 일괄 다운로드 (zip 압축)
 */
export const consoleDataDashboardControllerDownloadAllCasesZip = (
    companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/download-all-cases-zip`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerDownloadAllCasesZipQueryKey = (companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/download-all-cases-zip`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerDownloadAllCasesZipInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']>, TError = unknown>(companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, QueryKey, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadAllCasesZipQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, QueryKey, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerDownloadAllCasesZip(companyId,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, QueryKey, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadAllCasesZipInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>>
export type ConsoleDataDashboardControllerDownloadAllCasesZipInfiniteQueryError = unknown

/**
 * @summary 선택된 케이스 전체 일괄 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadAllCasesZipInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']>, TError = unknown>(
 companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, QueryKey, ConsoleDataDashboardControllerDownloadAllCasesZipParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadAllCasesZipInfiniteQueryOptions(companyId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerDownloadAllCasesZipQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError = unknown>(companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadAllCasesZipQueryKey(companyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>> = ({ signal }) => consoleDataDashboardControllerDownloadAllCasesZip(companyId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadAllCasesZipQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>>
export type ConsoleDataDashboardControllerDownloadAllCasesZipQueryError = unknown

/**
 * @summary 선택된 케이스 전체 일괄 다운로드 (zip 압축)
 */
export const useConsoleDataDashboardControllerDownloadAllCasesZip = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError = unknown>(
 companyId: string,
    params: ConsoleDataDashboardControllerDownloadAllCasesZipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadAllCasesZip>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadAllCasesZipQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 특정 사이클의 데이터 대시보드를 조회합니다. (하위 호환성을 위해 유지)
 * @summary 대시보드 데이터 조회 (단일 사이클, 하위 호환성)
 */
export const consoleDataDashboardControllerGetDashboardLegacy = (
    companyId: string,
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ConsoleDataDashboardControllerGetDashboardLegacy200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/${cycleId}`, method: 'GET', signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerGetDashboardLegacyQueryKey = (companyId: string,
    cycleId: string,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/${cycleId}`] as const;
    }

    
export const getConsoleDataDashboardControllerGetDashboardLegacyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>>, TError = unknown>(companyId: string,
    cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetDashboardLegacyQueryKey(companyId,cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>> = ({ signal }) => consoleDataDashboardControllerGetDashboardLegacy(companyId,cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetDashboardLegacyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>>
export type ConsoleDataDashboardControllerGetDashboardLegacyInfiniteQueryError = unknown

/**
 * @summary 대시보드 데이터 조회 (단일 사이클, 하위 호환성)
 */
export const useConsoleDataDashboardControllerGetDashboardLegacyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>>, TError = unknown>(
 companyId: string,
    cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetDashboardLegacyInfiniteQueryOptions(companyId,cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerGetDashboardLegacyQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError = unknown>(companyId: string,
    cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerGetDashboardLegacyQueryKey(companyId,cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>> = ({ signal }) => consoleDataDashboardControllerGetDashboardLegacy(companyId,cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerGetDashboardLegacyQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>>
export type ConsoleDataDashboardControllerGetDashboardLegacyQueryError = unknown

/**
 * @summary 대시보드 데이터 조회 (단일 사이클, 하위 호환성)
 */
export const useConsoleDataDashboardControllerGetDashboardLegacy = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError = unknown>(
 companyId: string,
    cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGetDashboardLegacy>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerGetDashboardLegacyQueryOptions(companyId,cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 데이터 대시보드에서 개인별 데이터 파일을 다운로드합니다.
 * @summary 파일 다운로드 (개인별 데이터)
 */
export const consoleDataDashboardControllerDownloadCycleFile = (
    companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/download/${fileType}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerDownloadCycleFileQueryKey = (companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/download/${fileType}`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerDownloadCycleFileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, ConsoleDataDashboardControllerDownloadCycleFileParams['page']>, TError = unknown>(companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCycleFileParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCycleFileQueryKey(companyId,cycleId,fileType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCycleFileParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerDownloadCycleFile(companyId,cycleId,fileType,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId && fileType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCycleFileParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCycleFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>>
export type ConsoleDataDashboardControllerDownloadCycleFileInfiniteQueryError = unknown

/**
 * @summary 파일 다운로드 (개인별 데이터)
 */
export const useConsoleDataDashboardControllerDownloadCycleFileInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, ConsoleDataDashboardControllerDownloadCycleFileParams['page']>, TError = unknown>(
 companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCycleFileParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCycleFileInfiniteQueryOptions(companyId,cycleId,fileType,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerDownloadCycleFileQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError = unknown>(companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCycleFileQueryKey(companyId,cycleId,fileType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>> = ({ signal }) => consoleDataDashboardControllerDownloadCycleFile(companyId,cycleId,fileType,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && cycleId && fileType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCycleFileQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>>
export type ConsoleDataDashboardControllerDownloadCycleFileQueryError = unknown

/**
 * @summary 파일 다운로드 (개인별 데이터)
 */
export const useConsoleDataDashboardControllerDownloadCycleFile = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError = unknown>(
 companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCycleFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCycleFile>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCycleFileQueryOptions(companyId,cycleId,fileType,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 데이터 대시보드에서 회사 공통 데이터 파일을 다운로드합니다.
 * @summary 파일 다운로드 (회사 공통 데이터)
 */
export const consoleDataDashboardControllerDownloadCompanyFile = (
    companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/download/${fileType}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerDownloadCompanyFileQueryKey = (companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/download/${fileType}`, ...(params ? [params]: [])] as const;
    }

    
export const getConsoleDataDashboardControllerDownloadCompanyFileInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']>, TError = unknown>(companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCompanyFileQueryKey(companyId,fileType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']> = ({ signal, pageParam }) => consoleDataDashboardControllerDownloadCompanyFile(companyId,fileType,{...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && fileType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCompanyFileInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>>
export type ConsoleDataDashboardControllerDownloadCompanyFileInfiniteQueryError = unknown

/**
 * @summary 파일 다운로드 (회사 공통 데이터)
 */
export const useConsoleDataDashboardControllerDownloadCompanyFileInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']>, TError = unknown>(
 companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData, Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, QueryKey, ConsoleDataDashboardControllerDownloadCompanyFileParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCompanyFileInfiniteQueryOptions(companyId,fileType,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerDownloadCompanyFileQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError = unknown>(companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerDownloadCompanyFileQueryKey(companyId,fileType,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>> = ({ signal }) => consoleDataDashboardControllerDownloadCompanyFile(companyId,fileType,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && fileType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerDownloadCompanyFileQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>>
export type ConsoleDataDashboardControllerDownloadCompanyFileQueryError = unknown

/**
 * @summary 파일 다운로드 (회사 공통 데이터)
 */
export const useConsoleDataDashboardControllerDownloadCompanyFile = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError = unknown>(
 companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDownloadCompanyFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDownloadCompanyFile>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerDownloadCompanyFileQueryOptions(companyId,fileType,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 데이터 대시보드에서 개인별 데이터 파일을 삭제합니다.
 * @summary 파일 삭제 (개인별 데이터)
 */
export const consoleDataDashboardControllerDeleteCycleFile = (
    companyId: string,
    cycleId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDeleteCycleFileParams,
 ) => {
      
      
      return apiClient<ConsoleDataDashboardControllerDeleteCycleFile200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/${cycleId}/delete/${fileType}`, method: 'DELETE',
        params
    },
      );
    }
  


export const getConsoleDataDashboardControllerDeleteCycleFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>, TError,{companyId: string;cycleId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCycleFileParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>, TError,{companyId: string;cycleId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCycleFileParams}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>, {companyId: string;cycleId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCycleFileParams}> = (props) => {
          const {companyId,cycleId,fileType,params} = props ?? {};

          return  consoleDataDashboardControllerDeleteCycleFile(companyId,cycleId,fileType,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerDeleteCycleFileMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>>
    
    export type ConsoleDataDashboardControllerDeleteCycleFileMutationError = unknown

    /**
 * @summary 파일 삭제 (개인별 데이터)
 */
export const useConsoleDataDashboardControllerDeleteCycleFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>, TError,{companyId: string;cycleId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCycleFileParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCycleFile>>,
        TError,
        {companyId: string;cycleId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCycleFileParams},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerDeleteCycleFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 데이터 대시보드에서 회사 공통 데이터 파일을 삭제합니다.
 * @summary 파일 삭제 (회사 공통 데이터)
 */
export const consoleDataDashboardControllerDeleteCompanyFile = (
    companyId: string,
    fileType: string,
    params?: ConsoleDataDashboardControllerDeleteCompanyFileParams,
 ) => {
      
      
      return apiClient<ConsoleDataDashboardControllerDeleteCompanyFile200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/delete/${fileType}`, method: 'DELETE',
        params
    },
      );
    }
  


export const getConsoleDataDashboardControllerDeleteCompanyFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>, TError,{companyId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCompanyFileParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>, TError,{companyId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCompanyFileParams}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>, {companyId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCompanyFileParams}> = (props) => {
          const {companyId,fileType,params} = props ?? {};

          return  consoleDataDashboardControllerDeleteCompanyFile(companyId,fileType,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerDeleteCompanyFileMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>>
    
    export type ConsoleDataDashboardControllerDeleteCompanyFileMutationError = unknown

    /**
 * @summary 파일 삭제 (회사 공통 데이터)
 */
export const useConsoleDataDashboardControllerDeleteCompanyFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>, TError,{companyId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCompanyFileParams}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerDeleteCompanyFile>>,
        TError,
        {companyId: string;fileType: string;params?: ConsoleDataDashboardControllerDeleteCompanyFileParams},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerDeleteCompanyFileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 조직 진단 리포트를 생성합니다. (개발 예정)
 * @summary 조직 진단 리포트 생성
 */
export const consoleDataDashboardControllerGenerateOrganizationalDiagnosis = (
    companyId: string,
    consoleDataDashboardControllerGenerateOrganizationalDiagnosisBody: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody,
 ) => {
      
      
      return apiClient<ConsoleDataDashboardControllerGenerateOrganizationalDiagnosis200>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/generate-organizational-diagnosis`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: consoleDataDashboardControllerGenerateOrganizationalDiagnosisBody
    },
      );
    }
  


export const getConsoleDataDashboardControllerGenerateOrganizationalDiagnosisMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>, {companyId: string;data: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody}> = (props) => {
          const {companyId,data} = props ?? {};

          return  consoleDataDashboardControllerGenerateOrganizationalDiagnosis(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>>
    export type ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisMutationBody = ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody
    export type ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisMutationError = unknown

    /**
 * @summary 조직 진단 리포트 생성
 */
export const useConsoleDataDashboardControllerGenerateOrganizationalDiagnosis = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>, TError,{companyId: string;data: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateOrganizationalDiagnosis>>,
        TError,
        {companyId: string;data: ConsoleDataDashboardControllerGenerateOrganizationalDiagnosisBody},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerGenerateOrganizationalDiagnosisMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 선택한 사이클들의 코칭 데이터를 AI로 분석하여 캐치업 미팅용 리포트(.docx)를 생성합니다.
 * @summary 캐치업 미팅 리포트 자동 생성
 */
export const consoleDataDashboardControllerGenerateCatchUpReport = (
    companyId: string,
    generateCatchUpReportRequestDtoModel: GenerateCatchUpReportRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/catch-up-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateCatchUpReportRequestDtoModel
    },
      );
    }
  


export const getConsoleDataDashboardControllerGenerateCatchUpReportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>, TError,{companyId: string;data: GenerateCatchUpReportRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>, TError,{companyId: string;data: GenerateCatchUpReportRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>, {companyId: string;data: GenerateCatchUpReportRequestDtoModel}> = (props) => {
          const {companyId,data} = props ?? {};

          return  consoleDataDashboardControllerGenerateCatchUpReport(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConsoleDataDashboardControllerGenerateCatchUpReportMutationResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>>
    export type ConsoleDataDashboardControllerGenerateCatchUpReportMutationBody = GenerateCatchUpReportRequestDtoModel
    export type ConsoleDataDashboardControllerGenerateCatchUpReportMutationError = unknown

    /**
 * @summary 캐치업 미팅 리포트 자동 생성
 */
export const useConsoleDataDashboardControllerGenerateCatchUpReport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>, TError,{companyId: string;data: GenerateCatchUpReportRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof consoleDataDashboardControllerGenerateCatchUpReport>>,
        TError,
        {companyId: string;data: GenerateCatchUpReportRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getConsoleDataDashboardControllerGenerateCatchUpReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 조직 리포트 PPTX 내보내기
 */
export const consoleDataDashboardControllerExportOrgReport = (
    companyId: string,
    orgReportId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/v2/coaching-managers/me/console-data/${companyId}/org-reports/${orgReportId}/export`, method: 'GET', signal
    },
      );
    }
  

export const getConsoleDataDashboardControllerExportOrgReportQueryKey = (companyId: string,
    orgReportId: string,) => {
    return [`/v2/coaching-managers/me/console-data/${companyId}/org-reports/${orgReportId}/export`] as const;
    }

    
export const getConsoleDataDashboardControllerExportOrgReportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>>, TError = unknown>(companyId: string,
    orgReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerExportOrgReportQueryKey(companyId,orgReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>> = ({ signal }) => consoleDataDashboardControllerExportOrgReport(companyId,orgReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && orgReportId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerExportOrgReportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>>
export type ConsoleDataDashboardControllerExportOrgReportInfiniteQueryError = unknown

/**
 * @summary 조직 리포트 PPTX 내보내기
 */
export const useConsoleDataDashboardControllerExportOrgReportInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>>, TError = unknown>(
 companyId: string,
    orgReportId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerExportOrgReportInfiniteQueryOptions(companyId,orgReportId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConsoleDataDashboardControllerExportOrgReportQueryOptions = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError = unknown>(companyId: string,
    orgReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConsoleDataDashboardControllerExportOrgReportQueryKey(companyId,orgReportId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>> = ({ signal }) => consoleDataDashboardControllerExportOrgReport(companyId,orgReportId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId && orgReportId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData> & { queryKey: QueryKey }
}

export type ConsoleDataDashboardControllerExportOrgReportQueryResult = NonNullable<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>>
export type ConsoleDataDashboardControllerExportOrgReportQueryError = unknown

/**
 * @summary 조직 리포트 PPTX 내보내기
 */
export const useConsoleDataDashboardControllerExportOrgReport = <TData = Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError = unknown>(
 companyId: string,
    orgReportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof consoleDataDashboardControllerExportOrgReport>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConsoleDataDashboardControllerExportOrgReportQueryOptions(companyId,orgReportId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 전체 기본 템플릿 목록 조회
 */
export const notificationTemplateControllerListGlobal = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<NotificationTemplateControllerListGlobal200>(
      {url: `/v2/notification-templates`, method: 'GET', signal
    },
      );
    }
  

export const getNotificationTemplateControllerListGlobalQueryKey = () => {
    return [`/v2/notification-templates`] as const;
    }

    
export const getNotificationTemplateControllerListGlobalInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>> = ({ signal }) => notificationTemplateControllerListGlobal(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListGlobalInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>>
export type NotificationTemplateControllerListGlobalInfiniteQueryError = unknown

/**
 * @summary 전체 기본 템플릿 목록 조회
 */
export const useNotificationTemplateControllerListGlobalInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListGlobalInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationTemplateControllerListGlobalQueryOptions = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>> = ({ signal }) => notificationTemplateControllerListGlobal(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>>
export type NotificationTemplateControllerListGlobalQueryError = unknown

/**
 * @summary 전체 기본 템플릿 목록 조회
 */
export const useNotificationTemplateControllerListGlobal = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListGlobal>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListGlobalQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 전체 기본 템플릿 수정
 */
export const notificationTemplateControllerUpsertGlobal = (
    type: string,
    lang: string,
    recipient: string,
    upsertNotificationTemplateDtoModel: UpsertNotificationTemplateDtoModel,
 ) => {
      
      
      return apiClient<NotificationTemplateControllerUpsertGlobal200>(
      {url: `/v2/notification-templates/${type}/${lang}/${recipient}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertNotificationTemplateDtoModel
    },
      );
    }
  


export const getNotificationTemplateControllerUpsertGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>, TError,{type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>, TError,{type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>, {type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}> = (props) => {
          const {type,lang,recipient,data} = props ?? {};

          return  notificationTemplateControllerUpsertGlobal(type,lang,recipient,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationTemplateControllerUpsertGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>>
    export type NotificationTemplateControllerUpsertGlobalMutationBody = UpsertNotificationTemplateDtoModel
    export type NotificationTemplateControllerUpsertGlobalMutationError = unknown

    /**
 * @summary 전체 기본 템플릿 수정
 */
export const useNotificationTemplateControllerUpsertGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>, TError,{type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationTemplateControllerUpsertGlobal>>,
        TError,
        {type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationTemplateControllerUpsertGlobalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 기업별 템플릿 오버라이드 목록 조회
 */
export const notificationTemplateControllerListByCompany = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<NotificationTemplateControllerListByCompany200>(
      {url: `/v2/notification-templates/companies/${companyId}`, method: 'GET', signal
    },
      );
    }
  

export const getNotificationTemplateControllerListByCompanyQueryKey = (companyId: string,) => {
    return [`/v2/notification-templates/companies/${companyId}`] as const;
    }

    
export const getNotificationTemplateControllerListByCompanyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListByCompanyQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>> = ({ signal }) => notificationTemplateControllerListByCompany(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListByCompanyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>>
export type NotificationTemplateControllerListByCompanyInfiniteQueryError = unknown

/**
 * @summary 기업별 템플릿 오버라이드 목록 조회
 */
export const useNotificationTemplateControllerListByCompanyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListByCompanyInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationTemplateControllerListByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListByCompanyQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>> = ({ signal }) => notificationTemplateControllerListByCompany(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>>
export type NotificationTemplateControllerListByCompanyQueryError = unknown

/**
 * @summary 기업별 템플릿 오버라이드 목록 조회
 */
export const useNotificationTemplateControllerListByCompany = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListByCompany>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListByCompanyQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 기업별 템플릿 오버라이드 저장
 */
export const notificationTemplateControllerUpsertCompanyOverride = (
    companyId: string,
    type: string,
    lang: string,
    recipient: string,
    upsertNotificationTemplateDtoModel: UpsertNotificationTemplateDtoModel,
 ) => {
      
      
      return apiClient<NotificationTemplateControllerUpsertCompanyOverride200>(
      {url: `/v2/notification-templates/companies/${companyId}/${type}/${lang}/${recipient}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertNotificationTemplateDtoModel
    },
      );
    }
  


export const getNotificationTemplateControllerUpsertCompanyOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>, {companyId: string;type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}> = (props) => {
          const {companyId,type,lang,recipient,data} = props ?? {};

          return  notificationTemplateControllerUpsertCompanyOverride(companyId,type,lang,recipient,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationTemplateControllerUpsertCompanyOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>>
    export type NotificationTemplateControllerUpsertCompanyOverrideMutationBody = UpsertNotificationTemplateDtoModel
    export type NotificationTemplateControllerUpsertCompanyOverrideMutationError = unknown

    /**
 * @summary 기업별 템플릿 오버라이드 저장
 */
export const useNotificationTemplateControllerUpsertCompanyOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationTemplateControllerUpsertCompanyOverride>>,
        TError,
        {companyId: string;type: string;lang: string;recipient: string;data: UpsertNotificationTemplateDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationTemplateControllerUpsertCompanyOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 기업별 템플릿 오버라이드 삭제 (기본값으로 복원)
 */
export const notificationTemplateControllerDeleteCompanyOverride = (
    companyId: string,
    type: string,
    lang: string,
    recipient: string,
 ) => {
      
      
      return apiClient<NotificationTemplateControllerDeleteCompanyOverride200>(
      {url: `/v2/notification-templates/companies/${companyId}/${type}/${lang}/${recipient}`, method: 'DELETE'
    },
      );
    }
  


export const getNotificationTemplateControllerDeleteCompanyOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>, {companyId: string;type: string;lang: string;recipient: string}> = (props) => {
          const {companyId,type,lang,recipient} = props ?? {};

          return  notificationTemplateControllerDeleteCompanyOverride(companyId,type,lang,recipient,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationTemplateControllerDeleteCompanyOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>>
    
    export type NotificationTemplateControllerDeleteCompanyOverrideMutationError = unknown

    /**
 * @summary 기업별 템플릿 오버라이드 삭제 (기본값으로 복원)
 */
export const useNotificationTemplateControllerDeleteCompanyOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string;lang: string;recipient: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationTemplateControllerDeleteCompanyOverride>>,
        TError,
        {companyId: string;type: string;lang: string;recipient: string},
        TContext
      > => {

      const mutationOptions = getNotificationTemplateControllerDeleteCompanyOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 템플릿 Handlebars 렌더링 미리보기
 */
export const notificationTemplateControllerPreview = (
    notificationTemplatePreviewDtoModel: NotificationTemplatePreviewDtoModel,
 ) => {
      
      
      return apiClient<NotificationTemplateControllerPreview200>(
      {url: `/v2/notification-templates/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationTemplatePreviewDtoModel
    },
      );
    }
  


export const getNotificationTemplateControllerPreviewMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerPreview>>, TError,{data: NotificationTemplatePreviewDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerPreview>>, TError,{data: NotificationTemplatePreviewDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationTemplateControllerPreview>>, {data: NotificationTemplatePreviewDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  notificationTemplateControllerPreview(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationTemplateControllerPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerPreview>>>
    export type NotificationTemplateControllerPreviewMutationBody = NotificationTemplatePreviewDtoModel
    export type NotificationTemplateControllerPreviewMutationError = unknown

    /**
 * @summary 템플릿 Handlebars 렌더링 미리보기
 */
export const useNotificationTemplateControllerPreview = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerPreview>>, TError,{data: NotificationTemplatePreviewDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationTemplateControllerPreview>>,
        TError,
        {data: NotificationTemplatePreviewDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationTemplateControllerPreviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 테스트 이메일 발송
 */
export const notificationTemplateControllerSendTestEmail = (
    sendTestEmailDtoModel: SendTestEmailDtoModel,
 ) => {
      
      
      return apiClient<NotificationTemplateControllerSendTestEmail200>(
      {url: `/v2/notification-templates/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendTestEmailDtoModel
    },
      );
    }
  


export const getNotificationTemplateControllerSendTestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>, TError,{data: SendTestEmailDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>, TError,{data: SendTestEmailDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>, {data: SendTestEmailDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  notificationTemplateControllerSendTestEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationTemplateControllerSendTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>>
    export type NotificationTemplateControllerSendTestEmailMutationBody = SendTestEmailDtoModel
    export type NotificationTemplateControllerSendTestEmailMutationError = unknown

    /**
 * @summary 테스트 이메일 발송
 */
export const useNotificationTemplateControllerSendTestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>, TError,{data: SendTestEmailDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationTemplateControllerSendTestEmail>>,
        TError,
        {data: SendTestEmailDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationTemplateControllerSendTestEmailMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 콘솔이 타입 원문 대신 한글 이름을 쓰도록 백엔드가 내려준다. 라벨을 화면마다 따로 들고 있으면 알림을 추가할 때 빠진다.
 * @summary 알림 타입 목록 + 한글 이름
 */
export const notificationTemplateControllerListTypes = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<NotificationTemplateControllerListTypes200>(
      {url: `/v2/notification-templates/types`, method: 'GET', signal
    },
      );
    }
  

export const getNotificationTemplateControllerListTypesQueryKey = () => {
    return [`/v2/notification-templates/types`] as const;
    }

    
export const getNotificationTemplateControllerListTypesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>> = ({ signal }) => notificationTemplateControllerListTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListTypesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>>
export type NotificationTemplateControllerListTypesInfiniteQueryError = unknown

/**
 * @summary 알림 타입 목록 + 한글 이름
 */
export const useNotificationTemplateControllerListTypesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListTypesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationTemplateControllerListTypesQueryOptions = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTemplateControllerListTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>> = ({ signal }) => notificationTemplateControllerListTypes(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationTemplateControllerListTypesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>>
export type NotificationTemplateControllerListTypesQueryError = unknown

/**
 * @summary 알림 타입 목록 + 한글 이름
 */
export const useNotificationTemplateControllerListTypes = <TData = Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTemplateControllerListTypes>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationTemplateControllerListTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 전체 기본 발송 일정 목록 조회
 */
export const notificationScheduleControllerListGlobal = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<NotificationScheduleControllerListGlobal200>(
      {url: `/v2/notification-schedules`, method: 'GET', signal
    },
      );
    }
  

export const getNotificationScheduleControllerListGlobalQueryKey = () => {
    return [`/v2/notification-schedules`] as const;
    }

    
export const getNotificationScheduleControllerListGlobalInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationScheduleControllerListGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>> = ({ signal }) => notificationScheduleControllerListGlobal(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationScheduleControllerListGlobalInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>>
export type NotificationScheduleControllerListGlobalInfiniteQueryError = unknown

/**
 * @summary 전체 기본 발송 일정 목록 조회
 */
export const useNotificationScheduleControllerListGlobalInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationScheduleControllerListGlobalInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationScheduleControllerListGlobalQueryOptions = <TData = Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationScheduleControllerListGlobalQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>> = ({ signal }) => notificationScheduleControllerListGlobal(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationScheduleControllerListGlobalQueryResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>>
export type NotificationScheduleControllerListGlobalQueryError = unknown

/**
 * @summary 전체 기본 발송 일정 목록 조회
 */
export const useNotificationScheduleControllerListGlobal = <TData = Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListGlobal>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationScheduleControllerListGlobalQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 전체 기본 발송 일정 변경
 */
export const notificationScheduleControllerUpsertGlobal = (
    type: string,
    upsertNotificationScheduleDtoModel: UpsertNotificationScheduleDtoModel,
 ) => {
      
      
      return apiClient<NotificationScheduleControllerUpsertGlobal200>(
      {url: `/v2/notification-schedules/${type}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertNotificationScheduleDtoModel
    },
      );
    }
  


export const getNotificationScheduleControllerUpsertGlobalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>, TError,{type: string;data: UpsertNotificationScheduleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>, TError,{type: string;data: UpsertNotificationScheduleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>, {type: string;data: UpsertNotificationScheduleDtoModel}> = (props) => {
          const {type,data} = props ?? {};

          return  notificationScheduleControllerUpsertGlobal(type,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationScheduleControllerUpsertGlobalMutationResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>>
    export type NotificationScheduleControllerUpsertGlobalMutationBody = UpsertNotificationScheduleDtoModel
    export type NotificationScheduleControllerUpsertGlobalMutationError = unknown

    /**
 * @summary 전체 기본 발송 일정 변경
 */
export const useNotificationScheduleControllerUpsertGlobal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>, TError,{type: string;data: UpsertNotificationScheduleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationScheduleControllerUpsertGlobal>>,
        TError,
        {type: string;data: UpsertNotificationScheduleDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationScheduleControllerUpsertGlobalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 기업별 발송 일정 목록 조회
 */
export const notificationScheduleControllerListByCompany = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<NotificationScheduleControllerListByCompany200>(
      {url: `/v2/notification-schedules/companies/${companyId}`, method: 'GET', signal
    },
      );
    }
  

export const getNotificationScheduleControllerListByCompanyQueryKey = (companyId: string,) => {
    return [`/v2/notification-schedules/companies/${companyId}`] as const;
    }

    
export const getNotificationScheduleControllerListByCompanyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationScheduleControllerListByCompanyQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>> = ({ signal }) => notificationScheduleControllerListByCompany(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationScheduleControllerListByCompanyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>>
export type NotificationScheduleControllerListByCompanyInfiniteQueryError = unknown

/**
 * @summary 기업별 발송 일정 목록 조회
 */
export const useNotificationScheduleControllerListByCompanyInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationScheduleControllerListByCompanyInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationScheduleControllerListByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationScheduleControllerListByCompanyQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>> = ({ signal }) => notificationScheduleControllerListByCompany(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationScheduleControllerListByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>>
export type NotificationScheduleControllerListByCompanyQueryError = unknown

/**
 * @summary 기업별 발송 일정 목록 조회
 */
export const useNotificationScheduleControllerListByCompany = <TData = Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationScheduleControllerListByCompany>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationScheduleControllerListByCompanyQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 기업별 발송 일정 설정
 */
export const notificationScheduleControllerUpsertCompanyOverride = (
    companyId: string,
    type: string,
    upsertNotificationScheduleDtoModel: UpsertNotificationScheduleDtoModel,
 ) => {
      
      
      return apiClient<NotificationScheduleControllerUpsertCompanyOverride200>(
      {url: `/v2/notification-schedules/companies/${companyId}/${type}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertNotificationScheduleDtoModel
    },
      );
    }
  


export const getNotificationScheduleControllerUpsertCompanyOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;data: UpsertNotificationScheduleDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;data: UpsertNotificationScheduleDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>, {companyId: string;type: string;data: UpsertNotificationScheduleDtoModel}> = (props) => {
          const {companyId,type,data} = props ?? {};

          return  notificationScheduleControllerUpsertCompanyOverride(companyId,type,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationScheduleControllerUpsertCompanyOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>>
    export type NotificationScheduleControllerUpsertCompanyOverrideMutationBody = UpsertNotificationScheduleDtoModel
    export type NotificationScheduleControllerUpsertCompanyOverrideMutationError = unknown

    /**
 * @summary 기업별 발송 일정 설정
 */
export const useNotificationScheduleControllerUpsertCompanyOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>, TError,{companyId: string;type: string;data: UpsertNotificationScheduleDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationScheduleControllerUpsertCompanyOverride>>,
        TError,
        {companyId: string;type: string;data: UpsertNotificationScheduleDtoModel},
        TContext
      > => {

      const mutationOptions = getNotificationScheduleControllerUpsertCompanyOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 기업별 발송 일정 삭제 (기본값으로 복원)
 */
export const notificationScheduleControllerDeleteCompanyOverride = (
    companyId: string,
    type: string,
 ) => {
      
      
      return apiClient<NotificationScheduleControllerDeleteCompanyOverride200>(
      {url: `/v2/notification-schedules/companies/${companyId}/${type}`, method: 'DELETE'
    },
      );
    }
  


export const getNotificationScheduleControllerDeleteCompanyOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>, {companyId: string;type: string}> = (props) => {
          const {companyId,type} = props ?? {};

          return  notificationScheduleControllerDeleteCompanyOverride(companyId,type,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationScheduleControllerDeleteCompanyOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>>
    
    export type NotificationScheduleControllerDeleteCompanyOverrideMutationError = unknown

    /**
 * @summary 기업별 발송 일정 삭제 (기본값으로 복원)
 */
export const useNotificationScheduleControllerDeleteCompanyOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>, TError,{companyId: string;type: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof notificationScheduleControllerDeleteCompanyOverride>>,
        TError,
        {companyId: string;type: string},
        TContext
      > => {

      const mutationOptions = getNotificationScheduleControllerDeleteCompanyOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 사이클의 Alignment Call 기록을 조회합니다. 없으면 빈 기본값을 반환합니다.
 * @summary Alignment Call 기록 조회
 */
export const cmAlignmentCallControllerGetAlignmentCall = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmAlignmentCallControllerGetAlignmentCall200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/alignment-call`, method: 'GET', signal
    },
      );
    }
  

export const getCmAlignmentCallControllerGetAlignmentCallQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/alignment-call`] as const;
    }

    
export const getCmAlignmentCallControllerGetAlignmentCallInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmAlignmentCallControllerGetAlignmentCallQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>> = ({ signal }) => cmAlignmentCallControllerGetAlignmentCall(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData> & { queryKey: QueryKey }
}

export type CmAlignmentCallControllerGetAlignmentCallInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>>
export type CmAlignmentCallControllerGetAlignmentCallInfiniteQueryError = unknown

/**
 * @summary Alignment Call 기록 조회
 */
export const useCmAlignmentCallControllerGetAlignmentCallInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmAlignmentCallControllerGetAlignmentCallInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmAlignmentCallControllerGetAlignmentCallQueryOptions = <TData = Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmAlignmentCallControllerGetAlignmentCallQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>> = ({ signal }) => cmAlignmentCallControllerGetAlignmentCall(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData> & { queryKey: QueryKey }
}

export type CmAlignmentCallControllerGetAlignmentCallQueryResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>>
export type CmAlignmentCallControllerGetAlignmentCallQueryError = unknown

/**
 * @summary Alignment Call 기록 조회
 */
export const useCmAlignmentCallControllerGetAlignmentCall = <TData = Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerGetAlignmentCall>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmAlignmentCallControllerGetAlignmentCallQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Alignment Call 기록을 덮어쓰기 저장합니다. 필수 문항 미입력이어도 저장됩니다.
 * @summary Alignment Call 기록 저장
 */
export const cmAlignmentCallControllerSaveAlignmentCall = (
    cycleId: string,
    saveAlignmentCallDtoModel: SaveAlignmentCallDtoModel,
 ) => {
      
      
      return apiClient<CmAlignmentCallControllerSaveAlignmentCall200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/alignment-call`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveAlignmentCallDtoModel
    },
      );
    }
  


export const getCmAlignmentCallControllerSaveAlignmentCallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>, TError,{cycleId: string;data: SaveAlignmentCallDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>, TError,{cycleId: string;data: SaveAlignmentCallDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>, {cycleId: string;data: SaveAlignmentCallDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmAlignmentCallControllerSaveAlignmentCall(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmAlignmentCallControllerSaveAlignmentCallMutationResult = NonNullable<Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>>
    export type CmAlignmentCallControllerSaveAlignmentCallMutationBody = SaveAlignmentCallDtoModel
    export type CmAlignmentCallControllerSaveAlignmentCallMutationError = unknown

    /**
 * @summary Alignment Call 기록 저장
 */
export const useCmAlignmentCallControllerSaveAlignmentCall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>, TError,{cycleId: string;data: SaveAlignmentCallDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmAlignmentCallControllerSaveAlignmentCall>>,
        TError,
        {cycleId: string;data: SaveAlignmentCallDtoModel},
        TContext
      > => {

      const mutationOptions = getCmAlignmentCallControllerSaveAlignmentCallMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 상위리더에게 발급한 매직링크로만 접근할 수 있습니다.
 * @summary Leader Context Document 작성 폼 정보 조회
 */
export const leaderContextDocumentControllerGetForm = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<LeaderContextDocumentControllerGetForm200>(
      {url: `/v2/leader-context-documents/${cycleId}`, method: 'GET', signal
    },
      );
    }
  

export const getLeaderContextDocumentControllerGetFormQueryKey = (cycleId: string,) => {
    return [`/v2/leader-context-documents/${cycleId}`] as const;
    }

    
export const getLeaderContextDocumentControllerGetFormInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLeaderContextDocumentControllerGetFormQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>> = ({ signal }) => leaderContextDocumentControllerGetForm(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData> & { queryKey: QueryKey }
}

export type LeaderContextDocumentControllerGetFormInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>>
export type LeaderContextDocumentControllerGetFormInfiniteQueryError = unknown

/**
 * @summary Leader Context Document 작성 폼 정보 조회
 */
export const useLeaderContextDocumentControllerGetFormInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLeaderContextDocumentControllerGetFormInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLeaderContextDocumentControllerGetFormQueryOptions = <TData = Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLeaderContextDocumentControllerGetFormQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>> = ({ signal }) => leaderContextDocumentControllerGetForm(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData> & { queryKey: QueryKey }
}

export type LeaderContextDocumentControllerGetFormQueryResult = NonNullable<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>>
export type LeaderContextDocumentControllerGetFormQueryError = unknown

/**
 * @summary Leader Context Document 작성 폼 정보 조회
 */
export const useLeaderContextDocumentControllerGetForm = <TData = Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerGetForm>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLeaderContextDocumentControllerGetFormQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 상위리더에게 발급한 매직링크로만 접근할 수 있습니다.
 * @summary Leader Context Document 제출
 */
export const leaderContextDocumentControllerSubmit = (
    cycleId: string,
    submitLeaderContextDocumentDtoModel: SubmitLeaderContextDocumentDtoModel,
 ) => {
      
      
      return apiClient<LeaderContextDocumentControllerSubmit201>(
      {url: `/v2/leader-context-documents/${cycleId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitLeaderContextDocumentDtoModel
    },
      );
    }
  


export const getLeaderContextDocumentControllerSubmitMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>, TError,{cycleId: string;data: SubmitLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>, TError,{cycleId: string;data: SubmitLeaderContextDocumentDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>, {cycleId: string;data: SubmitLeaderContextDocumentDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  leaderContextDocumentControllerSubmit(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LeaderContextDocumentControllerSubmitMutationResult = NonNullable<Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>>
    export type LeaderContextDocumentControllerSubmitMutationBody = SubmitLeaderContextDocumentDtoModel
    export type LeaderContextDocumentControllerSubmitMutationError = unknown

    /**
 * @summary Leader Context Document 제출
 */
export const useLeaderContextDocumentControllerSubmit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>, TError,{cycleId: string;data: SubmitLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof leaderContextDocumentControllerSubmit>>,
        TError,
        {cycleId: string;data: SubmitLeaderContextDocumentDtoModel},
        TContext
      > => {

      const mutationOptions = getLeaderContextDocumentControllerSubmitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 상위리더에게 Leader Context Document 작성 매직링크를 이메일로 발송합니다.
 * @summary LCD 작성 요청 발송
 */
export const cmLeaderContextDocumentControllerRequestDocument = (
    cycleId: string,
    requestLeaderContextDocumentDtoModel: RequestLeaderContextDocumentDtoModel,
 ) => {
      
      
      return apiClient<CmLeaderContextDocumentControllerRequestDocument201>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/leader-context-document`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestLeaderContextDocumentDtoModel
    },
      );
    }
  


export const getCmLeaderContextDocumentControllerRequestDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>, TError,{cycleId: string;data: RequestLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>, TError,{cycleId: string;data: RequestLeaderContextDocumentDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>, {cycleId: string;data: RequestLeaderContextDocumentDtoModel}> = (props) => {
          const {cycleId,data} = props ?? {};

          return  cmLeaderContextDocumentControllerRequestDocument(cycleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmLeaderContextDocumentControllerRequestDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>>
    export type CmLeaderContextDocumentControllerRequestDocumentMutationBody = RequestLeaderContextDocumentDtoModel
    export type CmLeaderContextDocumentControllerRequestDocumentMutationError = unknown

    /**
 * @summary LCD 작성 요청 발송
 */
export const useCmLeaderContextDocumentControllerRequestDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>, TError,{cycleId: string;data: RequestLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmLeaderContextDocumentControllerRequestDocument>>,
        TError,
        {cycleId: string;data: RequestLeaderContextDocumentDtoModel},
        TContext
      > => {

      const mutationOptions = getCmLeaderContextDocumentControllerRequestDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 해당 사이클의 Leader Context Document 상태·제출본을 조회합니다.
 * @summary LCD 조회
 */
export const cmLeaderContextDocumentControllerGetDocument = (
    cycleId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmLeaderContextDocumentControllerGetDocument200>(
      {url: `/v2/coaching-managers/me/cycles/${cycleId}/leader-context-document`, method: 'GET', signal
    },
      );
    }
  

export const getCmLeaderContextDocumentControllerGetDocumentQueryKey = (cycleId: string,) => {
    return [`/v2/coaching-managers/me/cycles/${cycleId}/leader-context-document`] as const;
    }

    
export const getCmLeaderContextDocumentControllerGetDocumentInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmLeaderContextDocumentControllerGetDocumentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>> = ({ signal }) => cmLeaderContextDocumentControllerGetDocument(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type CmLeaderContextDocumentControllerGetDocumentInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>>
export type CmLeaderContextDocumentControllerGetDocumentInfiniteQueryError = unknown

/**
 * @summary LCD 조회
 */
export const useCmLeaderContextDocumentControllerGetDocumentInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmLeaderContextDocumentControllerGetDocumentInfiniteQueryOptions(cycleId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmLeaderContextDocumentControllerGetDocumentQueryOptions = <TData = Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError = unknown>(cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmLeaderContextDocumentControllerGetDocumentQueryKey(cycleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>> = ({ signal }) => cmLeaderContextDocumentControllerGetDocument(cycleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(cycleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type CmLeaderContextDocumentControllerGetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>>
export type CmLeaderContextDocumentControllerGetDocumentQueryError = unknown

/**
 * @summary LCD 조회
 */
export const useCmLeaderContextDocumentControllerGetDocument = <TData = Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError = unknown>(
 cycleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentControllerGetDocument>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmLeaderContextDocumentControllerGetDocumentQueryOptions(cycleId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 대시보드에서 선택한 여러 사이클에 LCD 작성 매직링크를 한 번에 발송합니다. 이메일은 요청 값 → 없으면 케이스 등록 저장값을 사용하며, 둘 다 없으면 skipped_no_email로 반환합니다.
 * @summary LCD 작성 요청 일괄 발송
 */
export const cmLeaderContextDocumentBulkControllerBulkRequest = (
    bulkRequestLeaderContextDocumentDtoModel: BulkRequestLeaderContextDocumentDtoModel,
 ) => {
      
      
      return apiClient<CmLeaderContextDocumentBulkControllerBulkRequest200>(
      {url: `/v2/coaching-managers/me/leader-context-document/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkRequestLeaderContextDocumentDtoModel
    },
      );
    }
  


export const getCmLeaderContextDocumentBulkControllerBulkRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>, TError,{data: BulkRequestLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>, TError,{data: BulkRequestLeaderContextDocumentDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>, {data: BulkRequestLeaderContextDocumentDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  cmLeaderContextDocumentBulkControllerBulkRequest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmLeaderContextDocumentBulkControllerBulkRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>>
    export type CmLeaderContextDocumentBulkControllerBulkRequestMutationBody = BulkRequestLeaderContextDocumentDtoModel
    export type CmLeaderContextDocumentBulkControllerBulkRequestMutationError = unknown

    /**
 * @summary LCD 작성 요청 일괄 발송
 */
export const useCmLeaderContextDocumentBulkControllerBulkRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>, TError,{data: BulkRequestLeaderContextDocumentDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmLeaderContextDocumentBulkControllerBulkRequest>>,
        TError,
        {data: BulkRequestLeaderContextDocumentDtoModel},
        TContext
      > => {

      const mutationOptions = getCmLeaderContextDocumentBulkControllerBulkRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 역할: COACHING_MANAGER
 * @summary 워크샵 등록
 */
export const workshopControllerCreateWorkshop = (
    companyId: string,
    createWorkshopDtoModel: CreateWorkshopDtoModel,
 ) => {
      
      
      return apiClient<WorkshopControllerCreateWorkshop201>(
      {url: `/v2/companies/${companyId}/workshops`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWorkshopDtoModel
    },
      );
    }
  


export const getWorkshopControllerCreateWorkshopMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>, TError,{companyId: string;data: CreateWorkshopDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>, TError,{companyId: string;data: CreateWorkshopDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>, {companyId: string;data: CreateWorkshopDtoModel}> = (props) => {
          const {companyId,data} = props ?? {};

          return  workshopControllerCreateWorkshop(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkshopControllerCreateWorkshopMutationResult = NonNullable<Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>>
    export type WorkshopControllerCreateWorkshopMutationBody = CreateWorkshopDtoModel
    export type WorkshopControllerCreateWorkshopMutationError = unknown

    /**
 * @summary 워크샵 등록
 */
export const useWorkshopControllerCreateWorkshop = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>, TError,{companyId: string;data: CreateWorkshopDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof workshopControllerCreateWorkshop>>,
        TError,
        {companyId: string;data: CreateWorkshopDtoModel},
        TContext
      > => {

      const mutationOptions = getWorkshopControllerCreateWorkshopMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 역할: COACHING_MANAGER
 * @summary 워크샵 목록 조회
 */
export const workshopControllerGetWorkshopsByCompanyId = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<WorkshopControllerGetWorkshopsByCompanyId200>(
      {url: `/v2/companies/${companyId}/workshops`, method: 'GET', signal
    },
      );
    }
  

export const getWorkshopControllerGetWorkshopsByCompanyIdQueryKey = (companyId: string,) => {
    return [`/v2/companies/${companyId}/workshops`] as const;
    }

    
export const getWorkshopControllerGetWorkshopsByCompanyIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkshopControllerGetWorkshopsByCompanyIdQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>> = ({ signal }) => workshopControllerGetWorkshopsByCompanyId(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type WorkshopControllerGetWorkshopsByCompanyIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>>
export type WorkshopControllerGetWorkshopsByCompanyIdInfiniteQueryError = unknown

/**
 * @summary 워크샵 목록 조회
 */
export const useWorkshopControllerGetWorkshopsByCompanyIdInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWorkshopControllerGetWorkshopsByCompanyIdInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getWorkshopControllerGetWorkshopsByCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWorkshopControllerGetWorkshopsByCompanyIdQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>> = ({ signal }) => workshopControllerGetWorkshopsByCompanyId(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type WorkshopControllerGetWorkshopsByCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>>
export type WorkshopControllerGetWorkshopsByCompanyIdQueryError = unknown

/**
 * @summary 워크샵 목록 조회
 */
export const useWorkshopControllerGetWorkshopsByCompanyId = <TData = Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetWorkshopsByCompanyId>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getWorkshopControllerGetWorkshopsByCompanyIdQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 역할: COACHING_MANAGER
 * @summary 워크샵 수정
 */
export const workshopControllerUpdateWorkshop = (
    workshopId: string,
    updateWorkshopDtoModel: UpdateWorkshopDtoModel,
 ) => {
      
      
      return apiClient<WorkshopControllerUpdateWorkshop200>(
      {url: `/v2/workshops/${workshopId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWorkshopDtoModel
    },
      );
    }
  


export const getWorkshopControllerUpdateWorkshopMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>, TError,{workshopId: string;data: UpdateWorkshopDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>, TError,{workshopId: string;data: UpdateWorkshopDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>, {workshopId: string;data: UpdateWorkshopDtoModel}> = (props) => {
          const {workshopId,data} = props ?? {};

          return  workshopControllerUpdateWorkshop(workshopId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkshopControllerUpdateWorkshopMutationResult = NonNullable<Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>>
    export type WorkshopControllerUpdateWorkshopMutationBody = UpdateWorkshopDtoModel
    export type WorkshopControllerUpdateWorkshopMutationError = unknown

    /**
 * @summary 워크샵 수정
 */
export const useWorkshopControllerUpdateWorkshop = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>, TError,{workshopId: string;data: UpdateWorkshopDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof workshopControllerUpdateWorkshop>>,
        TError,
        {workshopId: string;data: UpdateWorkshopDtoModel},
        TContext
      > => {

      const mutationOptions = getWorkshopControllerUpdateWorkshopMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 역할: COACHING_MANAGER
 * @summary 워크샵 삭제
 */
export const workshopControllerDeleteWorkshop = (
    workshopId: string,
 ) => {
      
      
      return apiClient<WorkshopControllerDeleteWorkshop200>(
      {url: `/v2/workshops/${workshopId}`, method: 'DELETE'
    },
      );
    }
  


export const getWorkshopControllerDeleteWorkshopMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>, TError,{workshopId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>, TError,{workshopId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>, {workshopId: string}> = (props) => {
          const {workshopId} = props ?? {};

          return  workshopControllerDeleteWorkshop(workshopId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WorkshopControllerDeleteWorkshopMutationResult = NonNullable<Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>>
    
    export type WorkshopControllerDeleteWorkshopMutationError = unknown

    /**
 * @summary 워크샵 삭제
 */
export const useWorkshopControllerDeleteWorkshop = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>, TError,{workshopId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof workshopControllerDeleteWorkshop>>,
        TError,
        {workshopId: string},
        TContext
      > => {

      const mutationOptions = getWorkshopControllerDeleteWorkshopMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * 프론트가 0/1/N에 따라 등록·바로발송·선택 UI를 고른다.
 * @summary 고객사 HR 계정 목록
 */
export const cmCaseInfoRequestControllerGetHrAccounts = (
    companyId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CmCaseInfoRequestControllerGetHrAccounts200>(
      {url: `/v2/coaching-managers/me/companies/${companyId}/hr-accounts`, method: 'GET', signal
    },
      );
    }
  

export const getCmCaseInfoRequestControllerGetHrAccountsQueryKey = (companyId: string,) => {
    return [`/v2/coaching-managers/me/companies/${companyId}/hr-accounts`] as const;
    }

    
export const getCmCaseInfoRequestControllerGetHrAccountsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCaseInfoRequestControllerGetHrAccountsQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>> = ({ signal }) => cmCaseInfoRequestControllerGetHrAccounts(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCaseInfoRequestControllerGetHrAccountsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>>
export type CmCaseInfoRequestControllerGetHrAccountsInfiniteQueryError = unknown

/**
 * @summary 고객사 HR 계정 목록
 */
export const useCmCaseInfoRequestControllerGetHrAccountsInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCaseInfoRequestControllerGetHrAccountsInfiniteQueryOptions(companyId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCmCaseInfoRequestControllerGetHrAccountsQueryOptions = <TData = Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError = unknown>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCmCaseInfoRequestControllerGetHrAccountsQueryKey(companyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>> = ({ signal }) => cmCaseInfoRequestControllerGetHrAccounts(companyId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type CmCaseInfoRequestControllerGetHrAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>>
export type CmCaseInfoRequestControllerGetHrAccountsQueryError = unknown

/**
 * @summary 고객사 HR 계정 목록
 */
export const useCmCaseInfoRequestControllerGetHrAccounts = <TData = Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError = unknown>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerGetHrAccounts>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCmCaseInfoRequestControllerGetHrAccountsQueryOptions(companyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * 대상자 정보 요청을 보낼 고객사 HR 로그인 계정을 만든다.
 * @summary 고객사 HR 계정 등록
 */
export const cmCaseInfoRequestControllerCreateHrAccount = (
    companyId: string,
    createHrAccountRequestDtoModel: CreateHrAccountRequestDtoModel,
 ) => {
      
      
      return apiClient<CmCaseInfoRequestControllerCreateHrAccount201>(
      {url: `/v2/coaching-managers/me/companies/${companyId}/hr-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHrAccountRequestDtoModel
    },
      );
    }
  


export const getCmCaseInfoRequestControllerCreateHrAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>, TError,{companyId: string;data: CreateHrAccountRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>, TError,{companyId: string;data: CreateHrAccountRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>, {companyId: string;data: CreateHrAccountRequestDtoModel}> = (props) => {
          const {companyId,data} = props ?? {};

          return  cmCaseInfoRequestControllerCreateHrAccount(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCaseInfoRequestControllerCreateHrAccountMutationResult = NonNullable<Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>>
    export type CmCaseInfoRequestControllerCreateHrAccountMutationBody = CreateHrAccountRequestDtoModel
    export type CmCaseInfoRequestControllerCreateHrAccountMutationError = unknown

    /**
 * @summary 고객사 HR 계정 등록
 */
export const useCmCaseInfoRequestControllerCreateHrAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>, TError,{companyId: string;data: CreateHrAccountRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCaseInfoRequestControllerCreateHrAccount>>,
        TError,
        {companyId: string;data: CreateHrAccountRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCaseInfoRequestControllerCreateHrAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * HR에게 대상자·리뷰어 등록을 요청하는 메일을 보낸다. 만료된 요청이면 재오픈한다. hrUserId로 대상 HR을 지정한다(HR이 1명이면 프론트가 그 값을 자동으로 넣는다).
 * @summary 대상자 정보 요청 발송
 */
export const cmCaseInfoRequestControllerSendCaseInfoRequest = (
    companyId: string,
    sendCaseInfoRequestRequestDtoModel: SendCaseInfoRequestRequestDtoModel,
 ) => {
      
      
      return apiClient<CmCaseInfoRequestControllerSendCaseInfoRequest201>(
      {url: `/v2/coaching-managers/me/companies/${companyId}/case-info-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCaseInfoRequestRequestDtoModel
    },
      );
    }
  


export const getCmCaseInfoRequestControllerSendCaseInfoRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>, TError,{companyId: string;data: SendCaseInfoRequestRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>, TError,{companyId: string;data: SendCaseInfoRequestRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>, {companyId: string;data: SendCaseInfoRequestRequestDtoModel}> = (props) => {
          const {companyId,data} = props ?? {};

          return  cmCaseInfoRequestControllerSendCaseInfoRequest(companyId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CmCaseInfoRequestControllerSendCaseInfoRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>>
    export type CmCaseInfoRequestControllerSendCaseInfoRequestMutationBody = SendCaseInfoRequestRequestDtoModel
    export type CmCaseInfoRequestControllerSendCaseInfoRequestMutationError = unknown

    /**
 * @summary 대상자 정보 요청 발송
 */
export const useCmCaseInfoRequestControllerSendCaseInfoRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>, TError,{companyId: string;data: SendCaseInfoRequestRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof cmCaseInfoRequestControllerSendCaseInfoRequest>>,
        TError,
        {companyId: string;data: SendCaseInfoRequestRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getCmCaseInfoRequestControllerSendCaseInfoRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 내 대상자 등록 요청 상태 + 임시저장 목록
 */
export const hrCaseRegistrationControllerGetMyRequest = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrCaseRegistrationControllerGetMyRequest200>(
      {url: `/v2/hr/me/case-info-requests`, method: 'GET', signal
    },
      );
    }
  

export const getHrCaseRegistrationControllerGetMyRequestQueryKey = () => {
    return [`/v2/hr/me/case-info-requests`] as const;
    }

    
export const getHrCaseRegistrationControllerGetMyRequestInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCaseRegistrationControllerGetMyRequestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>> = ({ signal }) => hrCaseRegistrationControllerGetMyRequest(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type HrCaseRegistrationControllerGetMyRequestInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>>
export type HrCaseRegistrationControllerGetMyRequestInfiniteQueryError = unknown

/**
 * @summary 내 대상자 등록 요청 상태 + 임시저장 목록
 */
export const useHrCaseRegistrationControllerGetMyRequestInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCaseRegistrationControllerGetMyRequestInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHrCaseRegistrationControllerGetMyRequestQueryOptions = <TData = Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCaseRegistrationControllerGetMyRequestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>> = ({ signal }) => hrCaseRegistrationControllerGetMyRequest(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type HrCaseRegistrationControllerGetMyRequestQueryResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>>
export type HrCaseRegistrationControllerGetMyRequestQueryError = unknown

/**
 * @summary 내 대상자 등록 요청 상태 + 임시저장 목록
 */
export const useHrCaseRegistrationControllerGetMyRequest = <TData = Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerGetMyRequest>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCaseRegistrationControllerGetMyRequestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 대상자 임시 등록
 */
export const hrCaseRegistrationControllerRegisterDraftCase = (
    registerDraftCaseRequestDtoModel: RegisterDraftCaseRequestDtoModel,
 ) => {
      
      
      return apiClient<HrCaseRegistrationControllerRegisterDraftCase201>(
      {url: `/v2/hr/me/case-info-requests/cases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerDraftCaseRequestDtoModel
    },
      );
    }
  


export const getHrCaseRegistrationControllerRegisterDraftCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>, TError,{data: RegisterDraftCaseRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>, TError,{data: RegisterDraftCaseRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>, {data: RegisterDraftCaseRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  hrCaseRegistrationControllerRegisterDraftCase(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HrCaseRegistrationControllerRegisterDraftCaseMutationResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>>
    export type HrCaseRegistrationControllerRegisterDraftCaseMutationBody = RegisterDraftCaseRequestDtoModel
    export type HrCaseRegistrationControllerRegisterDraftCaseMutationError = unknown

    /**
 * @summary 대상자 임시 등록
 */
export const useHrCaseRegistrationControllerRegisterDraftCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>, TError,{data: RegisterDraftCaseRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hrCaseRegistrationControllerRegisterDraftCase>>,
        TError,
        {data: RegisterDraftCaseRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getHrCaseRegistrationControllerRegisterDraftCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 대상자 리뷰어 등록(교체)
 */
export const hrCaseRegistrationControllerSetReviewers = (
    caseId: string,
    setCaseReviewersRequestDtoModel: SetCaseReviewersRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/hr/me/case-info-requests/cases/${caseId}/reviewers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setCaseReviewersRequestDtoModel
    },
      );
    }
  


export const getHrCaseRegistrationControllerSetReviewersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>, TError,{caseId: string;data: SetCaseReviewersRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>, TError,{caseId: string;data: SetCaseReviewersRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>, {caseId: string;data: SetCaseReviewersRequestDtoModel}> = (props) => {
          const {caseId,data} = props ?? {};

          return  hrCaseRegistrationControllerSetReviewers(caseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HrCaseRegistrationControllerSetReviewersMutationResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>>
    export type HrCaseRegistrationControllerSetReviewersMutationBody = SetCaseReviewersRequestDtoModel
    export type HrCaseRegistrationControllerSetReviewersMutationError = unknown

    /**
 * @summary 대상자 리뷰어 등록(교체)
 */
export const useHrCaseRegistrationControllerSetReviewers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>, TError,{caseId: string;data: SetCaseReviewersRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hrCaseRegistrationControllerSetReviewers>>,
        TError,
        {caseId: string;data: SetCaseReviewersRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getHrCaseRegistrationControllerSetReviewersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 리뷰어 자동완성(이름/이메일, 본인 회사 범위)
 */
export const hrCaseRegistrationControllerSearchReviewers = (
    params: HrCaseRegistrationControllerSearchReviewersParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<HrCaseRegistrationControllerSearchReviewers200>(
      {url: `/v2/hr/me/case-info-requests/reviewers/autocomplete`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHrCaseRegistrationControllerSearchReviewersQueryKey = (params: HrCaseRegistrationControllerSearchReviewersParams,) => {
    return [`/v2/hr/me/case-info-requests/reviewers/autocomplete`, ...(params ? [params]: [])] as const;
    }

    
export const getHrCaseRegistrationControllerSearchReviewersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, HrCaseRegistrationControllerSearchReviewersParams['page']>, TError = unknown>(params: HrCaseRegistrationControllerSearchReviewersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData, Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, QueryKey, HrCaseRegistrationControllerSearchReviewersParams['page']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCaseRegistrationControllerSearchReviewersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, QueryKey, HrCaseRegistrationControllerSearchReviewersParams['page']> = ({ signal, pageParam }) => hrCaseRegistrationControllerSearchReviewers({...params, page: pageParam || params?.['page']}, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData, Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, QueryKey, HrCaseRegistrationControllerSearchReviewersParams['page']> & { queryKey: QueryKey }
}

export type HrCaseRegistrationControllerSearchReviewersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>>
export type HrCaseRegistrationControllerSearchReviewersInfiniteQueryError = unknown

/**
 * @summary 리뷰어 자동완성(이름/이메일, 본인 회사 범위)
 */
export const useHrCaseRegistrationControllerSearchReviewersInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, HrCaseRegistrationControllerSearchReviewersParams['page']>, TError = unknown>(
 params: HrCaseRegistrationControllerSearchReviewersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData, Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, QueryKey, HrCaseRegistrationControllerSearchReviewersParams['page']>>, }

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCaseRegistrationControllerSearchReviewersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getHrCaseRegistrationControllerSearchReviewersQueryOptions = <TData = Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError = unknown>(params: HrCaseRegistrationControllerSearchReviewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHrCaseRegistrationControllerSearchReviewersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>> = ({ signal }) => hrCaseRegistrationControllerSearchReviewers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData> & { queryKey: QueryKey }
}

export type HrCaseRegistrationControllerSearchReviewersQueryResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>>
export type HrCaseRegistrationControllerSearchReviewersQueryError = unknown

/**
 * @summary 리뷰어 자동완성(이름/이메일, 본인 회사 범위)
 */
export const useHrCaseRegistrationControllerSearchReviewers = <TData = Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError = unknown>(
 params: HrCaseRegistrationControllerSearchReviewersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerSearchReviewers>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHrCaseRegistrationControllerSearchReviewersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary 임시 등록한 대상자 수정
 */
export const hrCaseRegistrationControllerUpdateDraftCase = (
    caseId: string,
    updateDraftCaseRequestDtoModel: UpdateDraftCaseRequestDtoModel,
 ) => {
      
      
      return apiClient<HrCaseRegistrationControllerUpdateDraftCase200>(
      {url: `/v2/hr/me/case-info-requests/cases/${caseId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDraftCaseRequestDtoModel
    },
      );
    }
  


export const getHrCaseRegistrationControllerUpdateDraftCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>, TError,{caseId: string;data: UpdateDraftCaseRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>, TError,{caseId: string;data: UpdateDraftCaseRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>, {caseId: string;data: UpdateDraftCaseRequestDtoModel}> = (props) => {
          const {caseId,data} = props ?? {};

          return  hrCaseRegistrationControllerUpdateDraftCase(caseId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HrCaseRegistrationControllerUpdateDraftCaseMutationResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>>
    export type HrCaseRegistrationControllerUpdateDraftCaseMutationBody = UpdateDraftCaseRequestDtoModel
    export type HrCaseRegistrationControllerUpdateDraftCaseMutationError = unknown

    /**
 * @summary 임시 등록한 대상자 수정
 */
export const useHrCaseRegistrationControllerUpdateDraftCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>, TError,{caseId: string;data: UpdateDraftCaseRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hrCaseRegistrationControllerUpdateDraftCase>>,
        TError,
        {caseId: string;data: UpdateDraftCaseRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getHrCaseRegistrationControllerUpdateDraftCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 임시 등록한 대상자 삭제
 */
export const hrCaseRegistrationControllerDeleteDraftCase = (
    caseId: string,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/hr/me/case-info-requests/cases/${caseId}`, method: 'DELETE'
    },
      );
    }
  


export const getHrCaseRegistrationControllerDeleteDraftCaseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>, TError,{caseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>, TError,{caseId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>, {caseId: string}> = (props) => {
          const {caseId} = props ?? {};

          return  hrCaseRegistrationControllerDeleteDraftCase(caseId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HrCaseRegistrationControllerDeleteDraftCaseMutationResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>>
    
    export type HrCaseRegistrationControllerDeleteDraftCaseMutationError = unknown

    /**
 * @summary 임시 등록한 대상자 삭제
 */
export const useHrCaseRegistrationControllerDeleteDraftCase = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>, TError,{caseId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hrCaseRegistrationControllerDeleteDraftCase>>,
        TError,
        {caseId: string},
        TContext
      > => {

      const mutationOptions = getHrCaseRegistrationControllerDeleteDraftCaseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 전체 완료(대상자 확정 제출)
 */
export const hrCaseRegistrationControllerComplete = (
    
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/hr/me/case-info-requests/completion`, method: 'POST'
    },
      );
    }
  


export const getHrCaseRegistrationControllerCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>, TError,void, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>, void> = () => {
          

          return  hrCaseRegistrationControllerComplete()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HrCaseRegistrationControllerCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>>
    
    export type HrCaseRegistrationControllerCompleteMutationError = unknown

    /**
 * @summary 전체 완료(대상자 확정 제출)
 */
export const useHrCaseRegistrationControllerComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>, TError,void, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hrCaseRegistrationControllerComplete>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getHrCaseRegistrationControllerCompleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 지원팀 문의 메일 발송 (비로그인)
 */
export const supportInquiryControllerCreate = (
    createSupportInquiryRequestDtoModel: CreateSupportInquiryRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/support-inquiries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSupportInquiryRequestDtoModel
    },
      );
    }
  


export const getSupportInquiryControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportInquiryControllerCreate>>, TError,{data: CreateSupportInquiryRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof supportInquiryControllerCreate>>, TError,{data: CreateSupportInquiryRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportInquiryControllerCreate>>, {data: CreateSupportInquiryRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  supportInquiryControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportInquiryControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof supportInquiryControllerCreate>>>
    export type SupportInquiryControllerCreateMutationBody = CreateSupportInquiryRequestDtoModel
    export type SupportInquiryControllerCreateMutationError = unknown

    /**
 * @summary 지원팀 문의 메일 발송 (비로그인)
 */
export const useSupportInquiryControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportInquiryControllerCreate>>, TError,{data: CreateSupportInquiryRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof supportInquiryControllerCreate>>,
        TError,
        {data: CreateSupportInquiryRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getSupportInquiryControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
/**
 * @summary 지원팀 문의 메일 발송 (HR 콘솔)
 */
export const mySupportInquiryControllerCreate = (
    createMySupportInquiryRequestDtoModel: CreateMySupportInquiryRequestDtoModel,
 ) => {
      
      
      return apiClient<void>(
      {url: `/v2/users/me/support-inquiries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMySupportInquiryRequestDtoModel
    },
      );
    }
  


export const getMySupportInquiryControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>, TError,{data: CreateMySupportInquiryRequestDtoModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>, TError,{data: CreateMySupportInquiryRequestDtoModel}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>, {data: CreateMySupportInquiryRequestDtoModel}> = (props) => {
          const {data} = props ?? {};

          return  mySupportInquiryControllerCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MySupportInquiryControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>>
    export type MySupportInquiryControllerCreateMutationBody = CreateMySupportInquiryRequestDtoModel
    export type MySupportInquiryControllerCreateMutationError = unknown

    /**
 * @summary 지원팀 문의 메일 발송 (HR 콘솔)
 */
export const useMySupportInquiryControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>, TError,{data: CreateMySupportInquiryRequestDtoModel}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof mySupportInquiryControllerCreate>>,
        TError,
        {data: CreateMySupportInquiryRequestDtoModel},
        TContext
      > => {

      const mutationOptions = getMySupportInquiryControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
